// // src/services/walletService.js 
// import { ethers } from 'ethers';

// // Wallet Types - Added Phantom
// export const WALLET_TYPES = {
//   METAMASK: 'metamask',
//   TRONLINK: 'tronlink',
//   TRUST_WALLET: 'trustwallet',
//   LUTE: 'lute',
//   PHANTOM: 'phantom' // New Phantom wallet for Solana
// };

// // Network Types - Added Solana
// export const NETWORK_TYPES = {
//   ETHEREUM: 'ethereum',
//   BSC: 'bsc',
//   TRON: 'tron',
//   ALGORAND: 'algorand',
//   SOLANA: 'solana' // New Solana network
// };

// // Network configuration - Added Solana
// export const NETWORK_CONFIG = {
//   [NETWORK_TYPES.ETHEREUM]: {
//     name: 'Ethereum Mainnet',
//     chainId: 1,
//     symbol: 'ETH',
//     decimals: 18,
//     rpcUrl: 'https://mainnet.infura.io/v3/your-infura-key',
//     blockExplorerUrl: 'https://etherscan.io'
//   },
//   [NETWORK_TYPES.BSC]: {
//     name: 'Binance Smart Chain',
//     chainId: 56,
//     symbol: 'BNB',
//     decimals: 18,
//     rpcUrl: 'https://bsc-dataseed.binance.org/',
//     blockExplorerUrl: 'https://bscscan.com'
//   },
//   [NETWORK_TYPES.TRON]: {
//     name: 'TRON Mainnet',
//     symbol: 'TRX',
//     decimals: 6,
//     rpcUrl: 'https://api.trongrid.io',
//     blockExplorerUrl: 'https://tronscan.org'
//   },
//   [NETWORK_TYPES.ALGORAND]: {
//     name: 'Algorand Mainnet',
//     symbol: 'ALGO',
//     decimals: 6,
//     rpcUrl: 'https://mainnet-api.algonode.cloud',
//     blockExplorerUrl: 'https://algoexplorer.io'
//   },
//   [NETWORK_TYPES.SOLANA]: {
//     name: 'Solana Mainnet',
//     symbol: 'SOL',
//     decimals: 9,
//     rpcUrl: 'https://api.mainnet-beta.solana.com',
//     blockExplorerUrl: 'https://explorer.solana.com'
//   }
// };

// // Token configurations with correct contract addresses and decimals - Added Solana tokens
// export const TOKEN_CONFIG = {
//   USDT: {
//     ethereum: {
//       contractAddress: '0xdAC17F958D2ee523a2206206994597C13D831ec7',
//       decimals: 6,
//       symbol: 'USDT'
//     },
//     bsc: {
//       contractAddress: '0x55d398326f99059fF775485246999027B3197955',
//       decimals: 18,
//       symbol: 'USDT'
//     },
//     tron: {
//       contractAddress: 'TR7NHqjeKQxGTCi8q8ZY4pL8otSzgjLj6t',
//       decimals: 6,
//       symbol: 'USDT'
//     },
//     algorand: {
//       assetId: 312769,
//       decimals: 6,
//       symbol: 'USDT'
//     },
//     solana: {
//       contractAddress: 'Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB', // USDT on Solana
//       decimals: 6,
//       symbol: 'USDT'
//     }
//   },
//   USDC: {
//     ethereum: {
//       contractAddress: '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
//       decimals: 6,
//       symbol: 'USDC'
//     },
//     bsc: {
//       contractAddress: '0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d',
//       decimals: 18,
//       symbol: 'USDC'
//     },
//     tron: {
//       contractAddress: 'TEkxiTehnzSmSe2XqrBj4w32RUN966rdz8',
//       decimals: 6,
//       symbol: 'USDC'
//     },
//     algorand: {
//       assetId: 31566704,
//       decimals: 6,
//       symbol: 'USDC'
//     },
//     solana: {
//       contractAddress: 'EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v', // USDC on Solana
//       decimals: 6,
//       symbol: 'USDC'
//     }
//   },
//   BNB: {
//     bsc: {
//       decimals: 18,
//       symbol: 'BNB',
//       isNative: true
//     }
//   },
//   ETH: {
//     ethereum: {
//       decimals: 18,
//       symbol: 'ETH',
//       isNative: true
//     }
//   },
//   TRX: {
//     tron: {
//       decimals: 6,
//       symbol: 'TRX',
//       isNative: true
//     }
//   },
//   ALGO: {
//     algorand: {
//       decimals: 6,
//       symbol: 'ALGO',
//       isNative: true
//     }
//   },
//   SOL: {
//     solana: {
//       decimals: 9,
//       symbol: 'SOL',
//       isNative: true
//     }
//   }
// };

// // Network to wallet mapping - Added Solana/Phantom
// export const NETWORK_WALLET_MAP = {
//   [NETWORK_TYPES.ETHEREUM]: [WALLET_TYPES.METAMASK, WALLET_TYPES.TRUST_WALLET],
//   [NETWORK_TYPES.BSC]: [WALLET_TYPES.METAMASK, WALLET_TYPES.TRUST_WALLET],
//   [NETWORK_TYPES.TRON]: [WALLET_TYPES.TRONLINK],
//   [NETWORK_TYPES.ALGORAND]: [WALLET_TYPES.LUTE],
//   [NETWORK_TYPES.SOLANA]: [WALLET_TYPES.PHANTOM] // Phantom for Solana
// };

// // Installation URLs for wallets - Added Phantom
// export const getWalletInstallUrl = (walletType) => {
//   const urls = {
//     [WALLET_TYPES.METAMASK]: 'https://metamask.io/download/',
//     [WALLET_TYPES.TRONLINK]: 'https://www.tronlink.org/download/',
//     [WALLET_TYPES.TRUST_WALLET]: 'https://trustwallet.com/download/',
//     [WALLET_TYPES.LUTE]: 'https://lute.app/download/',
//     [WALLET_TYPES.PHANTOM]: 'https://phantom.app/download'
//   };
//   return urls[walletType] || '';
// };

// // Enhanced Lute wallet detection
// const detectLuteWallet = () => {
//   if (typeof window === 'undefined') return false;
  
//   // Multiple ways to detect Lute wallet
//   const luteDetectionMethods = [
//     // Check for window.lute
//     () => window.lute !== undefined,
//     // Check for window.algorand (some Algorand wallets use this)
//     () => window.algorand !== undefined,
//     // Check for AlgoSigner (alternative Algorand wallet)
//     () => window.AlgoSigner !== undefined,
//     // Check for specific Lute wallet identifiers
//     () => window.luteWallet !== undefined,
//     // Check for wallet extension in DOM
//     () => document.querySelector('[data-wallet="lute"]') !== null,
//     // Check if Lute is injected via content script
//     () => window.postMessage && document.documentElement.getAttribute('data-lute-extension') === 'true'
//   ];
  
//   return luteDetectionMethods.some(method => {
//     try {
//       return method();
//     } catch (error) {
//       console.warn('Lute detection method failed:', error);
//       return false;
//     }
//   });
// };

// // Enhanced Phantom wallet detection
// const detectPhantomWallet = () => {
//   if (typeof window === 'undefined') return false;
  
//   // Multiple ways to detect Phantom wallet
//   const phantomDetectionMethods = [
//     // Check for window.solana with isPhantom
//     () => window.solana && window.solana.isPhantom,
//     // Check for window.phantom
//     () => window.phantom && window.phantom.solana,
//     // Check for specific Phantom wallet identifiers
//     () => window.phantomWallet !== undefined,
//     // Check for wallet extension in DOM
//     () => document.querySelector('[data-wallet="phantom"]') !== null
//   ];
  
//   return phantomDetectionMethods.some(method => {
//     try {
//       return method();
//     } catch (error) {
//       console.warn('Phantom detection method failed:', error);
//       return false;
//     }
//   });
// };

// // Detect available wallets in the browser - Added Phantom
// export const detectWallets = () => {
//   const availableWallets = {
//     [WALLET_TYPES.METAMASK]: typeof window !== 'undefined' && window.ethereum !== undefined && window.ethereum.isMetaMask,
//     [WALLET_TYPES.TRONLINK]: typeof window !== 'undefined' && window.tronWeb !== undefined,
//     [WALLET_TYPES.TRUST_WALLET]: typeof window !== 'undefined' && 
//       window.ethereum !== undefined && 
//       window.ethereum.isTrust === true,
//     [WALLET_TYPES.LUTE]: detectLuteWallet(),
//     [WALLET_TYPES.PHANTOM]: detectPhantomWallet()
//   };
  
//   // Enhanced logging for wallet detection
//   if (typeof window !== 'undefined') {
//     console.log('=== WALLET DETECTION DEBUG ===');
//     console.log('MetaMask:', availableWallets[WALLET_TYPES.METAMASK]);
//     console.log('TronLink:', availableWallets[WALLET_TYPES.TRONLINK]);
//     console.log('Trust Wallet:', availableWallets[WALLET_TYPES.TRUST_WALLET]);
//     console.log('Lute:', availableWallets[WALLET_TYPES.LUTE]);
//     console.log('Phantom:', availableWallets[WALLET_TYPES.PHANTOM]);
//     console.log('window.solana:', Boolean(window.solana));
//     console.log('window.phantom:', Boolean(window.phantom));
//     console.log('=== END WALLET DETECTION DEBUG ===');
//   }
  
//   return availableWallets;
// };

// // Detect wallets with retry and enhanced detection
// export const detectWalletsWithRetry = async (maxRetries = 5, delay = 1000) => {
//   let retries = 0;
//   let wallets = detectWallets();
  
//   // Special handling for wallet injection - give it more time
//   while (retries < maxRetries) {
//     wallets = detectWallets();
    
//     // Check if we found any wallets or if we've reached max retries
//     const hasAnyWallet = Object.values(wallets).some(v => v === true);
    
//     if (hasAnyWallet || retries >= maxRetries - 1) {
//       break;
//     }
    
//     console.log(`Wallet detection attempt ${retries + 1}/${maxRetries}...`);
//     console.log('Current detection results:', wallets);
    
//     // Wait before next attempt
//     await new Promise(resolve => setTimeout(resolve, delay));
//     retries++;
//   }
  
//   // Final check with extended detection
//   if (!wallets[WALLET_TYPES.LUTE] || !wallets[WALLET_TYPES.PHANTOM]) {
//     console.log('Performing extended wallet detection...');
    
//     if (typeof window !== 'undefined') {
//       try {
//         // Dispatch custom events that might trigger wallet injection
//         const luteEvent = new CustomEvent('lute-wallet-detect', { detail: { source: 'coinley-sdk' } });
//         const phantomEvent = new CustomEvent('phantom-wallet-detect', { detail: { source: 'coinley-sdk' } });
//         window.dispatchEvent(luteEvent);
//         window.dispatchEvent(phantomEvent);
        
//         // Wait a bit more for potential injection
//         await new Promise(resolve => setTimeout(resolve, 500));
        
//         // Re-detect
//         wallets[WALLET_TYPES.LUTE] = detectLuteWallet();
//         wallets[WALLET_TYPES.PHANTOM] = detectPhantomWallet();
//       } catch (error) {
//         console.warn('Extended wallet detection failed:', error);
//       }
//     }
//   }
  
//   console.log('Final wallet detection results:', wallets);
//   return wallets;
// };

// // Debug wallet environment - Added Phantom
// export const debugWalletEnvironment = () => {
//   console.log('=== WALLET ENVIRONMENT DEBUG ===');
//   console.log('ethereum:', typeof window !== 'undefined' ? Boolean(window.ethereum) : 'Not in browser');
//   console.log('tronWeb:', typeof window !== 'undefined' ? Boolean(window.tronWeb) : 'Not in browser');
//   console.log('lute:', typeof window !== 'undefined' ? Boolean(window.lute) : 'Not in browser');
//   console.log('algorand:', typeof window !== 'undefined' ? Boolean(window.algorand) : 'Not in browser');
//   console.log('AlgoSigner:', typeof window !== 'undefined' ? Boolean(window.AlgoSigner) : 'Not in browser');
//   console.log('solana:', typeof window !== 'undefined' ? Boolean(window.solana) : 'Not in browser');
//   console.log('phantom:', typeof window !== 'undefined' ? Boolean(window.phantom) : 'Not in browser');
  
//   if (typeof window !== 'undefined' && window.ethereum) {
//     console.log('ethereum details:', {
//       isTrust: window.ethereum.isTrust,
//       isMetaMask: window.ethereum.isMetaMask,
//       chainId: window.ethereum.chainId
//     });
//   }
  
//   if (typeof window !== 'undefined' && window.tronWeb) {
//     console.log('tronWeb details:', {
//       ready: window.tronWeb.ready,
//       fullNode: window.tronWeb.fullNode?.host,
//       defaultAddress: window.tronWeb.defaultAddress
//     });
//   }
  
//   if (typeof window !== 'undefined' && window.solana) {
//     console.log('solana details:', {
//       isPhantom: window.solana.isPhantom,
//       publicKey: window.solana.publicKey?.toString(),
//       isConnected: window.solana.isConnected
//     });
//   }
  
//   if (typeof window !== 'undefined') {
//     console.log('All window wallet properties:');
//     const walletProps = Object.keys(window).filter(key => 
//       key.toLowerCase().includes('lute') || 
//       key.toLowerCase().includes('algo') || 
//       key.toLowerCase().includes('wallet') ||
//       key.toLowerCase().includes('phantom') ||
//       key.toLowerCase().includes('solana')
//     );
//     console.log('Potential wallet properties:', walletProps);
//   }
  
//   const wallets = detectWallets();
//   console.log('Detected wallets:', wallets);
//   console.log('=== END WALLET ENVIRONMENT DEBUG ===');
// };

// // Connect to MetaMask wallet
// const connectMetamaskWallet = async () => {
//   console.log('Connecting to MetaMask wallet...');
  
//   if (!window.ethereum || !window.ethereum.isMetaMask) {
//     console.error('MetaMask not found.');
//     throw new Error('MetaMask not detected. Please install MetaMask extension.');
//   }
  
//   try {
//     // Use the direct window.ethereum.request method for compatibility
//     const accounts = await window.ethereum.request({ method: 'eth_requestAccounts' });
    
//     if (!accounts || accounts.length === 0) {
//       throw new Error('No accounts found');
//     }
    
//     const address = accounts[0];
//     const chainIdHex = await window.ethereum.request({ method: 'eth_chainId' });
//     const chainId = parseInt(chainIdHex, 16);
    
//     let networkType;
//     switch (chainId) {
//       case 1: networkType = NETWORK_TYPES.ETHEREUM; break;
//       case 56: networkType = NETWORK_TYPES.BSC; break;
//       default: networkType = `unknown-${chainId}`;
//     }
    
//     // Create a proper ethers-compatible provider
//     const web3Provider = new ethers.BrowserProvider(window.ethereum);
    
//     return {
//       walletType: WALLET_TYPES.METAMASK,
//       address,
//       provider: web3Provider,
//       network: networkType,
//       isConnected: true,
//       chainId
//     };
//   } catch (error) {
//     console.error('Error connecting to MetaMask:', error);
//     throw error;
//   }
// };

// // Connect to Trust Wallet
// const connectTrustWallet = async () => {
//   console.log('Connecting to Trust Wallet...');
  
//   if (!window.ethereum || !window.ethereum.isTrust) {
//     console.error('Trust Wallet not found.');
//     throw new Error('Trust Wallet not detected. Please install Trust Wallet.');
//   }
  
//   try {
//     const accounts = await window.ethereum.request({ method: 'eth_requestAccounts' });
    
//     if (!accounts || accounts.length === 0) {
//       throw new Error('No accounts found');
//     }
    
//     const address = accounts[0];
//     const chainIdHex = await window.ethereum.request({ method: 'eth_chainId' });
//     const chainId = parseInt(chainIdHex, 16);
    
//     let networkType;
//     switch (chainId) {
//       case 1: networkType = NETWORK_TYPES.ETHEREUM; break;
//       case 56: networkType = NETWORK_TYPES.BSC; break;
//       default: networkType = `unknown-${chainId}`;
//     }
    
//     // Create a proper ethers-compatible provider
//     const web3Provider = new ethers.BrowserProvider(window.ethereum);
    
//     return {
//       walletType: WALLET_TYPES.TRUST_WALLET,
//       address,
//       provider: web3Provider,
//       network: networkType,
//       isConnected: true,
//       chainId
//     };
//   } catch (error) {
//     console.error('Error connecting to Trust Wallet:', error);
//     throw error;
//   }
// };

// // Connect to TronLink wallet
// const connectTronlinkWallet = async () => {
//   console.log('Connecting to TronLink wallet...');
  
//   if (!window.tronWeb) {
//     console.error('TronWeb not found. Is TronLink installed?');
//     throw new Error('TronLink not detected. Please install TronLink extension.');
//   }
  
//   const waitForTronWeb = async (maxAttempts = 10, interval = 500) => {
//     for (let attempt = 0; attempt < maxAttempts; attempt++) {
//       if (window.tronWeb && window.tronWeb.ready) {
//         return window.tronWeb;
//       }
//       console.log(`Waiting for TronWeb to be ready... Attempt ${attempt + 1}/${maxAttempts}`);
//       await new Promise(resolve => setTimeout(resolve, interval));
//     }
//     throw new Error('TronWeb took too long to be ready');
//   };
  
//   try {
//     const tronWeb = await waitForTronWeb();
    
//     if (!tronWeb.defaultAddress || !tronWeb.defaultAddress.base58) {
//       try {
//         await window.tronWeb.request({ method: 'tron_requestAccounts' });
//       } catch (permissionError) {
//         console.error('Failed to get permission from TronLink:', permissionError);
//         throw new Error('Please unlock TronLink and approve connection');
//       }
//     }
    
//     const address = tronWeb.defaultAddress.base58;
//     console.log('Connected to TronLink wallet:', address);
    
//     return {
//       walletType: WALLET_TYPES.TRONLINK,
//       address: address,
//       provider: tronWeb,
//       network: NETWORK_TYPES.TRON,
//       isConnected: true
//     };
//   } catch (error) {
//     console.error('Error connecting to TronLink:', error);
//     throw error;
//   }
// };

// // Enhanced Lute wallet connection with multiple detection methods
// const connectLuteWallet = async () => {
//   console.log('Connecting to Lute wallet...');
  
//   // Try multiple wallet detection methods
//   let walletProvider = null;
//   let walletName = '';
  
//   // Method 1: Direct Lute wallet
//   if (window.lute) {
//     walletProvider = window.lute;
//     walletName = 'Lute';
//   }
//   // Method 2: Generic Algorand provider
//   else if (window.algorand) {
//     walletProvider = window.algorand;
//     walletName = 'Algorand Provider';
//   }
//   // Method 3: AlgoSigner (alternative Algorand wallet)
//   else if (window.AlgoSigner) {
//     walletProvider = window.AlgoSigner;
//     walletName = 'AlgoSigner';
//   }
//   // Method 4: Check for luteWallet
//   else if (window.luteWallet) {
//     walletProvider = window.luteWallet;
//     walletName = 'Lute Wallet';
//   }
  
//   if (!walletProvider) {
//     console.error('No Algorand wallet detected.');
//     console.log('Available window properties:', Object.keys(window).filter(key => 
//       key.toLowerCase().includes('lute') || 
//       key.toLowerCase().includes('algo') || 
//       key.toLowerCase().includes('wallet')
//     ));
//     throw new Error('Lute wallet not detected. Please install Lute extension or another Algorand wallet.');
//   }
  
//   console.log(`Found ${walletName} wallet provider:`, walletProvider);
  
//   try {
//     let address = null;
    
//     // Try different connection methods based on the wallet type
//     if (walletProvider.connect) {
//       console.log('Using connect() method...');
//       const result = await walletProvider.connect();
//       address = result.address || result;
//     }
//     else if (walletProvider.enable) {
//       console.log('Using enable() method...');
//       const accounts = await walletProvider.enable();
//       address = accounts[0] || accounts;
//     }
//     else if (walletProvider.requestAccounts) {
//       console.log('Using requestAccounts() method...');
//       const accounts = await walletProvider.requestAccounts();
//       address = accounts[0];
//     }
//     // For AlgoSigner
//     else if (walletProvider.connect && walletName === 'AlgoSigner') {
//       console.log('Using AlgoSigner connect...');
//       await walletProvider.connect();
//       const accounts = await walletProvider.accounts({ ledger: 'MainNet' });
//       address = accounts[0]?.address;
//     }
    
//     if (!address) {
//       throw new Error(`No address returned from ${walletName}. Please unlock your wallet and try again.`);
//     }
    
//     console.log(`Connected to ${walletName} wallet:`, address);
    
//     return {
//       walletType: WALLET_TYPES.LUTE,
//       address: address,
//       provider: walletProvider,
//       network: NETWORK_TYPES.ALGORAND,
//       isConnected: true,
//       walletName: walletName
//     };
//   } catch (error) {
//     console.error(`Error connecting to ${walletName}:`, error);
    
//     if (error.message && error.message.includes('User rejected')) {
//       throw new Error('Connection rejected by user. Please approve the connection in your wallet.');
//     } else if (error.message && error.message.includes('locked')) {
//       throw new Error('Wallet is locked. Please unlock your wallet and try again.');
//     } else {
//       throw new Error(`Failed to connect to ${walletName}: ${error.message || 'Unknown error'}`);
//     }
//   }
// };

// // NEW: Connect to Phantom wallet
// const connectPhantomWallet = async () => {
//   console.log('Connecting to Phantom wallet...');
  
//   // Try multiple detection methods
//   let phantomProvider = null;
  
//   if (window.solana && window.solana.isPhantom) {
//     phantomProvider = window.solana;
//   } else if (window.phantom && window.phantom.solana) {
//     phantomProvider = window.phantom.solana;
//   }
  
//   if (!phantomProvider) {
//     console.error('Phantom wallet not found.');
//     console.log('Available Solana providers:', {
//       'window.solana': Boolean(window.solana),
//       'window.phantom': Boolean(window.phantom),
//       'window.solana.isPhantom': window.solana?.isPhantom
//     });
//     throw new Error('Phantom wallet not detected. Please install Phantom extension.');
//   }
  
//   console.log('Found Phantom wallet provider:', phantomProvider);
  
//   try {
//     // Connect to Phantom
//     const response = await phantomProvider.connect();
    
//     if (!response || !response.publicKey) {
//       throw new Error('No public key returned from Phantom');
//     }
    
//     const address = response.publicKey.toString();
//     console.log('Connected to Phantom wallet:', address);
    
//     return {
//       walletType: WALLET_TYPES.PHANTOM,
//       address: address,
//       provider: phantomProvider,
//       network: NETWORK_TYPES.SOLANA,
//       isConnected: true,
//       publicKey: response.publicKey
//     };
//   } catch (error) {
//     console.error('Error connecting to Phantom:', error);
    
//     if (error.code === 4001) {
//       throw new Error('Connection rejected by user. Please approve the connection in Phantom.');
//     } else if (error.message && error.message.includes('User rejected')) {
//       throw new Error('Connection rejected by user. Please approve the connection in Phantom.');
//     } else {
//       throw new Error(`Failed to connect to Phantom: ${error.message || 'Unknown error'}`);
//     }
//   }
// };

// // General wallet connection function - Added Phantom
// export const connectWallet = async (walletType) => {
//   console.log('Connecting to wallet:', walletType);
  
//   switch (walletType) {
//     case WALLET_TYPES.METAMASK:
//       return connectMetamaskWallet();
//     case WALLET_TYPES.TRONLINK:
//       return connectTronlinkWallet();
//     case WALLET_TYPES.TRUST_WALLET:
//       return connectTrustWallet();
//     case WALLET_TYPES.LUTE:
//       return connectLuteWallet();
//     case WALLET_TYPES.PHANTOM:
//       return connectPhantomWallet();
//     default:
//       throw new Error(`Unsupported wallet type: ${walletType}`);
//   }
// };

// // Get supported wallets for a network
// export const getSupportedWalletsForNetwork = (network) => {
//   return NETWORK_WALLET_MAP[network] || [];
// };

// // Send native currency transaction
// export const sendNativeTransaction = async (walletConnection, toAddress, amount) => {
//   console.log('Sending native transaction:', { toAddress, amount });
  
//   if (!walletConnection || !walletConnection.provider) {
//     throw new Error('Wallet not connected');
//   }
  
//   if (!toAddress) {
//     throw new Error('Recipient address not provided');
//   }
  
//   if (!amount || isNaN(parseFloat(amount)) || parseFloat(amount) <= 0) {
//     throw new Error('Invalid amount');
//   }
  
//   try {
//     let transaction;
    
//     switch (walletConnection.walletType) {
//       case WALLET_TYPES.METAMASK:
//       case WALLET_TYPES.TRUST_WALLET:
//         const provider = walletConnection.provider;
//         const signer = await provider.getSigner();
        
//         const amountInEther = amount.toString();
//         const amountWei = ethers.parseEther(amountInEther);
        
//         console.log('Sending ETH/BNB:', {
//           to: toAddress,
//           value: amountWei.toString()
//         });
        
//         // Estimate gas using the provider directly
//         const gasEstimate = await provider.estimateGas({
//           to: toAddress,
//           value: amountWei,
//           from: await signer.getAddress()
//         });
        
//         console.log('Gas estimate:', gasEstimate.toString());
        
//         // Add 10% buffer to gas estimate
//         const gasLimit = (gasEstimate * BigInt(110)) / BigInt(100);
        
//         console.log('Using gas limit:', gasLimit.toString());
        
//         // Send transaction
//         transaction = await signer.sendTransaction({
//           to: toAddress,
//           value: amountWei,
//           gasLimit: gasLimit
//         });
//         break;
        
//       case WALLET_TYPES.TRONLINK:
//         const tronWeb = walletConnection.provider;
        
//         if (!tronWeb || !tronWeb.ready) {
//           throw new Error('TronWeb not initialized');
//         }
        
//         const amountSun = tronWeb.toSun(amount.toString());
        
//         console.log('Sending TRX:', {
//           to: toAddress,
//           value: amountSun
//         });
        
//         transaction = await tronWeb.trx.sendTransaction(
//           toAddress,
//           amountSun
//         );
//         break;
        
//       case WALLET_TYPES.LUTE:
//         const algorandProvider = walletConnection.provider;
        
//         const microAlgos = Math.floor(parseFloat(amount) * 1000000);
        
//         console.log('Sending Algos:', {
//           to: toAddress,
//           amount: microAlgos,
//           walletName: walletConnection.walletName
//         });
        
//         // Handle different Algorand wallet APIs
//         if (algorandProvider.sendPayment) {
//           transaction = await algorandProvider.sendPayment({
//             recipient: toAddress,
//             amount: microAlgos
//           });
//         } else if (algorandProvider.signTransaction) {
//           // For AlgoSigner or other wallets that require manual transaction building
//           const txn = {
//             to: toAddress,
//             fee: 1000,
//             amount: microAlgos,
//             firstRound: 1000,
//             lastRound: 2000,
//             type: 'pay'
//           };
//           transaction = await algorandProvider.signTransaction(txn);
//         } else {
//           throw new Error(`Unsupported Algorand wallet API for ${walletConnection.walletName}`);
//         }
//         break;
        
//       case WALLET_TYPES.PHANTOM:
//         const phantomProvider = walletConnection.provider;
        
//         if (!phantomProvider || !phantomProvider.isConnected) {
//           throw new Error('Phantom wallet not connected');
//         }
        
//         // Create a Solana web3 connection
//         const { Connection, PublicKey, Transaction, SystemProgram, LAMPORTS_PER_SOL } = await import('@solana/web3.js');
        
//         const connection = new Connection(NETWORK_CONFIG[NETWORK_TYPES.SOLANA].rpcUrl);
//         const fromPubkey = walletConnection.publicKey;
//         const toPubkey = new PublicKey(toAddress);
        
//         const lamports = Math.floor(parseFloat(amount) * LAMPORTS_PER_SOL);
        
//         console.log('Sending SOL:', {
//           from: fromPubkey.toString(),
//           to: toAddress,
//           lamports: lamports
//         });
        
//         // Create transaction
//         const transferTransaction = new Transaction().add(
//           SystemProgram.transfer({
//             fromPubkey,
//             toPubkey,
//             lamports
//           })
//         );
        
//         // Get recent blockhash
//         const { blockhash } = await connection.getLatestBlockhash();
//         transferTransaction.recentBlockhash = blockhash;
//         transferTransaction.feePayer = fromPubkey;
        
//         // Sign and send transaction
//         const signedTransaction = await phantomProvider.signAndSendTransaction(transferTransaction);
//         transaction = signedTransaction;
//         break;
        
//       default:
//         throw new Error(`Unsupported wallet type: ${walletConnection.walletType}`);
//     }
    
//     console.log('Transaction sent:', transaction);
    
//     const hash = transaction.hash || transaction.signature || transaction.txID || transaction.txId || transaction;
//     console.log('Transaction hash:', hash);
//     return hash;
//   } catch (error) {
//     console.error('Native transaction error:', error);
//     throw error;
//   }
// };

// // Send transaction - main function
// export const sendTransaction = async (walletConnection, transactionDetails) => {
//   console.log('Sending transaction with:', transactionDetails);
  
//   if (!walletConnection) {
//     throw new Error('Wallet not connected');
//   }
  
//   const { to, amount, tokenAddress, currency, network } = transactionDetails;
  
//   if (!to) {
//     throw new Error('Recipient address not provided');
//   }
  
//   // Check if this is a native currency or token transfer
//   const tokenConfig = TOKEN_CONFIG[currency]?.[network];
  
//   if (tokenConfig && tokenConfig.isNative) {
//     return sendNativeTransaction(walletConnection, to, amount);
//   } else if (tokenConfig) {
//     return sendTokenTransaction(walletConnection, tokenConfig, to, amount);
//   } else {
//     // Fallback to native transaction
//     return sendNativeTransaction(walletConnection, to, amount);
//   }
// };

// // Send token transaction
// export const sendTokenTransaction = async (walletConnection, tokenConfig, toAddress, amount) => {
//   console.log('Sending token transaction with:', { tokenConfig, toAddress, amount });
  
//   if (!walletConnection || !walletConnection.provider) {
//     throw new Error('Wallet not connected');
//   }
  
//   if (!tokenConfig) {
//     throw new Error('Token configuration not provided');
//   }
  
//   if (!toAddress) {
//     throw new Error('Recipient address not provided');
//   }

//   if (!amount || isNaN(parseFloat(amount)) || parseFloat(amount) <= 0) {
//     throw new Error('Invalid amount');
//   }

//   const { contractAddress, decimals, symbol } = tokenConfig;
//   console.log(`Token: ${symbol}, Decimals: ${decimals}, Contract: ${contractAddress}`);
  
//   switch (walletConnection.walletType) {
//     case WALLET_TYPES.TRONLINK:
//       return sendTRC20Transaction(walletConnection, tokenConfig, toAddress, amount);
//     case WALLET_TYPES.LUTE:
//       return sendAlgorandAssetTransaction(walletConnection, tokenConfig, toAddress, amount);
//     case WALLET_TYPES.PHANTOM:
//       return sendSolanaTokenTransaction(walletConnection, tokenConfig, toAddress, amount);
//     default:
//       return sendERC20Transaction(walletConnection, tokenConfig, toAddress, amount);
//   }
// };

// // NEW: Solana token transaction function
// export const sendSolanaTokenTransaction = async (walletConnection, tokenConfig, toAddress, amount) => {
//   console.log('Sending Solana token transaction with:', { tokenConfig, toAddress, amount });
  
//   if (!walletConnection || !walletConnection.provider) {
//     throw new Error('Phantom wallet not connected');
//   }
  
//   const phantomProvider = walletConnection.provider;
  
//   if (!phantomProvider || !phantomProvider.isConnected) {
//     throw new Error('Phantom wallet not connected');
//   }
  
//   if (!tokenConfig || !tokenConfig.contractAddress) {
//     throw new Error('Invalid token configuration');
//   }
  
//   const { contractAddress, decimals, symbol } = tokenConfig;
  
//   const tokenAmount = parseFloat(amount);
//   const tokenDecimals = parseInt(decimals);
  
//   const amountInSmallestUnit = Math.floor(tokenAmount * Math.pow(10, tokenDecimals));
  
//   console.log(`Sending ${tokenAmount} ${symbol} (${amountInSmallestUnit} base units) to ${toAddress}`);
  
//   try {
//     // Import Solana web3 and SPL token libraries
//     const { Connection, PublicKey, Transaction } = await import('@solana/web3.js');
//     const { createTransferInstruction, getAssociatedTokenAddress, TOKEN_PROGRAM_ID, ASSOCIATED_TOKEN_PROGRAM_ID } = await import('@solana/spl-token');
    
//     const connection = new Connection(NETWORK_CONFIG[NETWORK_TYPES.SOLANA].rpcUrl);
//     const fromPubkey = walletConnection.publicKey;
//     const toPubkey = new PublicKey(toAddress);
//     const mintPubkey = new PublicKey(contractAddress);
    
//     // Get associated token accounts
//     const fromTokenAccount = await getAssociatedTokenAddress(
//       mintPubkey,
//       fromPubkey,
//       false,
//       TOKEN_PROGRAM_ID,
//       ASSOCIATED_TOKEN_PROGRAM_ID
//     );
    
//     const toTokenAccount = await getAssociatedTokenAddress(
//       mintPubkey,
//       toPubkey,
//       false,
//       TOKEN_PROGRAM_ID,
//       ASSOCIATED_TOKEN_PROGRAM_ID
//     );
    
//     // Create transfer instruction
//     const transferInstruction = createTransferInstruction(
//       fromTokenAccount,
//       toTokenAccount,
//       fromPubkey,
//       amountInSmallestUnit,
//       [],
//       TOKEN_PROGRAM_ID
//     );
    
//     // Create transaction
//     const transaction = new Transaction().add(transferInstruction);
    
//     // Get recent blockhash
//     const { blockhash } = await connection.getLatestBlockhash();
//     transaction.recentBlockhash = blockhash;
//     transaction.feePayer = fromPubkey;
    
//     // Sign and send transaction
//     const signedTransaction = await phantomProvider.signAndSendTransaction(transaction);
    
//     console.log('Solana token transaction sent:', signedTransaction);
//     return signedTransaction.signature || signedTransaction;
//   } catch (error) {
//     console.error('Solana token transaction error:', error);
    
//     if (error.message && error.message.includes('User rejected')) {
//       throw new Error('Transaction rejected by user');
//     } else if (error.message && error.message.includes('Insufficient')) {
//       throw new Error('Insufficient token balance');
//     } else {
//       throw error;
//     }
//   }
// };

// // ERC20/BEP20 token transaction function
// export const sendERC20Transaction = async (walletConnection, tokenConfig, toAddress, amount) => {
//   console.log('Sending ERC20/BEP20 transaction with:', { tokenConfig, toAddress, amount });
  
//   if (!walletConnection || !walletConnection.provider) {
//     throw new Error('Wallet not connected');
//   }
  
//   const provider = walletConnection.provider;
//   const signer = await provider.getSigner();
  
//   const { contractAddress, decimals, symbol } = tokenConfig;
  
//   const tokenAmount = parseFloat(amount);
//   const tokenDecimals = parseInt(decimals);
  
//   // Use ethers v6 parseUnits directly
//   const tokenUnits = ethers.parseUnits(tokenAmount.toString(), tokenDecimals);
  
//   console.log(`Sending ${tokenAmount} ${symbol} (${tokenUnits.toString()} base units) to ${toAddress}`);
//   console.log(`Token config:`, { contractAddress, decimals, symbol });
  
//   try {
//     // Create contract instance with proper signer
//     const tokenContract = new ethers.Contract(
//       contractAddress,
//       [
//         'function transfer(address to, uint256 amount) returns (bool)',
//         'function balanceOf(address owner) view returns (uint256)',
//         'function decimals() view returns (uint8)'
//       ],
//       signer
//     );
    
//     // Check token balance first
//     const userAddress = await signer.getAddress();
//     const balance = await tokenContract.balanceOf(userAddress);
//     console.log(`User ${symbol} balance:`, ethers.formatUnits(balance, decimals));
    
//     if (balance < tokenUnits) {
//       throw new Error(`Insufficient ${symbol} balance. Required: ${tokenAmount}, Available: ${ethers.formatUnits(balance, decimals)}`);
//     }
    
//     try {
//       // Estimate gas for the transfer with higher gas limit for USDC
//       const gasEstimate = await tokenContract.transfer.estimateGas(toAddress, tokenUnits);
//       console.log('Gas estimate:', gasEstimate.toString());
      
//       // USDC requires significantly more gas due to additional checks
//       let gasMultiplier;
//       if (symbol === 'USDC') {
//         gasMultiplier = BigInt(150); // 50% buffer for USDC
//       } else if (symbol === 'USDT') {
//         gasMultiplier = BigInt(130); // 30% buffer for USDT
//       } else {
//         gasMultiplier = BigInt(120); // 20% buffer for others
//       }
      
//       const gasLimit = (gasEstimate * gasMultiplier) / BigInt(100);
        
//       console.log('Using gas limit:', gasLimit.toString());
      
//       // Send with explicit gas limit
//       const transaction = await tokenContract.transfer(toAddress, tokenUnits, {
//         gasLimit: gasLimit
//       });
      
//       console.log('Transaction sent:', transaction);
//       return transaction.hash;
//     } catch (gasError) {
//       console.error('Gas estimation failed:', gasError);
      
//       // For USDC/USDT, try with higher fixed gas limits
//       let fixedGasLimit;
//       if (symbol === 'USDC') {
//         fixedGasLimit = BigInt(200000); // Higher for USDC
//       } else if (symbol === 'USDT') {
//         fixedGasLimit = BigInt(180000); // Higher for USDT
//       } else {
//         fixedGasLimit = BigInt(150000);
//       }
      
//       console.log(`Trying ${symbol} transaction with fixed gas limit:`, fixedGasLimit.toString());
      
//       const transaction = await tokenContract.transfer(toAddress, tokenUnits, {
//         gasLimit: fixedGasLimit
//       });
      
//       console.log('Transaction sent with fixed gas limit:', transaction);
//       return transaction.hash;
//     }
//   } catch (error) {
//     console.error('ERC20 transaction error:', error);
    
//     // Improve error messages
//     if (error.message && error.message.includes('user rejected')) {
//       throw new Error('Transaction rejected by user');
//     } else if (error.message && error.message.includes('insufficient funds')) {
//       throw new Error('Insufficient funds for transaction');
//     } else if (error.message && error.message.includes('Insufficient')) {
//       throw error; // Already formatted
//     } else {
//       throw error;
//     }
//   }
// };

// // TRC20 token transaction function
// export const sendTRC20Transaction = async (walletConnection, tokenConfig, toAddress, amount) => {
//   console.log('Sending TRC20 transaction with:', { tokenConfig, toAddress, amount });
  
//   if (!walletConnection || !walletConnection.provider) {
//     throw new Error('Tron wallet not connected');
//   }
  
//   const tronWeb = walletConnection.provider;
//   if (!tronWeb || !tronWeb.ready) {
//     throw new Error('TronWeb not initialized');
//   }
  
//   if (!tokenConfig || !tokenConfig.contractAddress) {
//     throw new Error('Invalid token configuration');
//   }
  
//   const { contractAddress, decimals, symbol } = tokenConfig;
  
//   const tokenAmount = parseFloat(amount);
//   const tokenDecimals = parseInt(decimals);
  
//   const amountWithDecimals = tokenAmount * Math.pow(10, tokenDecimals);
//   const amountString = amountWithDecimals.toString();
  
//   console.log(`Sending ${tokenAmount} ${symbol} (${amountString} base units) to ${toAddress}`);
  
//   try {
//     const contract = await tronWeb.contract().at(contractAddress);
    
//     if (!contract.transfer) {
//       throw new Error('Invalid TRC-20 contract');
//     }
    
//     const transaction = await contract.transfer(
//       toAddress,
//       amountString
//     ).send({
//       feeLimit: 100000000,
//       callValue: 0,
//       shouldPollResponse: false
//     });
    
//     console.log('TRC20 transaction sent:', transaction);
//     return transaction;
//   } catch (error) {
//     console.error('TRC20 transaction failed:', error);
    
//     if (error.message && error.message.includes('User rejected')) {
//       throw new Error('Transaction rejected by user');
//     } else if (error.message && error.message.includes('bandwidth')) {
//       throw new Error('Insufficient energy or bandwidth. Make sure you have enough TRX for fees.');
//     } else if (error.message && error.message.includes('balance')) {
//       throw new Error('Insufficient token balance for transfer');
//     } else {
//       throw new Error(`Transaction failed: ${error.message || 'Unknown error'}`);
//     }
//   }
// };

// // Enhanced Algorand asset transaction function
// export const sendAlgorandAssetTransaction = async (walletConnection, tokenConfig, toAddress, amount) => {
//   console.log('Sending Algorand asset transaction with:', { tokenConfig, toAddress, amount });
  
//   if (!walletConnection || !walletConnection.provider) {
//     throw new Error('Algorand wallet not connected');
//   }
  
//   const algorandProvider = walletConnection.provider;
  
//   if (!tokenConfig || !tokenConfig.assetId) {
//     throw new Error('Invalid token configuration - missing assetId');
//   }
  
//   const { assetId, decimals, symbol } = tokenConfig;
  
//   const tokenAmount = parseFloat(amount);
//   const tokenDecimals = parseInt(decimals);
  
//   const assetAmount = Math.floor(tokenAmount * Math.pow(10, tokenDecimals));
  
//   console.log(`Sending ${tokenAmount} ${symbol} (${assetAmount} base units) to ${toAddress}`);
//   console.log(`Using wallet: ${walletConnection.walletName || 'Unknown'}`);
  
//   try {
//     let transaction;
    
//     // Handle different Algorand wallet APIs
//     if (algorandProvider.sendAssetTransfer) {
//       console.log('Using sendAssetTransfer method...');
//       transaction = await algorandProvider.sendAssetTransfer({
//         recipient: toAddress,
//         assetId: assetId,
//         amount: assetAmount
//       });
//     } else if (algorandProvider.signTransaction) {
//       console.log('Using signTransaction method for asset transfer...');
//       // Build asset transfer transaction for wallets like AlgoSigner
//       const txn = {
//         type: 'axfer',
//         from: walletConnection.address,
//         to: toAddress,
//         amount: assetAmount,
//         assetIndex: assetId,
//         fee: 1000,
//         firstRound: 1000,
//         lastRound: 2000
//       };
//       transaction = await algorandProvider.signTransaction(txn);
//     } else {
//       throw new Error(`Unsupported Algorand wallet API for asset transfers in ${walletConnection.walletName || 'this wallet'}`);
//     }
    
//     console.log('Algorand asset transaction sent:', transaction);
//     return transaction.txId || transaction.txID || transaction;
//   } catch (error) {
//     console.error('Algorand asset transaction error:', error);
    
//     if (error.message && error.message.includes('rejected')) {
//       throw new Error('Transaction rejected by user');
//     } else if (error.message && error.message.includes('balance')) {
//       throw new Error('Insufficient asset balance');
//     } else if (error.message && error.message.includes('opted')) {
//       throw new Error('Account not opted in to this asset. Please opt in first.');
//     } else {
//       throw error;
//     }
//   }
// };

// // Get token configuration for a specific currency and network
// export const getTokenConfig = (currency, network) => {
//   if (!currency || !network) {
//     return null;
//   }
  
//   const tokenConfig = TOKEN_CONFIG[currency.toUpperCase()];
//   if (!tokenConfig) {
//     return null;
//   }
  
//   return tokenConfig[network.toLowerCase()];
// };

// // Export everything as a default object as well
// export default {
//   WALLET_TYPES,
//   NETWORK_TYPES,
//   NETWORK_CONFIG,
//   TOKEN_CONFIG,
//   NETWORK_WALLET_MAP,
//   getWalletInstallUrl,
//   detectWallets,
//   detectWalletsWithRetry,
//   debugWalletEnvironment,
//   connectWallet,
//   getSupportedWalletsForNetwork,
//   sendNativeTransaction,
//   sendTokenTransaction,
//   sendTransaction,
//   sendTRC20Transaction,
//   sendERC20Transaction,
//   sendSolanaTokenTransaction,
//   sendAlgorandAssetTransaction,
//   getTokenConfig
// };






































// // src/services/walletService.js 
// import { ethers } from 'ethers';

// // Wallet Types - Added Phantom
// export const WALLET_TYPES = {
//   METAMASK: 'metamask',
//   TRONLINK: 'tronlink',
//   TRUST_WALLET: 'trustwallet',
//   LUTE: 'lute',
//   PHANTOM: 'phantom' // New Phantom wallet for Solana
// };

// // Network Types - Added Solana
// export const NETWORK_TYPES = {
//   ETHEREUM: 'ethereum',
//   BSC: 'bsc',
//   TRON: 'tron',
//   ALGORAND: 'algorand',
//   SOLANA: 'solana' // New Solana network
// };

// // Network configuration - Added Solana
// export const NETWORK_CONFIG = {
//   [NETWORK_TYPES.ETHEREUM]: {
//     name: 'Ethereum Mainnet',
//     chainId: 1,
//     symbol: 'ETH',
//     decimals: 18,
//     rpcUrl: 'https://mainnet.infura.io/v3/your-infura-key',
//     blockExplorerUrl: 'https://etherscan.io'
//   },
//   [NETWORK_TYPES.BSC]: {
//     name: 'Binance Smart Chain',
//     chainId: 56,
//     symbol: 'BNB',
//     decimals: 18,
//     rpcUrl: 'https://bsc-dataseed.binance.org/',
//     blockExplorerUrl: 'https://bscscan.com'
//   },
//   [NETWORK_TYPES.TRON]: {
//     name: 'TRON Mainnet',
//     symbol: 'TRX',
//     decimals: 6,
//     rpcUrl: 'https://api.trongrid.io',
//     blockExplorerUrl: 'https://tronscan.org'
//   },
//   [NETWORK_TYPES.ALGORAND]: {
//     name: 'Algorand Mainnet',
//     symbol: 'ALGO',
//     decimals: 6,
//     rpcUrl: 'https://mainnet-api.algonode.cloud',
//     blockExplorerUrl: 'https://algoexplorer.io'
//   },
//   [NETWORK_TYPES.SOLANA]: {
//     name: 'Solana Mainnet',
//     symbol: 'SOL',
//     decimals: 9,
//     rpcUrl: 'https://api.mainnet-beta.solana.com',
//     blockExplorerUrl: 'https://explorer.solana.com'
//   }
// };

// // Token configurations with correct contract addresses and decimals - Added Solana tokens
// export const TOKEN_CONFIG = {
//   USDT: {
//     ethereum: {
//       contractAddress: '0xdAC17F958D2ee523a2206206994597C13D831ec7',
//       decimals: 6,
//       symbol: 'USDT'
//     },
//     bsc: {
//       contractAddress: '0x55d398326f99059fF775485246999027B3197955',
//       decimals: 18,
//       symbol: 'USDT'
//     },
//     tron: {
//       contractAddress: 'TR7NHqjeKQxGTCi8q8ZY4pL8otSzgjLj6t',
//       decimals: 6,
//       symbol: 'USDT'
//     },
//     algorand: {
//       assetId: 312769,
//       decimals: 6,
//       symbol: 'USDT'
//     },
//     solana: {
//       contractAddress: 'Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB', // USDT on Solana
//       decimals: 6,
//       symbol: 'USDT'
//     }
//   },
//   USDC: {
//     ethereum: {
//       contractAddress: '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
//       decimals: 6,
//       symbol: 'USDC'
//     },
//     bsc: {
//       contractAddress: '0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d',
//       decimals: 18,
//       symbol: 'USDC'
//     },
//     tron: {
//       contractAddress: 'TEkxiTehnzSmSe2XqrBj4w32RUN966rdz8',
//       decimals: 6,
//       symbol: 'USDC'
//     },
//     algorand: {
//       assetId: 31566704,
//       decimals: 6,
//       symbol: 'USDC'
//     },
//     solana: {
//       contractAddress: 'EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v', // USDC on Solana
//       decimals: 6,
//       symbol: 'USDC'
//     }
//   },
//   BNB: {
//     bsc: {
//       decimals: 18,
//       symbol: 'BNB',
//       isNative: true
//     }
//   },
//   ETH: {
//     ethereum: {
//       decimals: 18,
//       symbol: 'ETH',
//       isNative: true
//     }
//   },
//   TRX: {
//     tron: {
//       decimals: 6,
//       symbol: 'TRX',
//       isNative: true
//     }
//   },
//   ALGO: {
//     algorand: {
//       decimals: 6,
//       symbol: 'ALGO',
//       isNative: true
//     }
//   },
//   SOL: {
//     solana: {
//       decimals: 9,
//       symbol: 'SOL',
//       isNative: true
//     }
//   }
// };

// // Network to wallet mapping - Added Solana/Phantom
// export const NETWORK_WALLET_MAP = {
//   [NETWORK_TYPES.ETHEREUM]: [WALLET_TYPES.METAMASK, WALLET_TYPES.TRUST_WALLET],
//   [NETWORK_TYPES.BSC]: [WALLET_TYPES.METAMASK, WALLET_TYPES.TRUST_WALLET],
//   [NETWORK_TYPES.TRON]: [WALLET_TYPES.TRONLINK],
//   [NETWORK_TYPES.ALGORAND]: [WALLET_TYPES.LUTE],
//   [NETWORK_TYPES.SOLANA]: [WALLET_TYPES.PHANTOM] // Phantom for Solana
// };

// // Installation URLs for wallets - Added Phantom
// export const getWalletInstallUrl = (walletType) => {
//   const urls = {
//     [WALLET_TYPES.METAMASK]: 'https://metamask.io/download/',
//     [WALLET_TYPES.TRONLINK]: 'https://www.tronlink.org/download/',
//     [WALLET_TYPES.TRUST_WALLET]: 'https://trustwallet.com/download/',
//     [WALLET_TYPES.LUTE]: 'https://lute.app/download/',
//     [WALLET_TYPES.PHANTOM]: 'https://phantom.app/download'
//   };
//   return urls[walletType] || '';
// };

// // Enhanced Lute wallet detection
// const detectLuteWallet = () => {
//   if (typeof window === 'undefined') return false;
  
//   // Multiple ways to detect Lute wallet
//   const luteDetectionMethods = [
//     // Check for window.lute
//     () => window.lute !== undefined,
//     // Check for window.algorand (some Algorand wallets use this)
//     () => window.algorand !== undefined,
//     // Check for AlgoSigner (alternative Algorand wallet)
//     () => window.AlgoSigner !== undefined,
//     // Check for specific Lute wallet identifiers
//     () => window.luteWallet !== undefined,
//     // Check for wallet extension in DOM
//     () => document.querySelector('[data-wallet="lute"]') !== null,
//     // Check if Lute is injected via content script
//     () => window.postMessage && document.documentElement.getAttribute('data-lute-extension') === 'true'
//   ];
  
//   return luteDetectionMethods.some(method => {
//     try {
//       return method();
//     } catch (error) {
//       console.warn('Lute detection method failed:', error);
//       return false;
//     }
//   });
// };

// // Enhanced Phantom wallet detection
// const detectPhantomWallet = () => {
//   if (typeof window === 'undefined') return false;
  
//   // Multiple ways to detect Phantom wallet
//   const phantomDetectionMethods = [
//     // Check for window.solana with isPhantom
//     () => window.solana && window.solana.isPhantom,
//     // Check for window.phantom
//     () => window.phantom && window.phantom.solana,
//     // Check for specific Phantom wallet identifiers
//     () => window.phantomWallet !== undefined,
//     // Check for wallet extension in DOM
//     () => document.querySelector('[data-wallet="phantom"]') !== null
//   ];
  
//   return phantomDetectionMethods.some(method => {
//     try {
//       return method();
//     } catch (error) {
//       console.warn('Phantom detection method failed:', error);
//       return false;
//     }
//   });
// };

// // Detect available wallets in the browser - Added Phantom
// export const detectWallets = () => {
//   const availableWallets = {
//     [WALLET_TYPES.METAMASK]: typeof window !== 'undefined' && window.ethereum !== undefined && window.ethereum.isMetaMask,
//     [WALLET_TYPES.TRONLINK]: typeof window !== 'undefined' && window.tronWeb !== undefined,
//     [WALLET_TYPES.TRUST_WALLET]: typeof window !== 'undefined' && 
//       window.ethereum !== undefined && 
//       window.ethereum.isTrust === true,
//     [WALLET_TYPES.LUTE]: detectLuteWallet(),
//     [WALLET_TYPES.PHANTOM]: detectPhantomWallet()
//   };
  
//   // Enhanced logging for wallet detection
//   if (typeof window !== 'undefined') {
//     console.log('=== WALLET DETECTION DEBUG ===');
//     console.log('MetaMask:', availableWallets[WALLET_TYPES.METAMASK]);
//     console.log('TronLink:', availableWallets[WALLET_TYPES.TRONLINK]);
//     console.log('Trust Wallet:', availableWallets[WALLET_TYPES.TRUST_WALLET]);
//     console.log('Lute:', availableWallets[WALLET_TYPES.LUTE]);
//     console.log('Phantom:', availableWallets[WALLET_TYPES.PHANTOM]);
//     console.log('window.solana:', Boolean(window.solana));
//     console.log('window.phantom:', Boolean(window.phantom));
//     console.log('=== END WALLET DETECTION DEBUG ===');
//   }
  
//   return availableWallets;
// };

// // Detect wallets with retry and enhanced detection
// export const detectWalletsWithRetry = async (maxRetries = 5, delay = 1000) => {
//   let retries = 0;
//   let wallets = detectWallets();
  
//   // Special handling for wallet injection - give it more time
//   while (retries < maxRetries) {
//     wallets = detectWallets();
    
//     // Check if we found any wallets or if we've reached max retries
//     const hasAnyWallet = Object.values(wallets).some(v => v === true);
    
//     if (hasAnyWallet || retries >= maxRetries - 1) {
//       break;
//     }
    
//     console.log(`Wallet detection attempt ${retries + 1}/${maxRetries}...`);
//     console.log('Current detection results:', wallets);
    
//     // Wait before next attempt
//     await new Promise(resolve => setTimeout(resolve, delay));
//     retries++;
//   }
  
//   // Final check with extended detection
//   if (!wallets[WALLET_TYPES.LUTE] || !wallets[WALLET_TYPES.PHANTOM]) {
//     console.log('Performing extended wallet detection...');
    
//     if (typeof window !== 'undefined') {
//       try {
//         // Dispatch custom events that might trigger wallet injection
//         const luteEvent = new CustomEvent('lute-wallet-detect', { detail: { source: 'coinley-sdk' } });
//         const phantomEvent = new CustomEvent('phantom-wallet-detect', { detail: { source: 'coinley-sdk' } });
//         window.dispatchEvent(luteEvent);
//         window.dispatchEvent(phantomEvent);
        
//         // Wait a bit more for potential injection
//         await new Promise(resolve => setTimeout(resolve, 500));
        
//         // Re-detect
//         wallets[WALLET_TYPES.LUTE] = detectLuteWallet();
//         wallets[WALLET_TYPES.PHANTOM] = detectPhantomWallet();
//       } catch (error) {
//         console.warn('Extended wallet detection failed:', error);
//       }
//     }
//   }
  
//   console.log('Final wallet detection results:', wallets);
//   return wallets;
// };

// // Debug wallet environment - Added Phantom
// export const debugWalletEnvironment = () => {
//   console.log('=== WALLET ENVIRONMENT DEBUG ===');
//   console.log('ethereum:', typeof window !== 'undefined' ? Boolean(window.ethereum) : 'Not in browser');
//   console.log('tronWeb:', typeof window !== 'undefined' ? Boolean(window.tronWeb) : 'Not in browser');
//   console.log('lute:', typeof window !== 'undefined' ? Boolean(window.lute) : 'Not in browser');
//   console.log('algorand:', typeof window !== 'undefined' ? Boolean(window.algorand) : 'Not in browser');
//   console.log('AlgoSigner:', typeof window !== 'undefined' ? Boolean(window.AlgoSigner) : 'Not in browser');
//   console.log('solana:', typeof window !== 'undefined' ? Boolean(window.solana) : 'Not in browser');
//   console.log('phantom:', typeof window !== 'undefined' ? Boolean(window.phantom) : 'Not in browser');
  
//   if (typeof window !== 'undefined' && window.ethereum) {
//     console.log('ethereum details:', {
//       isTrust: window.ethereum.isTrust,
//       isMetaMask: window.ethereum.isMetaMask,
//       chainId: window.ethereum.chainId
//     });
//   }
  
//   if (typeof window !== 'undefined' && window.tronWeb) {
//     console.log('tronWeb details:', {
//       ready: window.tronWeb.ready,
//       fullNode: window.tronWeb.fullNode?.host,
//       defaultAddress: window.tronWeb.defaultAddress
//     });
//   }
  
//   if (typeof window !== 'undefined' && window.solana) {
//     console.log('solana details:', {
//       isPhantom: window.solana.isPhantom,
//       publicKey: window.solana.publicKey?.toString(),
//       isConnected: window.solana.isConnected
//     });
//   }
  
//   if (typeof window !== 'undefined') {
//     console.log('All window wallet properties:');
//     const walletProps = Object.keys(window).filter(key => 
//       key.toLowerCase().includes('lute') || 
//       key.toLowerCase().includes('algo') || 
//       key.toLowerCase().includes('wallet') ||
//       key.toLowerCase().includes('phantom') ||
//       key.toLowerCase().includes('solana')
//     );
//     console.log('Potential wallet properties:', walletProps);
//   }
  
//   const wallets = detectWallets();
//   console.log('Detected wallets:', wallets);
//   console.log('=== END WALLET ENVIRONMENT DEBUG ===');
// };

// // Connect to MetaMask wallet
// const connectMetamaskWallet = async () => {
//   console.log('Connecting to MetaMask wallet...');
  
//   if (!window.ethereum || !window.ethereum.isMetaMask) {
//     console.error('MetaMask not found.');
//     throw new Error('MetaMask not detected. Please install MetaMask extension.');
//   }
  
//   try {
//     // Use the direct window.ethereum.request method for compatibility
//     const accounts = await window.ethereum.request({ method: 'eth_requestAccounts' });
    
//     if (!accounts || accounts.length === 0) {
//       throw new Error('No accounts found');
//     }
    
//     const address = accounts[0];
//     const chainIdHex = await window.ethereum.request({ method: 'eth_chainId' });
//     const chainId = parseInt(chainIdHex, 16);
    
//     let networkType;
//     switch (chainId) {
//       case 1: networkType = NETWORK_TYPES.ETHEREUM; break;
//       case 56: networkType = NETWORK_TYPES.BSC; break;
//       default: networkType = `unknown-${chainId}`;
//     }
    
//     // Create a proper ethers-compatible provider
//     const web3Provider = new ethers.BrowserProvider(window.ethereum);
    
//     return {
//       walletType: WALLET_TYPES.METAMASK,
//       address,
//       provider: web3Provider,
//       network: networkType,
//       isConnected: true,
//       chainId
//     };
//   } catch (error) {
//     console.error('Error connecting to MetaMask:', error);
//     throw error;
//   }
// };

// // Connect to Trust Wallet
// const connectTrustWallet = async () => {
//   console.log('Connecting to Trust Wallet...');
  
//   if (!window.ethereum || !window.ethereum.isTrust) {
//     console.error('Trust Wallet not found.');
//     throw new Error('Trust Wallet not detected. Please install Trust Wallet.');
//   }
  
//   try {
//     const accounts = await window.ethereum.request({ method: 'eth_requestAccounts' });
    
//     if (!accounts || accounts.length === 0) {
//       throw new Error('No accounts found');
//     }
    
//     const address = accounts[0];
//     const chainIdHex = await window.ethereum.request({ method: 'eth_chainId' });
//     const chainId = parseInt(chainIdHex, 16);
    
//     let networkType;
//     switch (chainId) {
//       case 1: networkType = NETWORK_TYPES.ETHEREUM; break;
//       case 56: networkType = NETWORK_TYPES.BSC; break;
//       default: networkType = `unknown-${chainId}`;
//     }
    
//     // Create a proper ethers-compatible provider
//     const web3Provider = new ethers.BrowserProvider(window.ethereum);
    
//     return {
//       walletType: WALLET_TYPES.TRUST_WALLET,
//       address,
//       provider: web3Provider,
//       network: networkType,
//       isConnected: true,
//       chainId
//     };
//   } catch (error) {
//     console.error('Error connecting to Trust Wallet:', error);
//     throw error;
//   }
// };

// // Connect to TronLink wallet
// const connectTronlinkWallet = async () => {
//   console.log('Connecting to TronLink wallet...');
  
//   if (!window.tronWeb) {
//     console.error('TronWeb not found. Is TronLink installed?');
//     throw new Error('TronLink not detected. Please install TronLink extension.');
//   }
  
//   const waitForTronWeb = async (maxAttempts = 10, interval = 500) => {
//     for (let attempt = 0; attempt < maxAttempts; attempt++) {
//       if (window.tronWeb && window.tronWeb.ready) {
//         return window.tronWeb;
//       }
//       console.log(`Waiting for TronWeb to be ready... Attempt ${attempt + 1}/${maxAttempts}`);
//       await new Promise(resolve => setTimeout(resolve, interval));
//     }
//     throw new Error('TronWeb took too long to be ready');
//   };
  
//   try {
//     const tronWeb = await waitForTronWeb();
    
//     if (!tronWeb.defaultAddress || !tronWeb.defaultAddress.base58) {
//       try {
//         await window.tronWeb.request({ method: 'tron_requestAccounts' });
//       } catch (permissionError) {
//         console.error('Failed to get permission from TronLink:', permissionError);
//         throw new Error('Please unlock TronLink and approve connection');
//       }
//     }
    
//     const address = tronWeb.defaultAddress.base58;
//     console.log('Connected to TronLink wallet:', address);
    
//     return {
//       walletType: WALLET_TYPES.TRONLINK,
//       address: address,
//       provider: tronWeb,
//       network: NETWORK_TYPES.TRON,
//       isConnected: true
//     };
//   } catch (error) {
//     console.error('Error connecting to TronLink:', error);
//     throw error;
//   }
// };

// // Enhanced Lute wallet connection with multiple detection methods
// const connectLuteWallet = async () => {
//   console.log('Connecting to Lute wallet...');
  
//   // Try multiple wallet detection methods
//   let walletProvider = null;
//   let walletName = '';
  
//   // Method 1: Direct Lute wallet
//   if (window.lute) {
//     walletProvider = window.lute;
//     walletName = 'Lute';
//   }
//   // Method 2: Generic Algorand provider
//   else if (window.algorand) {
//     walletProvider = window.algorand;
//     walletName = 'Algorand Provider';
//   }
//   // Method 3: AlgoSigner (alternative Algorand wallet)
//   else if (window.AlgoSigner) {
//     walletProvider = window.AlgoSigner;
//     walletName = 'AlgoSigner';
//   }
//   // Method 4: Check for luteWallet
//   else if (window.luteWallet) {
//     walletProvider = window.luteWallet;
//     walletName = 'Lute Wallet';
//   }
  
//   if (!walletProvider) {
//     console.error('No Algorand wallet detected.');
//     console.log('Available window properties:', Object.keys(window).filter(key => 
//       key.toLowerCase().includes('lute') || 
//       key.toLowerCase().includes('algo') || 
//       key.toLowerCase().includes('wallet')
//     ));
//     throw new Error('Lute wallet not detected. Please install Lute extension or another Algorand wallet.');
//   }
  
//   console.log(`Found ${walletName} wallet provider:`, walletProvider);
  
//   try {
//     let address = null;
    
//     // Try different connection methods based on the wallet type
//     if (walletProvider.connect) {
//       console.log('Using connect() method...');
//       const result = await walletProvider.connect();
//       address = result.address || result;
//     }
//     else if (walletProvider.enable) {
//       console.log('Using enable() method...');
//       const accounts = await walletProvider.enable();
//       address = accounts[0] || accounts;
//     }
//     else if (walletProvider.requestAccounts) {
//       console.log('Using requestAccounts() method...');
//       const accounts = await walletProvider.requestAccounts();
//       address = accounts[0];
//     }
//     // For AlgoSigner
//     else if (walletProvider.connect && walletName === 'AlgoSigner') {
//       console.log('Using AlgoSigner connect...');
//       await walletProvider.connect();
//       const accounts = await walletProvider.accounts({ ledger: 'MainNet' });
//       address = accounts[0]?.address;
//     }
    
//     if (!address) {
//       throw new Error(`No address returned from ${walletName}. Please unlock your wallet and try again.`);
//     }
    
//     console.log(`Connected to ${walletName} wallet:`, address);
    
//     return {
//       walletType: WALLET_TYPES.LUTE,
//       address: address,
//       provider: walletProvider,
//       network: NETWORK_TYPES.ALGORAND,
//       isConnected: true,
//       walletName: walletName
//     };
//   } catch (error) {
//     console.error(`Error connecting to ${walletName}:`, error);
    
//     if (error.message && error.message.includes('User rejected')) {
//       throw new Error('Connection rejected by user. Please approve the connection in your wallet.');
//     } else if (error.message && error.message.includes('locked')) {
//       throw new Error('Wallet is locked. Please unlock your wallet and try again.');
//     } else {
//       throw new Error(`Failed to connect to ${walletName}: ${error.message || 'Unknown error'}`);
//     }
//   }
// };

// // NEW: Connect to Phantom wallet
// const connectPhantomWallet = async () => {
//   console.log('Connecting to Phantom wallet...');
  
//   // Try multiple detection methods
//   let phantomProvider = null;
  
//   if (window.solana && window.solana.isPhantom) {
//     phantomProvider = window.solana;
//   } else if (window.phantom && window.phantom.solana) {
//     phantomProvider = window.phantom.solana;
//   }
  
//   if (!phantomProvider) {
//     console.error('Phantom wallet not found.');
//     console.log('Available Solana providers:', {
//       'window.solana': Boolean(window.solana),
//       'window.phantom': Boolean(window.phantom),
//       'window.solana.isPhantom': window.solana?.isPhantom
//     });
//     throw new Error('Phantom wallet not detected. Please install Phantom extension.');
//   }
  
//   console.log('Found Phantom wallet provider:', phantomProvider);
  
//   try {
//     // Connect to Phantom
//     const response = await phantomProvider.connect();
    
//     if (!response || !response.publicKey) {
//       throw new Error('No public key returned from Phantom');
//     }
    
//     const address = response.publicKey.toString();
//     console.log('Connected to Phantom wallet:', address);
    
//     return {
//       walletType: WALLET_TYPES.PHANTOM,
//       address: address,
//       provider: phantomProvider,
//       network: NETWORK_TYPES.SOLANA,
//       isConnected: true,
//       publicKey: response.publicKey
//     };
//   } catch (error) {
//     console.error('Error connecting to Phantom:', error);
    
//     if (error.code === 4001) {
//       throw new Error('Connection rejected by user. Please approve the connection in Phantom.');
//     } else if (error.message && error.message.includes('User rejected')) {
//       throw new Error('Connection rejected by user. Please approve the connection in Phantom.');
//     } else {
//       throw new Error(`Failed to connect to Phantom: ${error.message || 'Unknown error'}`);
//     }
//   }
// };

// // General wallet connection function - Added Phantom
// export const connectWallet = async (walletType) => {
//   console.log('Connecting to wallet:', walletType);
  
//   switch (walletType) {
//     case WALLET_TYPES.METAMASK:
//       return connectMetamaskWallet();
//     case WALLET_TYPES.TRONLINK:
//       return connectTronlinkWallet();
//     case WALLET_TYPES.TRUST_WALLET:
//       return connectTrustWallet();
//     case WALLET_TYPES.LUTE:
//       return connectLuteWallet();
//     case WALLET_TYPES.PHANTOM:
//       return connectPhantomWallet();
//     default:
//       throw new Error(`Unsupported wallet type: ${walletType}`);
//   }
// };

// // Get supported wallets for a network
// export const getSupportedWalletsForNetwork = (network) => {
//   return NETWORK_WALLET_MAP[network] || [];
// };

// // Send native currency transaction
// export const sendNativeTransaction = async (walletConnection, toAddress, amount) => {
//   console.log('Sending native transaction:', { toAddress, amount });
  
//   if (!walletConnection || !walletConnection.provider) {
//     throw new Error('Wallet not connected');
//   }
  
//   if (!toAddress) {
//     throw new Error('Recipient address not provided');
//   }
  
//   if (!amount || isNaN(parseFloat(amount)) || parseFloat(amount) <= 0) {
//     throw new Error('Invalid amount');
//   }
  
//   try {
//     let transaction;
    
//     switch (walletConnection.walletType) {
//       case WALLET_TYPES.METAMASK:
//       case WALLET_TYPES.TRUST_WALLET:
//         const provider = walletConnection.provider;
//         const signer = await provider.getSigner();
        
//         const amountInEther = amount.toString();
//         const amountWei = ethers.parseEther(amountInEther);
        
//         console.log('Sending ETH/BNB:', {
//           to: toAddress,
//           value: amountWei.toString()
//         });
        
//         // Estimate gas using the provider directly
//         const gasEstimate = await provider.estimateGas({
//           to: toAddress,
//           value: amountWei,
//           from: await signer.getAddress()
//         });
        
//         console.log('Gas estimate:', gasEstimate.toString());
        
//         // Add 10% buffer to gas estimate
//         const gasLimit = (gasEstimate * BigInt(110)) / BigInt(100);
        
//         console.log('Using gas limit:', gasLimit.toString());
        
//         // Send transaction
//         transaction = await signer.sendTransaction({
//           to: toAddress,
//           value: amountWei,
//           gasLimit: gasLimit
//         });
//         break;
        
//       case WALLET_TYPES.TRONLINK:
//         const tronWeb = walletConnection.provider;
        
//         if (!tronWeb || !tronWeb.ready) {
//           throw new Error('TronWeb not initialized');
//         }
        
//         const amountSun = tronWeb.toSun(amount.toString());
        
//         console.log('Sending TRX:', {
//           to: toAddress,
//           value: amountSun
//         });
        
//         transaction = await tronWeb.trx.sendTransaction(
//           toAddress,
//           amountSun
//         );
//         break;
        
//       case WALLET_TYPES.LUTE:
//         const algorandProvider = walletConnection.provider;
        
//         const microAlgos = Math.floor(parseFloat(amount) * 1000000);
        
//         console.log('Sending Algos:', {
//           to: toAddress,
//           amount: microAlgos,
//           walletName: walletConnection.walletName
//         });
        
//         // Handle different Algorand wallet APIs
//         if (algorandProvider.sendPayment) {
//           transaction = await algorandProvider.sendPayment({
//             recipient: toAddress,
//             amount: microAlgos
//           });
//         } else if (algorandProvider.signTransaction) {
//           // For AlgoSigner or other wallets that require manual transaction building
//           const txn = {
//             to: toAddress,
//             fee: 1000,
//             amount: microAlgos,
//             firstRound: 1000,
//             lastRound: 2000,
//             type: 'pay'
//           };
//           transaction = await algorandProvider.signTransaction(txn);
//         } else {
//           throw new Error(`Unsupported Algorand wallet API for ${walletConnection.walletName}`);
//         }
//         break;
        
//       case WALLET_TYPES.PHANTOM:
//         const phantomProvider = walletConnection.provider;
        
//         if (!phantomProvider || !phantomProvider.isConnected) {
//           throw new Error('Phantom wallet not connected');
//         }
        
//         // For Phantom, we need to be careful about the amount calculation
//         // The issue is likely that we're calculating lamports but Phantom expects SOL
//         const amountFloat = parseFloat(amount);
        
//         console.log('Phantom SOL Transaction Debug:', {
//           originalAmount: amount,
//           amountFloat: amountFloat,
//           walletType: 'Phantom Native SOL'
//         });
        
//         // For native SOL transfers, Phantom expects the amount in SOL, not lamports
//         // Let's create a simple transfer using Phantom's built-in methods
//         try {
//           // Try using Phantom's simple transfer method first
//           if (phantomProvider.request) {
//             const result = await phantomProvider.request({
//               method: 'transfer',
//               params: {
//                 to: toAddress,
//                 amount: amountFloat // Send in SOL, not lamports
//               }
//             });
            
//             console.log('Phantom transfer result:', result);
//             transaction = result;
//           } else {
//             // Fallback: manual transaction construction
//             // Import Solana libraries only when needed and handle the import error
//             let Connection, PublicKey, Transaction, SystemProgram, LAMPORTS_PER_SOL;
            
//             try {
//               const solanaWeb3 = await import('@solana/web3.js');
//               Connection = solanaWeb3.Connection;
//               PublicKey = solanaWeb3.PublicKey;
//               Transaction = solanaWeb3.Transaction;
//               SystemProgram = solanaWeb3.SystemProgram;
//               LAMPORTS_PER_SOL = solanaWeb3.LAMPORTS_PER_SOL;
//             } catch (importError) {
//               console.error('Failed to import Solana libraries:', importError);
//               throw new Error('Solana libraries not available. Please ensure @solana/web3.js is installed.');
//             }
            
//             const connection = new Connection(NETWORK_CONFIG[NETWORK_TYPES.SOLANA].rpcUrl);
//             const fromPubkey = walletConnection.publicKey;
//             const toPubkey = new PublicKey(toAddress);
            
//             // Convert to lamports for the transaction
//             const lamports = Math.floor(amountFloat * LAMPORTS_PER_SOL);
            
//             console.log('Manual Solana transaction:', {
//               from: fromPubkey.toString(),
//               to: toAddress,
//               amountSOL: amountFloat,
//               lamports: lamports,
//               conversionCheck: `${amountFloat} SOL = ${lamports} lamports`
//             });
            
//             // Validate the conversion
//             if (lamports <= 0) {
//               throw new Error(`Invalid amount: ${amountFloat} SOL converts to ${lamports} lamports`);
//             }
            
//             // Create transaction
//             const transferTransaction = new Transaction().add(
//               SystemProgram.transfer({
//                 fromPubkey,
//                 toPubkey,
//                 lamports
//               })
//             );
            
//             // Get recent blockhash
//             const { blockhash } = await connection.getLatestBlockhash();
//             transferTransaction.recentBlockhash = blockhash;
//             transferTransaction.feePayer = fromPubkey;
            
//             // Sign and send transaction
//             const signedTransaction = await phantomProvider.signAndSendTransaction(transferTransaction);
//             transaction = signedTransaction;
//           }
//         } catch (phantomError) {
//           console.error('Phantom transaction error:', phantomError);
//           throw new Error(`Phantom transaction failed: ${phantomError.message || 'Unknown error'}`);
//         }
//         break;
        
//       default:
//         throw new Error(`Unsupported wallet type: ${walletConnection.walletType}`);
//     }
    
//     console.log('Transaction sent:', transaction);
    
//     const hash = transaction.hash || transaction.signature || transaction.txID || transaction.txId || transaction;
//     console.log('Transaction hash:', hash);
//     return hash;
//   } catch (error) {
//     console.error('Native transaction error:', error);
//     throw error;
//   }
// };

// // Helper function to validate transaction amounts before sending
// const validateTransactionAmount = (amount, currency, network) => {
//   const amountFloat = parseFloat(amount);
  
//   console.log('=== TRANSACTION AMOUNT VALIDATION ===');
//   console.log('Amount:', amountFloat);
//   console.log('Currency:', currency);
//   console.log('Network:', network);
  
//   // Warn for large amounts
//   if (currency === 'SOL' && amountFloat > 1) {
//     const estimatedUSDValue = amountFloat * 100; // Rough estimate: 1 SOL = $100
//     console.warn(`⚠️ Large SOL transaction: ${amountFloat} SOL (~${estimatedUSDValue})`);
//     return {
//       isLarge: true,
//       warning: `You are about to send ${amountFloat} SOL (approximately ${estimatedUSDValue}). Please confirm this is correct.`
//     };
//   }
  
//   if (['USDC', 'USDT'].includes(currency) && amountFloat > 100) {
//     console.warn(`⚠️ Large stablecoin transaction: ${amountFloat} ${currency}`);
//     return {
//       isLarge: true,
//       warning: `You are about to send ${amountFloat} ${currency}. Please confirm this is correct.`
//     };
//   }
  
//   console.log('✅ Transaction amount looks reasonable');
//   console.log('=== END TRANSACTION AMOUNT VALIDATION ===');
  
//   return { isLarge: false };
// };
// export const sendTransaction = async (walletConnection, transactionDetails) => {
//   console.log('Sending transaction with:', transactionDetails);
  
//   if (!walletConnection) {
//     throw new Error('Wallet not connected');
//   }
  
//   const { to, amount, tokenAddress, currency, network } = transactionDetails;
  
//   if (!to) {
//     throw new Error('Recipient address not provided');
//   }
  
//   // Check if this is a native currency or token transfer
//   const tokenConfig = TOKEN_CONFIG[currency]?.[network];
  
//   if (tokenConfig && tokenConfig.isNative) {
//     return sendNativeTransaction(walletConnection, to, amount);
//   } else if (tokenConfig) {
//     return sendTokenTransaction(walletConnection, tokenConfig, to, amount);
//   } else {
//     // Fallback to native transaction
//     return sendNativeTransaction(walletConnection, to, amount);
//   }
// };

// // Send token transaction
// export const sendTokenTransaction = async (walletConnection, tokenConfig, toAddress, amount) => {
//   console.log('Sending token transaction with:', { tokenConfig, toAddress, amount });
  
//   if (!walletConnection || !walletConnection.provider) {
//     throw new Error('Wallet not connected');
//   }
  
//   if (!tokenConfig) {
//     throw new Error('Token configuration not provided');
//   }
  
//   if (!toAddress) {
//     throw new Error('Recipient address not provided');
//   }

//   if (!amount || isNaN(parseFloat(amount)) || parseFloat(amount) <= 0) {
//     throw new Error('Invalid amount');
//   }

//   const { contractAddress, decimals, symbol } = tokenConfig;
//   console.log(`Token: ${symbol}, Decimals: ${decimals}, Contract: ${contractAddress}`);
  
//   switch (walletConnection.walletType) {
//     case WALLET_TYPES.TRONLINK:
//       return sendTRC20Transaction(walletConnection, tokenConfig, toAddress, amount);
//     case WALLET_TYPES.LUTE:
//       return sendAlgorandAssetTransaction(walletConnection, tokenConfig, toAddress, amount);
//     case WALLET_TYPES.PHANTOM:
//       return sendSolanaTokenTransaction(walletConnection, tokenConfig, toAddress, amount);
//     default:
//       return sendERC20Transaction(walletConnection, tokenConfig, toAddress, amount);
//   }
// };

// // NEW: Solana token transaction function
// export const sendSolanaTokenTransaction = async (walletConnection, tokenConfig, toAddress, amount) => {
//   console.log('=== SOLANA TOKEN TRANSACTION DEBUG ===');
//   console.log('Input params:', { tokenConfig, toAddress, amount });
//   console.log('Wallet connection:', walletConnection);
  
//   if (!walletConnection || !walletConnection.provider) {
//     throw new Error('Phantom wallet not connected');
//   }
  
//   const phantomProvider = walletConnection.provider;
  
//   if (!phantomProvider || !phantomProvider.isConnected) {
//     throw new Error('Phantom wallet not connected');
//   }
  
//   if (!tokenConfig || !tokenConfig.contractAddress) {
//     throw new Error('Invalid token configuration');
//   }
  
//   const { contractAddress, decimals, symbol } = tokenConfig;
//   const tokenAmount = parseFloat(amount);
//   const tokenDecimals = parseInt(decimals);
  
//   console.log('Token config details:', {
//     symbol,
//     contractAddress,
//     decimals: tokenDecimals,
//     inputAmount: tokenAmount
//   });
  
//   // The key issue: For USDC with 6 decimals, $0.31 should be 310,000 micro-USDC
//   // But we need to make sure this is what we actually want to send
  
//   // Calculate the amount in the token's smallest unit
//   const amountInSmallestUnit = Math.floor(tokenAmount * Math.pow(10, tokenDecimals));
  
//   console.log('Amount calculation:', {
//     tokenAmount: tokenAmount,
//     decimals: tokenDecimals,
//     calculation: `${tokenAmount} * 10^${tokenDecimals}`,
//     amountInSmallestUnit: amountInSmallestUnit,
//     humanReadable: `${tokenAmount} ${symbol} = ${amountInSmallestUnit} micro-${symbol}`
//   });
  
//   // IMPORTANT: Validate that this is actually what we want
//   // For $0.31 USDC (6 decimals): 0.31 * 10^6 = 310,000 micro-USDC
//   // This should be ~$0.31, not $310k
  
//   if (amountInSmallestUnit <= 0) {
//     throw new Error(`Invalid amount: ${tokenAmount} ${symbol} converts to ${amountInSmallestUnit} base units`);
//   }
  
//   // For very small amounts, warn if we might lose precision
//   if (tokenAmount < 1 && amountInSmallestUnit === 0) {
//     throw new Error(`Amount too small: ${tokenAmount} ${symbol} is smaller than the minimum unit (1/${Math.pow(10, tokenDecimals)} ${symbol})`);
//   }
  
//   try {
//     // Import Solana libraries with proper error handling
//     let Connection, PublicKey, Transaction, createTransferInstruction, getAssociatedTokenAddress, TOKEN_PROGRAM_ID, ASSOCIATED_TOKEN_PROGRAM_ID;
    
//     try {
//       const solanaWeb3 = await import('@solana/web3.js');
//       const splToken = await import('@solana/spl-token');
      
//       Connection = solanaWeb3.Connection;
//       PublicKey = solanaWeb3.PublicKey;
//       Transaction = solanaWeb3.Transaction;
//       createTransferInstruction = splToken.createTransferInstruction;
//       getAssociatedTokenAddress = splToken.getAssociatedTokenAddress;
//       TOKEN_PROGRAM_ID = splToken.TOKEN_PROGRAM_ID;
//       ASSOCIATED_TOKEN_PROGRAM_ID = splToken.ASSOCIATED_TOKEN_PROGRAM_ID;
//     } catch (importError) {
//       console.error('Failed to import Solana libraries:', importError);
//       throw new Error('Solana libraries not available. Please ensure @solana/web3.js and @solana/spl-token are installed.');
//     }
    
//     const connection = new Connection(NETWORK_CONFIG[NETWORK_TYPES.SOLANA].rpcUrl);
//     const fromPubkey = walletConnection.publicKey;
//     const toPubkey = new PublicKey(toAddress);
//     const mintPubkey = new PublicKey(contractAddress);
    
//     console.log('Public keys:', {
//       from: fromPubkey.toString(),
//       to: toPubkey.toString(),
//       mint: mintPubkey.toString()
//     });
    
//     // Get associated token accounts
//     const fromTokenAccount = await getAssociatedTokenAddress(
//       mintPubkey,
//       fromPubkey,
//       false,
//       TOKEN_PROGRAM_ID,
//       ASSOCIATED_TOKEN_PROGRAM_ID
//     );
    
//     const toTokenAccount = await getAssociatedTokenAddress(
//       mintPubkey,
//       toPubkey,
//       false,
//       TOKEN_PROGRAM_ID,
//       ASSOCIATED_TOKEN_PROGRAM_ID
//     );
    
//     console.log('Token accounts:', {
//       fromTokenAccount: fromTokenAccount.toString(),
//       toTokenAccount: toTokenAccount.toString()
//     });
    
//     // Create transfer instruction
//     console.log('Creating transfer instruction with amount:', amountInSmallestUnit);
    
//     const transferInstruction = createTransferInstruction(
//       fromTokenAccount,
//       toTokenAccount,
//       fromPubkey,
//       amountInSmallestUnit,
//       [],
//       TOKEN_PROGRAM_ID
//     );
    
//     // Create transaction
//     const transaction = new Transaction().add(transferInstruction);
    
//     // Get recent blockhash
//     const { blockhash } = await connection.getLatestBlockhash();
//     transaction.recentBlockhash = blockhash;
//     transaction.feePayer = fromPubkey;
    
//     console.log('Transaction created, sending to Phantom...');
    
//     // Sign and send transaction
//     const signedTransaction = await phantomProvider.signAndSendTransaction(transaction);
    
//     console.log('✅ Solana token transaction sent successfully:', signedTransaction);
//     console.log('=== END SOLANA TOKEN TRANSACTION DEBUG ===');
    
//     return signedTransaction.signature || signedTransaction;
//   } catch (error) {
//     console.error('❌ Solana token transaction error:', error);
//     console.log('=== END SOLANA TOKEN TRANSACTION DEBUG (ERROR) ===');
    
//     if (error.message && error.message.includes('User rejected')) {
//       throw new Error('Transaction rejected by user');
//     } else if (error.message && error.message.includes('Insufficient')) {
//       throw new Error('Insufficient token balance');
//     } else if (error.message && error.message.includes('Invalid amount') || error.message && error.message.includes('Amount too small')) {
//       throw error; // Re-throw our validation errors
//     } else if (error.message && error.message.includes('Solana libraries not available')) {
//       throw error; // Re-throw import errors
//     } else {
//       throw new Error(`Token transaction failed: ${error.message || 'Unknown error'}`);
//     }
//   }
// };

// // ERC20/BEP20 token transaction function
// export const sendERC20Transaction = async (walletConnection, tokenConfig, toAddress, amount) => {
//   console.log('Sending ERC20/BEP20 transaction with:', { tokenConfig, toAddress, amount });
  
//   if (!walletConnection || !walletConnection.provider) {
//     throw new Error('Wallet not connected');
//   }
  
//   const provider = walletConnection.provider;
//   const signer = await provider.getSigner();
  
//   const { contractAddress, decimals, symbol } = tokenConfig;
  
//   const tokenAmount = parseFloat(amount);
//   const tokenDecimals = parseInt(decimals);
  
//   // Use ethers v6 parseUnits directly
//   const tokenUnits = ethers.parseUnits(tokenAmount.toString(), tokenDecimals);
  
//   console.log(`Sending ${tokenAmount} ${symbol} (${tokenUnits.toString()} base units) to ${toAddress}`);
//   console.log(`Token config:`, { contractAddress, decimals, symbol });
  
//   try {
//     // Create contract instance with proper signer
//     const tokenContract = new ethers.Contract(
//       contractAddress,
//       [
//         'function transfer(address to, uint256 amount) returns (bool)',
//         'function balanceOf(address owner) view returns (uint256)',
//         'function decimals() view returns (uint8)'
//       ],
//       signer
//     );
    
//     // Check token balance first
//     const userAddress = await signer.getAddress();
//     const balance = await tokenContract.balanceOf(userAddress);
//     console.log(`User ${symbol} balance:`, ethers.formatUnits(balance, decimals));
    
//     if (balance < tokenUnits) {
//       throw new Error(`Insufficient ${symbol} balance. Required: ${tokenAmount}, Available: ${ethers.formatUnits(balance, decimals)}`);
//     }
    
//     try {
//       // Estimate gas for the transfer with higher gas limit for USDC
//       const gasEstimate = await tokenContract.transfer.estimateGas(toAddress, tokenUnits);
//       console.log('Gas estimate:', gasEstimate.toString());
      
//       // USDC requires significantly more gas due to additional checks
//       let gasMultiplier;
//       if (symbol === 'USDC') {
//         gasMultiplier = BigInt(150); // 50% buffer for USDC
//       } else if (symbol === 'USDT') {
//         gasMultiplier = BigInt(130); // 30% buffer for USDT
//       } else {
//         gasMultiplier = BigInt(120); // 20% buffer for others
//       }
      
//       const gasLimit = (gasEstimate * gasMultiplier) / BigInt(100);
        
//       console.log('Using gas limit:', gasLimit.toString());
      
//       // Send with explicit gas limit
//       const transaction = await tokenContract.transfer(toAddress, tokenUnits, {
//         gasLimit: gasLimit
//       });
      
//       console.log('Transaction sent:', transaction);
//       return transaction.hash;
//     } catch (gasError) {
//       console.error('Gas estimation failed:', gasError);
      
//       // For USDC/USDT, try with higher fixed gas limits
//       let fixedGasLimit;
//       if (symbol === 'USDC') {
//         fixedGasLimit = BigInt(200000); // Higher for USDC
//       } else if (symbol === 'USDT') {
//         fixedGasLimit = BigInt(180000); // Higher for USDT
//       } else {
//         fixedGasLimit = BigInt(150000);
//       }
      
//       console.log(`Trying ${symbol} transaction with fixed gas limit:`, fixedGasLimit.toString());
      
//       const transaction = await tokenContract.transfer(toAddress, tokenUnits, {
//         gasLimit: fixedGasLimit
//       });
      
//       console.log('Transaction sent with fixed gas limit:', transaction);
//       return transaction.hash;
//     }
//   } catch (error) {
//     console.error('ERC20 transaction error:', error);
    
//     // Improve error messages
//     if (error.message && error.message.includes('user rejected')) {
//       throw new Error('Transaction rejected by user');
//     } else if (error.message && error.message.includes('insufficient funds')) {
//       throw new Error('Insufficient funds for transaction');
//     } else if (error.message && error.message.includes('Insufficient')) {
//       throw error; // Already formatted
//     } else {
//       throw error;
//     }
//   }
// };

// // TRC20 token transaction function
// export const sendTRC20Transaction = async (walletConnection, tokenConfig, toAddress, amount) => {
//   console.log('Sending TRC20 transaction with:', { tokenConfig, toAddress, amount });
  
//   if (!walletConnection || !walletConnection.provider) {
//     throw new Error('Tron wallet not connected');
//   }
  
//   const tronWeb = walletConnection.provider;
//   if (!tronWeb || !tronWeb.ready) {
//     throw new Error('TronWeb not initialized');
//   }
  
//   if (!tokenConfig || !tokenConfig.contractAddress) {
//     throw new Error('Invalid token configuration');
//   }
  
//   const { contractAddress, decimals, symbol } = tokenConfig;
  
//   const tokenAmount = parseFloat(amount);
//   const tokenDecimals = parseInt(decimals);
  
//   const amountWithDecimals = tokenAmount * Math.pow(10, tokenDecimals);
//   const amountString = amountWithDecimals.toString();
  
//   console.log(`Sending ${tokenAmount} ${symbol} (${amountString} base units) to ${toAddress}`);
  
//   try {
//     const contract = await tronWeb.contract().at(contractAddress);
    
//     if (!contract.transfer) {
//       throw new Error('Invalid TRC-20 contract');
//     }
    
//     const transaction = await contract.transfer(
//       toAddress,
//       amountString
//     ).send({
//       feeLimit: 100000000,
//       callValue: 0,
//       shouldPollResponse: false
//     });
    
//     console.log('TRC20 transaction sent:', transaction);
//     return transaction;
//   } catch (error) {
//     console.error('TRC20 transaction failed:', error);
    
//     if (error.message && error.message.includes('User rejected')) {
//       throw new Error('Transaction rejected by user');
//     } else if (error.message && error.message.includes('bandwidth')) {
//       throw new Error('Insufficient energy or bandwidth. Make sure you have enough TRX for fees.');
//     } else if (error.message && error.message.includes('balance')) {
//       throw new Error('Insufficient token balance for transfer');
//     } else {
//       throw new Error(`Transaction failed: ${error.message || 'Unknown error'}`);
//     }
//   }
// };

// // Enhanced Algorand asset transaction function
// export const sendAlgorandAssetTransaction = async (walletConnection, tokenConfig, toAddress, amount) => {
//   console.log('Sending Algorand asset transaction with:', { tokenConfig, toAddress, amount });
  
//   if (!walletConnection || !walletConnection.provider) {
//     throw new Error('Algorand wallet not connected');
//   }
  
//   const algorandProvider = walletConnection.provider;
  
//   if (!tokenConfig || !tokenConfig.assetId) {
//     throw new Error('Invalid token configuration - missing assetId');
//   }
  
//   const { assetId, decimals, symbol } = tokenConfig;
  
//   const tokenAmount = parseFloat(amount);
//   const tokenDecimals = parseInt(decimals);
  
//   const assetAmount = Math.floor(tokenAmount * Math.pow(10, tokenDecimals));
  
//   console.log(`Sending ${tokenAmount} ${symbol} (${assetAmount} base units) to ${toAddress}`);
//   console.log(`Using wallet: ${walletConnection.walletName || 'Unknown'}`);
  
//   try {
//     let transaction;
    
//     // Handle different Algorand wallet APIs
//     if (algorandProvider.sendAssetTransfer) {
//       console.log('Using sendAssetTransfer method...');
//       transaction = await algorandProvider.sendAssetTransfer({
//         recipient: toAddress,
//         assetId: assetId,
//         amount: assetAmount
//       });
//     } else if (algorandProvider.signTransaction) {
//       console.log('Using signTransaction method for asset transfer...');
//       // Build asset transfer transaction for wallets like AlgoSigner
//       const txn = {
//         type: 'axfer',
//         from: walletConnection.address,
//         to: toAddress,
//         amount: assetAmount,
//         assetIndex: assetId,
//         fee: 1000,
//         firstRound: 1000,
//         lastRound: 2000
//       };
//       transaction = await algorandProvider.signTransaction(txn);
//     } else {
//       throw new Error(`Unsupported Algorand wallet API for asset transfers in ${walletConnection.walletName || 'this wallet'}`);
//     }
    
//     console.log('Algorand asset transaction sent:', transaction);
//     return transaction.txId || transaction.txID || transaction;
//   } catch (error) {
//     console.error('Algorand asset transaction error:', error);
    
//     if (error.message && error.message.includes('rejected')) {
//       throw new Error('Transaction rejected by user');
//     } else if (error.message && error.message.includes('balance')) {
//       throw new Error('Insufficient asset balance');
//     } else if (error.message && error.message.includes('opted')) {
//       throw new Error('Account not opted in to this asset. Please opt in first.');
//     } else {
//       throw error;
//     }
//   }
// };

// // Get token configuration for a specific currency and network
// export const getTokenConfig = (currency, network) => {
//   if (!currency || !network) {
//     return null;
//   }
  
//   const tokenConfig = TOKEN_CONFIG[currency.toUpperCase()];
//   if (!tokenConfig) {
//     return null;
//   }
  
//   return tokenConfig[network.toLowerCase()];
// };

// // Export everything as a default object as well
// export default {
//   WALLET_TYPES,
//   NETWORK_TYPES,
//   NETWORK_CONFIG,
//   TOKEN_CONFIG,
//   NETWORK_WALLET_MAP,
//   getWalletInstallUrl,
//   detectWallets,
//   detectWalletsWithRetry,
//   debugWalletEnvironment,
//   connectWallet,
//   getSupportedWalletsForNetwork,
//   sendNativeTransaction,
//   sendTokenTransaction,
//   sendTransaction,
//   sendTRC20Transaction,
//   sendERC20Transaction,
//   sendSolanaTokenTransaction,
//   sendAlgorandAssetTransaction,
//   getTokenConfig
// };


















// // src/services/walletService.js 
// import { ethers } from 'ethers';

// // Import Solana libraries statically to avoid dynamic import issues
// import {
//   Connection,
//   PublicKey,
//   Transaction,
//   SystemProgram,
//   LAMPORTS_PER_SOL
// } from '@solana/web3.js';

// import {
//   createTransferInstruction,
//   createAssociatedTokenAccountInstruction,
//   getAssociatedTokenAddress,
//   TOKEN_PROGRAM_ID,
//   ASSOCIATED_TOKEN_PROGRAM_ID
// } from '@solana/spl-token';

// // Wallet Types - Enhanced Trust Wallet support
// export const WALLET_TYPES = {
//   METAMASK: 'metamask',
//   TRONLINK: 'tronlink',
//   TRUST_WALLET: 'trustwallet',
//   LUTE: 'lute',
//   PHANTOM: 'phantom'
// };

// // Network Types
// export const NETWORK_TYPES = {
//   ETHEREUM: 'ethereum',
//   BSC: 'bsc',
//   TRON: 'tron',
//   ALGORAND: 'algorand',
//   SOLANA: 'solana'
// };

// // Network configuration
// export const NETWORK_CONFIG = {
//   [NETWORK_TYPES.ETHEREUM]: {
//     name: 'Ethereum Mainnet',
//     chainId: 1,
//     symbol: 'ETH',
//     decimals: 18,
//     rpcUrl: 'https://mainnet.infura.io/v3/your-infura-key',
//     blockExplorerUrl: 'https://etherscan.io'
//   },
//   [NETWORK_TYPES.BSC]: {
//     name: 'Binance Smart Chain',
//     chainId: 56,
//     symbol: 'BNB',
//     decimals: 18,
//     rpcUrl: 'https://bsc-dataseed.binance.org/',
//     blockExplorerUrl: 'https://bscscan.com'
//   },
//   [NETWORK_TYPES.TRON]: {
//     name: 'TRON Mainnet',
//     symbol: 'TRX',
//     decimals: 6,
//     rpcUrl: 'https://api.trongrid.io',
//     blockExplorerUrl: 'https://tronscan.org'
//   },
//   [NETWORK_TYPES.ALGORAND]: {
//     name: 'Algorand Mainnet',
//     symbol: 'ALGO',
//     decimals: 6,
//     rpcUrl: 'https://mainnet-api.algonode.cloud',
//     blockExplorerUrl: 'https://algoexplorer.io'
//   },
//   [NETWORK_TYPES.SOLANA]: {
//     name: 'Solana Mainnet',
//     symbol: 'SOL',
//     decimals: 9,
//     rpcUrl: 'https://rpc.ankr.com/solana',
//     fallbackRpcUrls: [
//       'https://solana-api.projectserum.com',
//       'https://api.mainnet-beta.solana.com',
//       'https://solana-mainnet.g.alchemy.com/v2/demo'
//     ],
//     blockExplorerUrl: 'https://explorer.solana.com'
//   }
// };

// // Token configurations with correct contract addresses and decimals
// export const TOKEN_CONFIG = {
//   USDT: {
//     ethereum: {
//       contractAddress: '0xdAC17F958D2ee523a2206206994597C13D831ec7',
//       decimals: 6,
//       symbol: 'USDT'
//     },
//     bsc: {
//       contractAddress: '0x55d398326f99059fF775485246999027B3197955',
//       decimals: 18,
//       symbol: 'USDT'
//     },
//     tron: {
//       contractAddress: 'TR7NHqjeKQxGTCi8q8ZY4pL8otSzgjLj6t',
//       decimals: 6,
//       symbol: 'USDT'
//     },
//     algorand: {
//       assetId: 312769,
//       decimals: 6,
//       symbol: 'USDT'
//     },
//     solana: {
//       contractAddress: 'Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB',
//       decimals: 6,
//       symbol: 'USDT'
//     }
//   },
//   USDC: {
//     ethereum: {
//       contractAddress: '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
//       decimals: 6,
//       symbol: 'USDC'
//     },
//     bsc: {
//       contractAddress: '0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d',
//       decimals: 18,
//       symbol: 'USDC'
//     },
//     tron: {
//       contractAddress: 'TEkxiTehnzSmSe2XqrBj4w32RUN966rdz8',
//       decimals: 6,
//       symbol: 'USDC'
//     },
//     algorand: {
//       assetId: 31566704,
//       decimals: 6,
//       symbol: 'USDC'
//     },
//     solana: {
//       contractAddress: 'EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v',
//       decimals: 6,
//       symbol: 'USDC'
//     }
//   },
//   BNB: {
//     bsc: {
//       decimals: 18,
//       symbol: 'BNB',
//       isNative: true
//     }
//   },
//   ETH: {
//     ethereum: {
//       decimals: 18,
//       symbol: 'ETH',
//       isNative: true
//     }
//   },
//   TRX: {
//     tron: {
//       decimals: 6,
//       symbol: 'TRX',
//       isNative: true
//     }
//   },
//   ALGO: {
//     algorand: {
//       decimals: 6,
//       symbol: 'ALGO',
//       isNative: true
//     }
//   },
//   SOL: {
//     solana: {
//       decimals: 9,
//       symbol: 'SOL',
//       isNative: true
//     }
//   }
// };

// // Network to wallet mapping - Enhanced Trust Wallet support
// export const NETWORK_WALLET_MAP = {
//   [NETWORK_TYPES.ETHEREUM]: [WALLET_TYPES.METAMASK, WALLET_TYPES.TRUST_WALLET],
//   [NETWORK_TYPES.BSC]: [WALLET_TYPES.METAMASK, WALLET_TYPES.TRUST_WALLET],
//   [NETWORK_TYPES.TRON]: [WALLET_TYPES.TRONLINK, WALLET_TYPES.TRUST_WALLET], // Trust Wallet supports TRON
//   [NETWORK_TYPES.ALGORAND]: [WALLET_TYPES.LUTE],
//   [NETWORK_TYPES.SOLANA]: [WALLET_TYPES.PHANTOM, WALLET_TYPES.TRUST_WALLET] // Trust Wallet supports Solana
// };

// // Installation URLs for wallets
// export const getWalletInstallUrl = (walletType) => {
//   const urls = {
//     [WALLET_TYPES.METAMASK]: 'https://metamask.io/download/',
//     [WALLET_TYPES.TRONLINK]: 'https://www.tronlink.org/download/',
//     [WALLET_TYPES.TRUST_WALLET]: 'https://trustwallet.com/download/',
//     [WALLET_TYPES.LUTE]: 'https://lute.app/download/',
//     [WALLET_TYPES.PHANTOM]: 'https://phantom.app/download'
//   };
//   return urls[walletType] || '';
// };

// // Helper function to create Solana connection with fallback RPC URLs
// const createSolanaConnection = async () => {
//   const config = NETWORK_CONFIG[NETWORK_TYPES.SOLANA];
//   const urls = [config.rpcUrl, ...(config.fallbackRpcUrls || [])];
  
//   for (const url of urls) {
//     try {
//       console.log(`Trying Solana RPC: ${url}`);
//       const connection = new Connection(url, 'confirmed');
      
//       // Test the connection by getting the latest blockhash
//       await connection.getLatestBlockhash();
//       console.log(`✅ Successfully connected to Solana RPC: ${url}`);
//       return connection;
//     } catch (error) {
//       console.warn(`❌ Failed to connect to ${url}:`, error.message);
//       continue;
//     }
//   }
  
//   throw new Error('Failed to connect to any Solana RPC endpoint. Please try again later.');
// };

// // Enhanced Trust Wallet detection with multiple methods
// const detectTrustWallet = () => {
//   if (typeof window === 'undefined') return false;
  
//   console.log('=== TRUST WALLET DETECTION DEBUG ===');
  
//   // Log all available ethereum providers for debugging
//   if (window.ethereum) {
//     console.log('window.ethereum exists:', {
//       isMetaMask: window.ethereum.isMetaMask,
//       isTrust: window.ethereum.isTrust,
//       isTrustWallet: window.ethereum.isTrustWallet,
//       providers: window.ethereum.providers?.length || 0,
//       chainId: window.ethereum.chainId
//     });
    
//     if (window.ethereum.providers) {
//       console.log('Multiple providers detected:', window.ethereum.providers.map(p => ({
//         isMetaMask: p.isMetaMask,
//         isTrust: p.isTrust,
//         isTrustWallet: p.isTrustWallet
//       })));
//     }
//   }
  
//   // Check for Trust Wallet specific global objects
//   console.log('Trust Wallet globals:', {
//     trustwallet: Boolean(window.trustwallet),
//     trust: Boolean(window.trust),
//     isTrustWallet: Boolean(window.isTrustWallet)
//   });
  
//   // Multiple ways to detect Trust Wallet
//   const trustDetectionMethods = [
//     // Method 1: Direct Trust Wallet identifier
//     () => {
//       const result = window.ethereum && window.ethereum.isTrust === true;
//       console.log('Method 1 (ethereum.isTrust):', result);
//       return result;
//     },
    
//     // Method 2: TrustWallet global object
//     () => {
//       const result = window.trustwallet !== undefined;
//       console.log('Method 2 (window.trustwallet):', result);
//       return result;
//     },
    
//     // Method 3: Trust Wallet mobile/extension interface
//     () => {
//       const result = window.ethereum && window.ethereum.isTrustWallet === true;
//       console.log('Method 3 (ethereum.isTrustWallet):', result);
//       return result;
//     },
    
//     // Method 4: Provider array detection
//     () => {
//       const result = window.ethereum && window.ethereum.providers && 
//             window.ethereum.providers.some(p => p.isTrust === true || p.isTrustWallet === true);
//       console.log('Method 4 (providers array):', result);
//       return result;
//     },
    
//     // Method 5: Trust Wallet as primary provider when no MetaMask
//     () => {
//       const result = window.ethereum && 
//             !window.ethereum.isMetaMask &&
//             window.ethereum.request &&
//             (window.ethereum.isTrust !== false);
//       console.log('Method 5 (primary provider, not MetaMask):', result);
//       return result;
//     },
    
//     // Method 6: Check for Trust Wallet specific methods/properties
//     () => {
//       const result = window.ethereum && (
//         typeof window.ethereum.isTrust === 'boolean' ||
//         window.ethereum._trustwallet ||
//         window.ethereum.trustWallet
//       );
//       console.log('Method 6 (Trust Wallet specific properties):', result);
//       return result;
//     },
    
//     // Method 7: User agent detection (for mobile web)
//     () => {
//       const result = /TrustWallet/i.test(navigator.userAgent);
//       console.log('Method 7 (user agent):', result);
//       return result;
//     },
    
//     // Method 8: DOM element detection
//     () => {
//       const result = document.querySelector('[data-wallet="trustwallet"]') !== null ||
//                     document.querySelector('#trustwallet-extension') !== null;
//       console.log('Method 8 (DOM elements):', result);
//       return result;
//     },
    
//     // Method 9: Check for Trust Wallet via window.trust
//     () => {
//       const result = window.trust !== undefined;
//       console.log('Method 9 (window.trust):', result);
//       return result;
//     },
    
//     // Method 10: Advanced provider detection
//     () => {
//       if (!window.ethereum) return false;
      
//       // Check if ethereum object has Trust Wallet characteristics
//       const hasTrustFeatures = (
//         // Not MetaMask and not other known wallets
//         !window.ethereum.isMetaMask &&
//         !window.ethereum.isPhantom &&
//         !window.ethereum.isFrame &&
//         // Has ethereum methods but could be Trust Wallet
//         window.ethereum.request &&
//         window.ethereum.on &&
//         // Check for Trust Wallet specific patterns
//         (window.ethereum.chainId || window.ethereum.networkVersion)
//       );
      
//       console.log('Method 10 (advanced detection):', hasTrustFeatures);
//       return hasTrustFeatures;
//     }
//   ];
  
//   const detectionResults = trustDetectionMethods.map((method, index) => {
//     try {
//       return method();
//     } catch (error) {
//       console.warn(`Trust Wallet detection method ${index + 1} failed:`, error);
//       return false;
//     }
//   });
  
//   const isDetected = detectionResults.some(result => result === true);
  
//   console.log('Detection results:', detectionResults);
//   console.log('Final Trust Wallet detection result:', isDetected);
//   console.log('=== END TRUST WALLET DETECTION DEBUG ===');
  
//   return isDetected;
// };

// // Enhanced Lute wallet detection
// const detectLuteWallet = () => {
//   if (typeof window === 'undefined') return false;
  
//   const luteDetectionMethods = [
//     () => window.lute !== undefined,
//     () => window.algorand !== undefined,
//     () => window.AlgoSigner !== undefined,
//     () => window.luteWallet !== undefined,
//     () => document.querySelector('[data-wallet="lute"]') !== null,
//     () => window.postMessage && document.documentElement.getAttribute('data-lute-extension') === 'true'
//   ];
  
//   return luteDetectionMethods.some(method => {
//     try {
//       return method();
//     } catch (error) {
//       console.warn('Lute detection method failed:', error);
//       return false;
//     }
//   });
// };

// // Enhanced Phantom wallet detection
// const detectPhantomWallet = () => {
//   if (typeof window === 'undefined') return false;
  
//   const phantomDetectionMethods = [
//     () => window.solana && window.solana.isPhantom,
//     () => window.phantom && window.phantom.solana,
//     () => window.phantomWallet !== undefined,
//     () => document.querySelector('[data-wallet="phantom"]') !== null
//   ];
  
//   return phantomDetectionMethods.some(method => {
//     try {
//       return method();
//     } catch (error) {
//       console.warn('Phantom detection method failed:', error);
//       return false;
//     }
//   });
// };

// // Enhanced MetaMask detection (to avoid conflicts with Trust Wallet)
// const detectMetamaskWallet = () => {
//   if (typeof window === 'undefined') return false;
  
//   try {
//     // Ensure it's MetaMask and not Trust Wallet or other wallets
//     return window.ethereum !== undefined && 
//            window.ethereum.isMetaMask === true &&
//            window.ethereum.isTrust !== true &&
//            window.ethereum.isTrustWallet !== true;
//   } catch (error) {
//     console.warn('MetaMask detection failed:', error);
//     return false;
//   }
// };

// // Detect available wallets in the browser - Enhanced Trust Wallet detection
// export const detectWallets = () => {
//   const availableWallets = {
//     [WALLET_TYPES.METAMASK]: detectMetamaskWallet(),
//     [WALLET_TYPES.TRONLINK]: typeof window !== 'undefined' && window.tronWeb !== undefined,
//     [WALLET_TYPES.TRUST_WALLET]: detectTrustWallet(),
//     [WALLET_TYPES.LUTE]: detectLuteWallet(),
//     [WALLET_TYPES.PHANTOM]: detectPhantomWallet()
//   };
  
//   // Enhanced logging for wallet detection
//   if (typeof window !== 'undefined') {
//     console.log('=== WALLET DETECTION DEBUG ===');
//     console.log('MetaMask:', availableWallets[WALLET_TYPES.METAMASK]);
//     console.log('TronLink:', availableWallets[WALLET_TYPES.TRONLINK]);
//     console.log('Trust Wallet:', availableWallets[WALLET_TYPES.TRUST_WALLET]);
//     console.log('Lute:', availableWallets[WALLET_TYPES.LUTE]);
//     console.log('Phantom:', availableWallets[WALLET_TYPES.PHANTOM]);
    
//     // Additional Trust Wallet debugging
//     if (window.ethereum) {
//       console.log('Ethereum provider details:', {
//         isMetaMask: window.ethereum.isMetaMask,
//         isTrust: window.ethereum.isTrust,
//         isTrustWallet: window.ethereum.isTrustWallet,
//         providers: window.ethereum.providers?.length || 0
//       });
//     }
    
//     console.log('=== END WALLET DETECTION DEBUG ===');
//   }
  
//   return availableWallets;
// };

// // Detect wallets with retry and enhanced detection
// export const detectWalletsWithRetry = async (maxRetries = 5, delay = 1000) => {
//   let retries = 0;
//   let wallets = detectWallets();
  
//   while (retries < maxRetries) {
//     wallets = detectWallets();
    
//     const hasAnyWallet = Object.values(wallets).some(v => v === true);
    
//     if (hasAnyWallet || retries >= maxRetries - 1) {
//       break;
//     }
    
//     console.log(`Wallet detection attempt ${retries + 1}/${maxRetries}...`);
//     console.log('Current detection results:', wallets);
    
//     await new Promise(resolve => setTimeout(resolve, delay));
//     retries++;
//   }
  
//   // Final check with extended detection
//   if (!wallets[WALLET_TYPES.TRUST_WALLET] || !wallets[WALLET_TYPES.LUTE] || !wallets[WALLET_TYPES.PHANTOM]) {
//     console.log('Performing extended wallet detection...');
    
//     if (typeof window !== 'undefined') {
//       try {
//         // Dispatch custom events that might trigger wallet injection
//         const events = [
//           new CustomEvent('trust-wallet-detect', { detail: { source: 'coinley-sdk' } }),
//           new CustomEvent('lute-wallet-detect', { detail: { source: 'coinley-sdk' } }),
//           new CustomEvent('phantom-wallet-detect', { detail: { source: 'coinley-sdk' } })
//         ];
        
//         events.forEach(event => window.dispatchEvent(event));
        
//         await new Promise(resolve => setTimeout(resolve, 500));
        
//         // Re-detect
//         wallets[WALLET_TYPES.TRUST_WALLET] = detectTrustWallet();
//         wallets[WALLET_TYPES.LUTE] = detectLuteWallet();
//         wallets[WALLET_TYPES.PHANTOM] = detectPhantomWallet();
//       } catch (error) {
//         console.warn('Extended wallet detection failed:', error);
//       }
//     }
//   }
  
//   console.log('Final wallet detection results:', wallets);
//   return wallets;
// };

// // Debug wallet environment - Enhanced Trust Wallet debugging
// export const debugWalletEnvironment = () => {
//   console.log('=== WALLET ENVIRONMENT DEBUG ===');
//   console.log('ethereum:', typeof window !== 'undefined' ? Boolean(window.ethereum) : 'Not in browser');
//   console.log('tronWeb:', typeof window !== 'undefined' ? Boolean(window.tronWeb) : 'Not in browser');
//   console.log('lute:', typeof window !== 'undefined' ? Boolean(window.lute) : 'Not in browser');
//   console.log('algorand:', typeof window !== 'undefined' ? Boolean(window.algorand) : 'Not in browser');
//   console.log('AlgoSigner:', typeof window !== 'undefined' ? Boolean(window.AlgoSigner) : 'Not in browser');
//   console.log('solana:', typeof window !== 'undefined' ? Boolean(window.solana) : 'Not in browser');
//   console.log('phantom:', typeof window !== 'undefined' ? Boolean(window.phantom) : 'Not in browser');
//   console.log('trustwallet:', typeof window !== 'undefined' ? Boolean(window.trustwallet) : 'Not in browser');
//   console.log('trust:', typeof window !== 'undefined' ? Boolean(window.trust) : 'Not in browser');
  
//   if (typeof window !== 'undefined' && window.ethereum) {
//     console.log('ethereum details:', {
//       isMetaMask: window.ethereum.isMetaMask,
//       isTrust: window.ethereum.isTrust,
//       isTrustWallet: window.ethereum.isTrustWallet,
//       chainId: window.ethereum.chainId,
//       providers: window.ethereum.providers?.length || 0,
//       selectedAddress: window.ethereum.selectedAddress
//     });
    
//     // Log all providers if multiple exist
//     if (window.ethereum.providers && window.ethereum.providers.length > 0) {
//       console.log('All providers:');
//       window.ethereum.providers.forEach((provider, index) => {
//         console.log(`Provider ${index}:`, {
//           isMetaMask: provider.isMetaMask,
//           isTrust: provider.isTrust,
//           isTrustWallet: provider.isTrustWallet,
//           selectedAddress: provider.selectedAddress
//         });
//       });
//     }
//   }
  
//   if (typeof window !== 'undefined' && window.tronWeb) {
//     console.log('tronWeb details:', {
//       ready: window.tronWeb.ready,
//       fullNode: window.tronWeb.fullNode?.host,
//       defaultAddress: window.tronWeb.defaultAddress,
//       isTrust: window.tronWeb.isTrust
//     });
//   }
  
//   if (typeof window !== 'undefined' && window.solana) {
//     console.log('solana details:', {
//       isPhantom: window.solana.isPhantom,
//       isTrust: window.solana.isTrust,
//       publicKey: window.solana.publicKey?.toString(),
//       isConnected: window.solana.isConnected
//     });
//   }
  
//   if (typeof window !== 'undefined') {
//     console.log('All window wallet properties:');
//     const walletProps = Object.keys(window).filter(key => 
//       key.toLowerCase().includes('lute') || 
//       key.toLowerCase().includes('algo') || 
//       key.toLowerCase().includes('wallet') ||
//       key.toLowerCase().includes('phantom') ||
//       key.toLowerCase().includes('solana') ||
//       key.toLowerCase().includes('trust') ||
//       key.toLowerCase().includes('metamask')
//     );
//     console.log('Potential wallet properties:', walletProps);
    
//     // Check for Trust Wallet specific injections
//     console.log('Trust Wallet specific checks:', {
//       'window.trustwallet': Boolean(window.trustwallet),
//       'window.trust': Boolean(window.trust),
//       'window.isTrustWallet': Boolean(window.isTrustWallet),
//       'document trust elements': document.querySelectorAll('[id*="trust"], [class*="trust"]').length
//     });
//   }
  
//   // Run detection methods and show results
//   console.log('=== DETECTION RESULTS ===');
//   const wallets = detectWallets();
//   console.log('Final detection results:', wallets);
  
//   // Run Trust Wallet specific detection
//   console.log('Trust Wallet specific detection result:', detectTrustWallet());
  
//   console.log('=== END WALLET ENVIRONMENT DEBUG ===');
  
//   // Return debug info for external use
//   return {
//     wallets,
//     ethereum: typeof window !== 'undefined' ? window.ethereum : null,
//     trustWalletDetected: typeof window !== 'undefined' ? detectTrustWallet() : false
//   };
// };

// // Connect to MetaMask wallet
// const connectMetamaskWallet = async () => {
//   console.log('Connecting to MetaMask wallet...');
  
//   if (!window.ethereum || !window.ethereum.isMetaMask || window.ethereum.isTrust === true) {
//     console.error('MetaMask not found or Trust Wallet detected instead.');
//     throw new Error('MetaMask not detected. Please install MetaMask extension.');
//   }
  
//   try {
//     const accounts = await window.ethereum.request({ method: 'eth_requestAccounts' });
    
//     if (!accounts || accounts.length === 0) {
//       throw new Error('No accounts found');
//     }
    
//     const address = accounts[0];
//     const chainIdHex = await window.ethereum.request({ method: 'eth_chainId' });
//     const chainId = parseInt(chainIdHex, 16);
    
//     let networkType;
//     switch (chainId) {
//       case 1: networkType = NETWORK_TYPES.ETHEREUM; break;
//       case 56: networkType = NETWORK_TYPES.BSC; break;
//       default: networkType = `unknown-${chainId}`;
//     }
    
//     const web3Provider = new ethers.BrowserProvider(window.ethereum);
    
//     return {
//       walletType: WALLET_TYPES.METAMASK,
//       address,
//       provider: web3Provider,
//       network: networkType,
//       isConnected: true,
//       chainId
//     };
//   } catch (error) {
//     console.error('Error connecting to MetaMask:', error);
//     throw error;
//   }
// };

// // Enhanced Trust Wallet connection with AGGRESSIVE connection strategies
// const connectTrustWallet = async (targetNetwork = null) => {
//   console.log('=== TRUST WALLET CONNECTION DEBUG ===');
//   console.log('Connecting to Trust Wallet for network:', targetNetwork);
  
//   let networkType = targetNetwork || NETWORK_TYPES.ETHEREUM;
  
//   try {
//     // For Ethereum and BSC networks
//     if (networkType === NETWORK_TYPES.ETHEREUM || networkType === NETWORK_TYPES.BSC) {
//       if (!window.ethereum) {
//         throw new Error('No Ethereum provider found. Please install Trust Wallet browser extension.');
//       }
      
//       console.log('Available ethereum details:', {
//         isMetaMask: window.ethereum.isMetaMask,
//         isTrust: window.ethereum.isTrust,
//         isTrustWallet: window.ethereum.isTrustWallet,
//         providers: window.ethereum.providers?.length || 0,
//         selectedAddress: window.ethereum.selectedAddress
//       });
      
//       // AGGRESSIVE STRATEGY: Try every possible provider until one works
//       const providersToTry = [];
      
//       // Add all possible providers to the list
//       if (window.ethereum.providers && window.ethereum.providers.length > 0) {
//         // Add all providers from the providers array
//         providersToTry.push(...window.ethereum.providers);
//         console.log(`Found ${window.ethereum.providers.length} providers in array`);
//       } else {
//         // Add the main ethereum provider
//         providersToTry.push(window.ethereum);
//         console.log('Using main ethereum provider');
//       }
      
//       // Also add any other potential Trust Wallet providers
//       if (window.trustwallet?.ethereum) {
//         providersToTry.push(window.trustwallet.ethereum);
//         console.log('Added trustwallet.ethereum provider');
//       }
      
//       console.log(`Total providers to try: ${providersToTry.length}`);
      
//       // Try each provider until one works
//       let successfulProvider = null;
//       let accounts = null;
//       let lastError = null;
      
//       for (let i = 0; i < providersToTry.length; i++) {
//         const provider = providersToTry[i];
//         console.log(`\n🔍 Trying provider ${i + 1}/${providersToTry.length}:`, {
//           isMetaMask: provider.isMetaMask,
//           isTrust: provider.isTrust,
//           isTrustWallet: provider.isTrustWallet,
//           selectedAddress: provider.selectedAddress
//         });
        
//         try {
//           // Try to connect to this provider
//           console.log(`📞 Requesting accounts from provider ${i + 1}...`);
//           const testAccounts = await provider.request({ 
//             method: 'eth_requestAccounts' 
//           });
          
//           if (testAccounts && testAccounts.length > 0) {
//             console.log(`✅ Provider ${i + 1} worked! Got ${testAccounts.length} accounts`);
//             console.log(`📝 First account: ${testAccounts[0]}`);
            
//             successfulProvider = provider;
//             accounts = testAccounts;
            
//             // If this provider is NOT MetaMask, prefer it (likely Trust Wallet)
//             if (!provider.isMetaMask) {
//               console.log(`🎯 Provider ${i + 1} is not MetaMask - using this one!`);
//               break;
//             } else {
//               console.log(`⚠️ Provider ${i + 1} is MetaMask - will use it if no other works`);
//               // Continue looking for non-MetaMask providers, but keep this as backup
//             }
//           } else {
//             console.log(`❌ Provider ${i + 1} returned no accounts`);
//           }
//         } catch (providerError) {
//           console.log(`❌ Provider ${i + 1} failed:`, providerError.message);
//           lastError = providerError;
          
//           // If user rejected, don't try other providers
//           if (providerError.code === 4001) {
//             console.log('🛑 User rejected connection - stopping attempts');
//             throw new Error('Connection rejected by user. Please approve the connection in your wallet.');
//           }
          
//           continue;
//         }
//       }
      
//       // Check if we got a successful connection
//       if (!successfulProvider || !accounts || accounts.length === 0) {
//         console.error('❌ All providers failed');
        
//         if (lastError) {
//           if (lastError.code === 4001) {
//             throw new Error('Connection rejected by user. Please approve the connection in your wallet.');
//           } else {
//             throw new Error(`Connection failed: ${lastError.message}. Please make sure your wallet is unlocked and try again.`);
//           }
//         } else {
//           throw new Error('No wallet accounts found. Please make sure Trust Wallet is unlocked and has at least one account.');
//         }
//       }
      
//       console.log('\n🎉 Successfully connected!');
//       console.log('Using provider:', {
//         isMetaMask: successfulProvider.isMetaMask,
//         isTrust: successfulProvider.isTrust,
//         isTrustWallet: successfulProvider.isTrustWallet
//       });
      
//       const address = accounts[0];
//       let chainIdHex, chainId;
      
//       try {
//         chainIdHex = await successfulProvider.request({ method: 'eth_chainId' });
//         chainId = parseInt(chainIdHex, 16);
//         console.log('Chain ID:', chainId);
//       } catch (chainError) {
//         console.warn('Could not get chain ID:', chainError);
//         chainId = 1; // Default to Ethereum mainnet
//       }
      
//       // Determine actual network based on chain ID
//       switch (chainId) {
//         case 1: networkType = NETWORK_TYPES.ETHEREUM; break;
//         case 56: networkType = NETWORK_TYPES.BSC; break;
//         default: networkType = `unknown-${chainId}`;
//       }
      
//       const web3Provider = new ethers.BrowserProvider(successfulProvider);
      
//       console.log('✅ Trust Wallet connected successfully:', {
//         address,
//         network: networkType,
//         chainId
//       });
//       console.log('=== END TRUST WALLET CONNECTION DEBUG ===');
      
//       return {
//         walletType: WALLET_TYPES.TRUST_WALLET,
//         address,
//         provider: web3Provider,
//         network: networkType,
//         isConnected: true,
//         chainId,
//         nativeProvider: successfulProvider
//       };
//     }
    
//     // For TRON network
//     else if (networkType === NETWORK_TYPES.TRON) {
//       if (!window.tronWeb) {
//         throw new Error('TronWeb not found. Please install Trust Wallet with TRON support or use Trust Wallet mobile app.');
//       }
      
//       const waitForTronWeb = async (maxAttempts = 10, interval = 500) => {
//         for (let attempt = 0; attempt < maxAttempts; attempt++) {
//           if (window.tronWeb && window.tronWeb.ready) {
//             return window.tronWeb;
//           }
//           console.log(`Waiting for TronWeb to be ready... Attempt ${attempt + 1}/${maxAttempts}`);
//           await new Promise(resolve => setTimeout(resolve, interval));
//         }
//         throw new Error('TronWeb took too long to be ready');
//       };
      
//       const tronWeb = await waitForTronWeb();
      
//       if (!tronWeb.defaultAddress || !tronWeb.defaultAddress.base58) {
//         try {
//           await window.tronWeb.request({ method: 'tron_requestAccounts' });
//         } catch (permissionError) {
//           console.error('Failed to get permission from Trust Wallet TRON:', permissionError);
//           throw new Error('Please unlock Trust Wallet and approve TRON connection');
//         }
//       }
      
//       const address = tronWeb.defaultAddress.base58;
//       console.log('Connected to Trust Wallet TRON:', address);
      
//       return {
//         walletType: WALLET_TYPES.TRUST_WALLET,
//         address: address,
//         provider: tronWeb,
//         network: NETWORK_TYPES.TRON,
//         isConnected: true,
//         nativeProvider: tronWeb
//       };
//     }
    
//     // For Solana network
//     else if (networkType === NETWORK_TYPES.SOLANA) {
//       let solanaProvider = null;
      
//       if (window.solana && window.solana.isTrust === true) {
//         solanaProvider = window.solana;
//       } else if (window.trustwallet && window.trustwallet.solana) {
//         solanaProvider = window.trustwallet.solana;
//       } else if (window.solana && !window.solana.isPhantom) {
//         // Could be Trust Wallet if not Phantom
//         solanaProvider = window.solana;
//       }
      
//       if (!solanaProvider) {
//         throw new Error('Trust Wallet Solana provider not found. Please install Trust Wallet with Solana support or use Trust Wallet mobile app.');
//       }
      
//       console.log('Found Trust Wallet Solana provider');
      
//       const response = await solanaProvider.connect();
      
//       if (!response || !response.publicKey) {
//         throw new Error('No public key returned from Trust Wallet Solana');
//       }
      
//       const address = response.publicKey.toString();
//       console.log('Connected to Trust Wallet Solana:', address);
      
//       return {
//         walletType: WALLET_TYPES.TRUST_WALLET,
//         address: address,
//         provider: solanaProvider,
//         network: NETWORK_TYPES.SOLANA,
//         isConnected: true,
//         publicKey: response.publicKey,
//         nativeProvider: solanaProvider
//       };
//     }
    
//     else {
//       throw new Error(`Trust Wallet does not support network: ${networkType}`);
//     }
    
//   } catch (error) {
//     console.error('=== TRUST WALLET CONNECTION ERROR ===');
//     console.error('Error details:', error);
//     console.log('=== END TRUST WALLET CONNECTION DEBUG ===');
    
//     // Don't modify user rejection errors
//     if (error.code === 4001 || error.message.includes('rejected by user')) {
//       throw error;
//     } else if (error.message.includes('locked')) {
//       throw new Error('Trust Wallet is locked. Please unlock your wallet and try again.');
//     } else {
//       throw error;
//     }
//   }
// };

// // Connect to TronLink wallet
// const connectTronlinkWallet = async () => {
//   console.log('Connecting to TronLink wallet...');
  
//   if (!window.tronWeb) {
//     console.error('TronWeb not found. Is TronLink installed?');
//     throw new Error('TronLink not detected. Please install TronLink extension.');
//   }
  
//   // Make sure this is TronLink and not Trust Wallet
//   if (window.tronWeb.isTrust === true) {
//     throw new Error('Trust Wallet TRON detected instead of TronLink. Please switch to TronLink or use Trust Wallet option.');
//   }
  
//   const waitForTronWeb = async (maxAttempts = 10, interval = 500) => {
//     for (let attempt = 0; attempt < maxAttempts; attempt++) {
//       if (window.tronWeb && window.tronWeb.ready) {
//         return window.tronWeb;
//       }
//       console.log(`Waiting for TronWeb to be ready... Attempt ${attempt + 1}/${maxAttempts}`);
//       await new Promise(resolve => setTimeout(resolve, interval));
//     }
//     throw new Error('TronWeb took too long to be ready');
//   };
  
//   try {
//     const tronWeb = await waitForTronWeb();
    
//     if (!tronWeb.defaultAddress || !tronWeb.defaultAddress.base58) {
//       try {
//         await window.tronWeb.request({ method: 'tron_requestAccounts' });
//       } catch (permissionError) {
//         console.error('Failed to get permission from TronLink:', permissionError);
//         throw new Error('Please unlock TronLink and approve connection');
//       }
//     }
    
//     const address = tronWeb.defaultAddress.base58;
//     console.log('Connected to TronLink wallet:', address);
    
//     return {
//       walletType: WALLET_TYPES.TRONLINK,
//       address: address,
//       provider: tronWeb,
//       network: NETWORK_TYPES.TRON,
//       isConnected: true
//     };
//   } catch (error) {
//     console.error('Error connecting to TronLink:', error);
//     throw error;
//   }
// };

// // Enhanced Lute wallet connection with multiple detection methods
// const connectLuteWallet = async () => {
//   console.log('Connecting to Lute wallet...');
  
//   let walletProvider = null;
//   let walletName = '';
  
//   if (window.lute) {
//     walletProvider = window.lute;
//     walletName = 'Lute';
//   } else if (window.algorand) {
//     walletProvider = window.algorand;
//     walletName = 'Algorand Provider';
//   } else if (window.AlgoSigner) {
//     walletProvider = window.AlgoSigner;
//     walletName = 'AlgoSigner';
//   } else if (window.luteWallet) {
//     walletProvider = window.luteWallet;
//     walletName = 'Lute Wallet';
//   }
  
//   if (!walletProvider) {
//     console.error('No Algorand wallet detected.');
//     console.log('Available window properties:', Object.keys(window).filter(key => 
//       key.toLowerCase().includes('lute') || 
//       key.toLowerCase().includes('algo') || 
//       key.toLowerCase().includes('wallet')
//     ));
//     throw new Error('Lute wallet not detected. Please install Lute extension or another Algorand wallet.');
//   }
  
//   console.log(`Found ${walletName} wallet provider:`, walletProvider);
  
//   try {
//     let address = null;
    
//     if (walletProvider.connect) {
//       console.log('Using connect() method...');
//       const result = await walletProvider.connect();
//       address = result.address || result;
//     }
//     else if (walletProvider.enable) {
//       console.log('Using enable() method...');
//       const accounts = await walletProvider.enable();
//       address = accounts[0] || accounts;
//     }
//     else if (walletProvider.requestAccounts) {
//       console.log('Using requestAccounts() method...');
//       const accounts = await walletProvider.requestAccounts();
//       address = accounts[0];
//     }
//     else if (walletProvider.connect && walletName === 'AlgoSigner') {
//       console.log('Using AlgoSigner connect...');
//       await walletProvider.connect();
//       const accounts = await walletProvider.accounts({ ledger: 'MainNet' });
//       address = accounts[0]?.address;
//     }
    
//     if (!address) {
//       throw new Error(`No address returned from ${walletName}. Please unlock your wallet and try again.`);
//     }
    
//     console.log(`Connected to ${walletName} wallet:`, address);
    
//     return {
//       walletType: WALLET_TYPES.LUTE,
//       address: address,
//       provider: walletProvider,
//       network: NETWORK_TYPES.ALGORAND,
//       isConnected: true,
//       walletName: walletName
//     };
//   } catch (error) {
//     console.error(`Error connecting to ${walletName}:`, error);
    
//     if (error.message && error.message.includes('User rejected')) {
//       throw new Error('Connection rejected by user. Please approve the connection in your wallet.');
//     } else if (error.message && error.message.includes('locked')) {
//       throw new Error('Wallet is locked. Please unlock your wallet and try again.');
//     } else {
//       throw new Error(`Failed to connect to ${walletName}: ${error.message || 'Unknown error'}`);
//     }
//   }
// };

// // Connect to Phantom wallet
// const connectPhantomWallet = async () => {
//   console.log('Connecting to Phantom wallet...');
  
//   let phantomProvider = null;
  
//   if (window.solana && window.solana.isPhantom) {
//     phantomProvider = window.solana;
//   } else if (window.phantom && window.phantom.solana) {
//     phantomProvider = window.phantom.solana;
//   }
  
//   if (!phantomProvider) {
//     console.error('Phantom wallet not found.');
//     console.log('Available Solana providers:', {
//       'window.solana': Boolean(window.solana),
//       'window.phantom': Boolean(window.phantom),
//       'window.solana.isPhantom': window.solana?.isPhantom
//     });
//     throw new Error('Phantom wallet not detected. Please install Phantom extension.');
//   }
  
//   // Make sure this is Phantom and not Trust Wallet
//   if (phantomProvider.isTrust === true) {
//     throw new Error('Trust Wallet Solana detected instead of Phantom. Please switch to Phantom or use Trust Wallet option.');
//   }
  
//   console.log('Found Phantom wallet provider:', phantomProvider);
  
//   try {
//     const response = await phantomProvider.connect();
    
//     if (!response || !response.publicKey) {
//       throw new Error('No public key returned from Phantom');
//     }
    
//     const address = response.publicKey.toString();
//     console.log('Connected to Phantom wallet:', address);
    
//     return {
//       walletType: WALLET_TYPES.PHANTOM,
//       address: address,
//       provider: phantomProvider,
//       network: NETWORK_TYPES.SOLANA,
//       isConnected: true,
//       publicKey: response.publicKey
//     };
//   } catch (error) {
//     console.error('Error connecting to Phantom:', error);
    
//     if (error.code === 4001) {
//       throw new Error('Connection rejected by user. Please approve the connection in Phantom.');
//     } else if (error.message && error.message.includes('User rejected')) {
//       throw new Error('Connection rejected by user. Please approve the connection in Phantom.');
//     } else {
//       throw new Error(`Failed to connect to Phantom: ${error.message || 'Unknown error'}`);
//     }
//   }
// };

// // General wallet connection function - Enhanced with Trust Wallet
// export const connectWallet = async (walletType, targetNetwork = null) => {
//   console.log('Connecting to wallet:', walletType, 'for network:', targetNetwork);
  
//   switch (walletType) {
//     case WALLET_TYPES.METAMASK:
//       return connectMetamaskWallet();
//     case WALLET_TYPES.TRONLINK:
//       return connectTronlinkWallet();
//     case WALLET_TYPES.TRUST_WALLET:
//       return connectTrustWallet(targetNetwork);
//     case WALLET_TYPES.LUTE:
//       return connectLuteWallet();
//     case WALLET_TYPES.PHANTOM:
//       return connectPhantomWallet();
//     default:
//       throw new Error(`Unsupported wallet type: ${walletType}`);
//   }
// };

// // Get supported wallets for a network
// export const getSupportedWalletsForNetwork = (network) => {
//   return NETWORK_WALLET_MAP[network] || [];
// };

// // Send native currency transaction - Enhanced for Trust Wallet
// export const sendNativeTransaction = async (walletConnection, toAddress, amount) => {
//   console.log('Sending native transaction:', { toAddress, amount, walletType: walletConnection.walletType });
  
//   if (!walletConnection || !walletConnection.provider) {
//     throw new Error('Wallet not connected');
//   }
  
//   if (!toAddress) {
//     throw new Error('Recipient address not provided');
//   }
  
//   if (!amount || isNaN(parseFloat(amount)) || parseFloat(amount) <= 0) {
//     throw new Error('Invalid amount');
//   }
  
//   try {
//     let transaction;
    
//     switch (walletConnection.walletType) {
//       case WALLET_TYPES.METAMASK:
//       case WALLET_TYPES.TRUST_WALLET: // Trust Wallet uses same EVM interface as MetaMask
//         const provider = walletConnection.provider;
//         const signer = await provider.getSigner();
        
//         const amountInEther = amount.toString();
//         const amountWei = ethers.parseEther(amountInEther);
        
//         console.log(`Sending ${walletConnection.walletType} ETH/BNB:`, {
//           to: toAddress,
//           value: amountWei.toString()
//         });
        
//         const gasEstimate = await provider.estimateGas({
//           to: toAddress,
//           value: amountWei,
//           from: await signer.getAddress()
//         });
        
//         console.log('Gas estimate:', gasEstimate.toString());
        
//         const gasLimit = (gasEstimate * BigInt(110)) / BigInt(100);
        
//         console.log('Using gas limit:', gasLimit.toString());
        
//         transaction = await signer.sendTransaction({
//           to: toAddress,
//           value: amountWei,
//           gasLimit: gasLimit
//         });
//         break;
        
//       case WALLET_TYPES.TRONLINK:
//         const tronWeb = walletConnection.provider;
        
//         if (!tronWeb || !tronWeb.ready) {
//           throw new Error('TronWeb not initialized');
//         }
        
//         const amountSun = tronWeb.toSun(amount.toString());
        
//         console.log('Sending TRX:', {
//           to: toAddress,
//           value: amountSun
//         });
        
//         transaction = await tronWeb.trx.sendTransaction(
//           toAddress,
//           amountSun
//         );
//         break;
        
//       case WALLET_TYPES.LUTE:
//         const algorandProvider = walletConnection.provider;
        
//         const microAlgos = Math.floor(parseFloat(amount) * 1000000);
        
//         console.log('Sending Algos:', {
//           to: toAddress,
//           amount: microAlgos,
//           walletName: walletConnection.walletName
//         });
        
//         if (algorandProvider.sendPayment) {
//           transaction = await algorandProvider.sendPayment({
//             recipient: toAddress,
//             amount: microAlgos
//           });
//         } else if (algorandProvider.signTransaction) {
//           const txn = {
//             to: toAddress,
//             fee: 1000,
//             amount: microAlgos,
//             firstRound: 1000,
//             lastRound: 2000,
//             type: 'pay'
//           };
//           transaction = await algorandProvider.signTransaction(txn);
//         } else {
//           throw new Error(`Unsupported Algorand wallet API for ${walletConnection.walletName}`);
//         }
//         break;
        
//       case WALLET_TYPES.PHANTOM:
//         const phantomProvider = walletConnection.provider;
        
//         if (!phantomProvider || !phantomProvider.isConnected) {
//           throw new Error('Phantom wallet not connected');
//         }
        
//         const amountFloat = parseFloat(amount);
        
//         console.log('Phantom SOL Transaction Debug:', {
//           originalAmount: amount,
//           amountFloat: amountFloat,
//           walletType: 'Phantom Native SOL'
//         });
        
//         try {
//           const connection = await createSolanaConnection();
//           const fromPubkey = walletConnection.publicKey;
//           const toPubkey = new PublicKey(toAddress);
          
//           const lamports = Math.floor(amountFloat * LAMPORTS_PER_SOL);
          
//           console.log('Solana native transaction:', {
//             from: fromPubkey.toString(),
//             to: toAddress,
//             amountSOL: amountFloat,
//             lamports: lamports,
//             conversionCheck: `${amountFloat} SOL = ${lamports} lamports`
//           });
          
//           if (lamports <= 0) {
//             throw new Error(`Invalid amount: ${amountFloat} SOL converts to ${lamports} lamports`);
//           }
          
//           const transferTransaction = new Transaction().add(
//             SystemProgram.transfer({
//               fromPubkey,
//               toPubkey,
//               lamports
//             })
//           );
          
//           const { blockhash } = await connection.getLatestBlockhash();
//           transferTransaction.recentBlockhash = blockhash;
//           transferTransaction.feePayer = fromPubkey;
          
//           const signedTransaction = await phantomProvider.signAndSendTransaction(transferTransaction);
//           transaction = signedTransaction;
          
//         } catch (phantomError) {
//           console.error('Phantom transaction error:', phantomError);
//           throw new Error(`Phantom transaction failed: ${phantomError.message || 'Unknown error'}`);
//         }
//         break;
        
//       default:
//         throw new Error(`Unsupported wallet type: ${walletConnection.walletType}`);
//     }
    
//     console.log('Transaction sent:', transaction);
    
//     const hash = transaction.hash || transaction.signature || transaction.txID || transaction.txId || transaction;
//     console.log('Transaction hash:', hash);
//     return hash;
//   } catch (error) {
//     console.error('Native transaction error:', error);
//     throw error;
//   }
// };

// // Helper function to validate transaction amounts before sending
// const validateTransactionAmount = (amount, currency, network) => {
//   const amountFloat = parseFloat(amount);
  
//   console.log('=== TRANSACTION AMOUNT VALIDATION ===');
//   console.log('Amount:', amountFloat);
//   console.log('Currency:', currency);
//   console.log('Network:', network);
  
//   if (currency === 'SOL' && amountFloat > 1) {
//     const estimatedUSDValue = amountFloat * 100;
//     console.warn(`⚠️ Large SOL transaction: ${amountFloat} SOL (~$${estimatedUSDValue})`);
//     return {
//       isLarge: true,
//       warning: `You are about to send ${amountFloat} SOL (approximately $${estimatedUSDValue}). Please confirm this is correct.`
//     };
//   }
  
//   if (['USDC', 'USDT'].includes(currency) && amountFloat > 100) {
//     console.warn(`⚠️ Large stablecoin transaction: ${amountFloat} ${currency}`);
//     return {
//       isLarge: true,
//       warning: `You are about to send ${amountFloat} ${currency}. Please confirm this is correct.`
//     };
//   }
  
//   console.log('✅ Transaction amount looks reasonable');
//   console.log('=== END TRANSACTION AMOUNT VALIDATION ===');
  
//   return { isLarge: false };
// };

// // Send transaction - main function
// export const sendTransaction = async (walletConnection, transactionDetails) => {
//   console.log('=== SEND TRANSACTION DEBUG ===');
//   console.log('Wallet connection:', walletConnection);
//   console.log('Transaction details:', transactionDetails);
  
//   if (!walletConnection) {
//     throw new Error('Wallet not connected');
//   }
  
//   const { to, amount, tokenAddress, currency, network } = transactionDetails;
  
//   if (!to) {
//     throw new Error('Recipient address not provided');
//   }
  
//   const validation = validateTransactionAmount(amount, currency, network);
//   if (validation.isLarge) {
//     console.warn('Large transaction warning:', validation.warning);
//   }
  
//   const tokenConfig = TOKEN_CONFIG[currency]?.[network];
  
//   console.log('Token config lookup:', {
//     currency,
//     network,
//     tokenConfig,
//     isNative: tokenConfig?.isNative
//   });
  
//   if (tokenConfig && tokenConfig.isNative) {
//     console.log('Sending native currency transaction');
//     return sendNativeTransaction(walletConnection, to, amount);
//   } else if (tokenConfig) {
//     console.log('Sending token transaction');
//     return sendTokenTransaction(walletConnection, tokenConfig, to, amount);
//   } else {
//     console.log('No token config found, defaulting to native transaction');
//     return sendNativeTransaction(walletConnection, to, amount);
//   }
// };

// // Send token transaction - Enhanced for Trust Wallet
// export const sendTokenTransaction = async (walletConnection, tokenConfig, toAddress, amount) => {
//   console.log('Sending token transaction with:', { tokenConfig, toAddress, amount, walletType: walletConnection.walletType });
  
//   if (!walletConnection || !walletConnection.provider) {
//     throw new Error('Wallet not connected');
//   }
  
//   if (!tokenConfig) {
//     throw new Error('Token configuration not provided');
//   }
  
//   if (!toAddress) {
//     throw new Error('Recipient address not provided');
//   }

//   if (!amount || isNaN(parseFloat(amount)) || parseFloat(amount) <= 0) {
//     throw new Error('Invalid amount');
//   }

//   const { contractAddress, decimals, symbol } = tokenConfig;
//   console.log(`Token: ${symbol}, Decimals: ${decimals}, Contract: ${contractAddress}`);
  
//   switch (walletConnection.walletType) {
//     case WALLET_TYPES.TRONLINK:
//       return sendTRC20Transaction(walletConnection, tokenConfig, toAddress, amount);
//     case WALLET_TYPES.LUTE:
//       return sendAlgorandAssetTransaction(walletConnection, tokenConfig, toAddress, amount);
//     case WALLET_TYPES.PHANTOM:
//       return sendSolanaTokenTransaction(walletConnection, tokenConfig, toAddress, amount);
//     case WALLET_TYPES.TRUST_WALLET:
//       // Trust Wallet can handle multiple network types
//       if (walletConnection.network === NETWORK_TYPES.SOLANA) {
//         return sendSolanaTokenTransaction(walletConnection, tokenConfig, toAddress, amount);
//       } else if (walletConnection.network === NETWORK_TYPES.TRON) {
//         return sendTRC20Transaction(walletConnection, tokenConfig, toAddress, amount);
//       } else {
//         // Default to ERC20/BEP20 for Ethereum and BSC
//         return sendERC20Transaction(walletConnection, tokenConfig, toAddress, amount);
//       }
//     default:
//       return sendERC20Transaction(walletConnection, tokenConfig, toAddress, amount);
//   }
// };

// // Solana token transaction function
// export const sendSolanaTokenTransaction = async (walletConnection, tokenConfig, toAddress, amount) => {
//   console.log('=== SOLANA TOKEN TRANSACTION DEBUG ===');
//   console.log('Input params:', { tokenConfig, toAddress, amount });
  
//   if (!walletConnection || !walletConnection.provider) {
//     throw new Error('Solana wallet not connected');
//   }
  
//   const solanaProvider = walletConnection.provider;
  
//   if (!solanaProvider || !solanaProvider.isConnected) {
//     throw new Error('Solana wallet not connected');
//   }
  
//   if (!tokenConfig || !tokenConfig.contractAddress) {
//     throw new Error('Invalid token configuration');
//   }
  
//   const { contractAddress, decimals, symbol } = tokenConfig;
//   const tokenAmount = parseFloat(amount);
//   const tokenDecimals = parseInt(decimals);
  
//   console.log('Token config details:', {
//     symbol,
//     contractAddress,
//     decimals: tokenDecimals,
//     inputAmount: tokenAmount
//   });
  
//   const amountInSmallestUnit = Math.floor(tokenAmount * Math.pow(10, tokenDecimals));
  
//   console.log('Amount calculation:', {
//     tokenAmount: tokenAmount,
//     decimals: tokenDecimals,
//     calculation: `${tokenAmount} * 10^${tokenDecimals}`,
//     amountInSmallestUnit: amountInSmallestUnit,
//     humanReadable: `${tokenAmount} ${symbol} = ${amountInSmallestUnit} micro-${symbol}`
//   });
  
//   if (amountInSmallestUnit <= 0) {
//     throw new Error(`Invalid amount: ${tokenAmount} ${symbol} converts to ${amountInSmallestUnit} base units`);
//   }
  
//   if (tokenAmount < 1 && amountInSmallestUnit === 0) {
//     throw new Error(`Amount too small: ${tokenAmount} ${symbol} is smaller than the minimum unit`);
//   }
  
//   try {
//     const connection = await createSolanaConnection();
//     const fromPubkey = walletConnection.publicKey;
//     const toPubkey = new PublicKey(toAddress);
//     const mintPubkey = new PublicKey(contractAddress);
    
//     console.log('Public keys:', {
//       from: fromPubkey.toString(),
//       to: toPubkey.toString(),
//       mint: mintPubkey.toString()
//     });
    
//     const fromTokenAccount = await getAssociatedTokenAddress(
//       mintPubkey,
//       fromPubkey,
//       false,
//       TOKEN_PROGRAM_ID,
//       ASSOCIATED_TOKEN_PROGRAM_ID
//     );
    
//     const toTokenAccount = await getAssociatedTokenAddress(
//       mintPubkey,
//       toPubkey,
//       false,
//       TOKEN_PROGRAM_ID,
//       ASSOCIATED_TOKEN_PROGRAM_ID
//     );
    
//     console.log('Token accounts:', {
//       fromTokenAccount: fromTokenAccount.toString(),
//       toTokenAccount: toTokenAccount.toString()
//     });
    
//     const toAccountInfo = await connection.getAccountInfo(toTokenAccount);
//     console.log('Recipient token account exists:', !!toAccountInfo);
    
//     const transaction = new Transaction();
    
//     if (!toAccountInfo) {
//       console.log('Creating associated token account for recipient...');
//       const createAccountInstruction = createAssociatedTokenAccountInstruction(
//         fromPubkey,
//         toTokenAccount,
//         toPubkey,
//         mintPubkey,
//         TOKEN_PROGRAM_ID,
//         ASSOCIATED_TOKEN_PROGRAM_ID
//       );
//       transaction.add(createAccountInstruction);
//     }
    
//     console.log('Creating transfer instruction with amount:', amountInSmallestUnit);
    
//     const transferInstruction = createTransferInstruction(
//       fromTokenAccount,
//       toTokenAccount,
//       fromPubkey,
//       amountInSmallestUnit,
//       [],
//       TOKEN_PROGRAM_ID
//     );
    
//     transaction.add(transferInstruction);
    
//     const { blockhash } = await connection.getLatestBlockhash();
//     transaction.recentBlockhash = blockhash;
//     transaction.feePayer = fromPubkey;
    
//     console.log('Transaction created with instructions:', transaction.instructions.length);
//     console.log('Transaction sending to Solana provider...');
    
//     const signedTransaction = await solanaProvider.signAndSendTransaction(transaction);
    
//     console.log('✅ Solana token transaction sent successfully:', signedTransaction);
//     console.log('=== END SOLANA TOKEN TRANSACTION DEBUG ===');
    
//     return signedTransaction.signature || signedTransaction;
//   } catch (error) {
//     console.error('❌ Solana token transaction error:', error);
//     console.log('=== END SOLANA TOKEN TRANSACTION DEBUG (ERROR) ===');
    
//     if (error.message && error.message.includes('User rejected')) {
//       throw new Error('Transaction rejected by user');
//     } else if (error.message && error.message.includes('Insufficient')) {
//       throw new Error('Insufficient token balance');
//     } else if (error.message && error.message.includes('Invalid amount') || error.message && error.message.includes('Amount too small')) {
//       throw error;
//     } else {
//       throw new Error(`Token transaction failed: ${error.message || 'Unknown error'}`);
//     }
//   }
// };

// // ERC20/BEP20 token transaction function - Enhanced for Trust Wallet
// export const sendERC20Transaction = async (walletConnection, tokenConfig, toAddress, amount) => {
//   console.log('Sending ERC20/BEP20 transaction with:', { tokenConfig, toAddress, amount, walletType: walletConnection.walletType });
  
//   if (!walletConnection || !walletConnection.provider) {
//     throw new Error('Wallet not connected');
//   }
  
//   const provider = walletConnection.provider;
//   const signer = await provider.getSigner();
  
//   const { contractAddress, decimals, symbol } = tokenConfig;
  
//   const tokenAmount = parseFloat(amount);
//   const tokenDecimals = parseInt(decimals);
  
//   const tokenUnits = ethers.parseUnits(tokenAmount.toString(), tokenDecimals);
  
//   console.log(`Sending ${tokenAmount} ${symbol} (${tokenUnits.toString()} base units) to ${toAddress} via ${walletConnection.walletType}`);
//   console.log(`Token config:`, { contractAddress, decimals, symbol });
  
//   try {
//     const tokenContract = new ethers.Contract(
//       contractAddress,
//       [
//         'function transfer(address to, uint256 amount) returns (bool)',
//         'function balanceOf(address owner) view returns (uint256)',
//         'function decimals() view returns (uint8)'
//       ],
//       signer
//     );
    
//     const userAddress = await signer.getAddress();
//     const balance = await tokenContract.balanceOf(userAddress);
//     console.log(`User ${symbol} balance:`, ethers.formatUnits(balance, decimals));
    
//     if (balance < tokenUnits) {
//       throw new Error(`Insufficient ${symbol} balance. Required: ${tokenAmount}, Available: ${ethers.formatUnits(balance, decimals)}`);
//     }
    
//     try {
//       const gasEstimate = await tokenContract.transfer.estimateGas(toAddress, tokenUnits);
//       console.log('Gas estimate:', gasEstimate.toString());
      
//       // Trust Wallet may need different gas multipliers
//       let gasMultiplier;
//       if (walletConnection.walletType === WALLET_TYPES.TRUST_WALLET) {
//         if (symbol === 'USDC') {
//           gasMultiplier = BigInt(160); // Higher buffer for Trust Wallet + USDC
//         } else if (symbol === 'USDT') {
//           gasMultiplier = BigInt(140); // Higher buffer for Trust Wallet + USDT
//         } else {
//           gasMultiplier = BigInt(130); // Higher buffer for Trust Wallet
//         }
//       } else {
//         if (symbol === 'USDC') {
//           gasMultiplier = BigInt(150);
//         } else if (symbol === 'USDT') {
//           gasMultiplier = BigInt(130);
//         } else {
//           gasMultiplier = BigInt(120);
//         }
//       }
      
//       const gasLimit = (gasEstimate * gasMultiplier) / BigInt(100);
        
//       console.log('Using gas limit:', gasLimit.toString());
      
//       const transaction = await tokenContract.transfer(toAddress, tokenUnits, {
//         gasLimit: gasLimit
//       });
      
//       console.log('Transaction sent:', transaction);
//       return transaction.hash;
//     } catch (gasError) {
//       console.error('Gas estimation failed:', gasError);
      
//       // Trust Wallet fallback with higher fixed gas limits
//       let fixedGasLimit;
//       if (walletConnection.walletType === WALLET_TYPES.TRUST_WALLET) {
//         if (symbol === 'USDC') {
//           fixedGasLimit = BigInt(220000); // Higher for Trust Wallet + USDC
//         } else if (symbol === 'USDT') {
//           fixedGasLimit = BigInt(200000); // Higher for Trust Wallet + USDT
//         } else {
//           fixedGasLimit = BigInt(180000); // Higher for Trust Wallet
//         }
//       } else {
//         if (symbol === 'USDC') {
//           fixedGasLimit = BigInt(200000);
//         } else if (symbol === 'USDT') {
//           fixedGasLimit = BigInt(180000);
//         } else {
//           fixedGasLimit = BigInt(150000);
//         }
//       }
      
//       console.log(`Trying ${symbol} transaction with fixed gas limit for ${walletConnection.walletType}:`, fixedGasLimit.toString());
      
//       const transaction = await tokenContract.transfer(toAddress, tokenUnits, {
//         gasLimit: fixedGasLimit
//       });
      
//       console.log('Transaction sent with fixed gas limit:', transaction);
//       return transaction.hash;
//     }
//   } catch (error) {
//     console.error('ERC20 transaction error:', error);
    
//     if (error.message && error.message.includes('user rejected')) {
//       throw new Error('Transaction rejected by user');
//     } else if (error.message && error.message.includes('insufficient funds')) {
//       throw new Error('Insufficient funds for transaction');
//     } else if (error.message && error.message.includes('Insufficient')) {
//       throw error;
//     } else {
//       throw error;
//     }
//   }
// };

// // TRC20 token transaction function
// export const sendTRC20Transaction = async (walletConnection, tokenConfig, toAddress, amount) => {
//   console.log('Sending TRC20 transaction with:', { tokenConfig, toAddress, amount });
  
//   if (!walletConnection || !walletConnection.provider) {
//     throw new Error('Tron wallet not connected');
//   }
  
//   const tronWeb = walletConnection.provider;
//   if (!tronWeb || !tronWeb.ready) {
//     throw new Error('TronWeb not initialized');
//   }
  
//   if (!tokenConfig || !tokenConfig.contractAddress) {
//     throw new Error('Invalid token configuration');
//   }
  
//   const { contractAddress, decimals, symbol } = tokenConfig;
  
//   const tokenAmount = parseFloat(amount);
//   const tokenDecimals = parseInt(decimals);
  
//   const amountWithDecimals = tokenAmount * Math.pow(10, tokenDecimals);
//   const amountString = amountWithDecimals.toString();
  
//   console.log(`Sending ${tokenAmount} ${symbol} (${amountString} base units) to ${toAddress}`);
  
//   try {
//     const contract = await tronWeb.contract().at(contractAddress);
    
//     if (!contract.transfer) {
//       throw new Error('Invalid TRC-20 contract');
//     }
    
//     const transaction = await contract.transfer(
//       toAddress,
//       amountString
//     ).send({
//       feeLimit: 100000000,
//       callValue: 0,
//       shouldPollResponse: false
//     });
    
//     console.log('TRC20 transaction sent:', transaction);
//     return transaction;
//   } catch (error) {
//     console.error('TRC20 transaction failed:', error);
    
//     if (error.message && error.message.includes('User rejected')) {
//       throw new Error('Transaction rejected by user');
//     } else if (error.message && error.message.includes('bandwidth')) {
//       throw new Error('Insufficient energy or bandwidth. Make sure you have enough TRX for fees.');
//     } else if (error.message && error.message.includes('balance')) {
//       throw new Error('Insufficient token balance for transfer');
//     } else {
//       throw new Error(`Transaction failed: ${error.message || 'Unknown error'}`);
//     }
//   }
// };

// // Enhanced Algorand asset transaction function
// export const sendAlgorandAssetTransaction = async (walletConnection, tokenConfig, toAddress, amount) => {
//   console.log('Sending Algorand asset transaction with:', { tokenConfig, toAddress, amount });
  
//   if (!walletConnection || !walletConnection.provider) {
//     throw new Error('Algorand wallet not connected');
//   }
  
//   const algorandProvider = walletConnection.provider;
  
//   if (!tokenConfig || !tokenConfig.assetId) {
//     throw new Error('Invalid token configuration - missing assetId');
//   }
  
//   const { assetId, decimals, symbol } = tokenConfig;
  
//   const tokenAmount = parseFloat(amount);
//   const tokenDecimals = parseInt(decimals);
  
//   const assetAmount = Math.floor(tokenAmount * Math.pow(10, tokenDecimals));
  
//   console.log(`Sending ${tokenAmount} ${symbol} (${assetAmount} base units) to ${toAddress}`);
//   console.log(`Using wallet: ${walletConnection.walletName || 'Unknown'}`);
  
//   try {
//     let transaction;
    
//     if (algorandProvider.sendAssetTransfer) {
//       console.log('Using sendAssetTransfer method...');
//       transaction = await algorandProvider.sendAssetTransfer({
//         recipient: toAddress,
//         assetId: assetId,
//         amount: assetAmount
//       });
//     } else if (algorandProvider.signTransaction) {
//       console.log('Using signTransaction method for asset transfer...');
//       const txn = {
//         type: 'axfer',
//         from: walletConnection.address,
//         to: toAddress,
//         amount: assetAmount,
//         assetIndex: assetId,
//         fee: 1000,
//         firstRound: 1000,
//         lastRound: 2000
//       };
//       transaction = await algorandProvider.signTransaction(txn);
//     } else {
//       throw new Error(`Unsupported Algorand wallet API for asset transfers in ${walletConnection.walletName || 'this wallet'}`);
//     }
    
//     console.log('Algorand asset transaction sent:', transaction);
//     return transaction.txId || transaction.txID || transaction;
//   } catch (error) {
//     console.error('Algorand asset transaction error:', error);
    
//     if (error.message && error.message.includes('rejected')) {
//       throw new Error('Transaction rejected by user');
//     } else if (error.message && error.message.includes('balance')) {
//       throw new Error('Insufficient asset balance');
//     } else if (error.message && error.message.includes('opted')) {
//       throw new Error('Account not opted in to this asset. Please opt in first.');
//     } else {
//       throw error;
//     }
//   }
// };

// // Get token configuration for a specific currency and network
// export const getTokenConfig = (currency, network) => {
//   if (!currency || !network) {
//     return null;
//   }
  
//   const tokenConfig = TOKEN_CONFIG[currency.toUpperCase()];
//   if (!tokenConfig) {
//     return null;
//   }
  
//   return tokenConfig[network.toLowerCase()];
// };

// // Export everything as a default object as well
// export default {
//   WALLET_TYPES,
//   NETWORK_TYPES,
//   NETWORK_CONFIG,
//   TOKEN_CONFIG,
//   NETWORK_WALLET_MAP,
//   getWalletInstallUrl,
//   detectWallets,
//   detectWalletsWithRetry,
//   debugWalletEnvironment,
//   connectWallet,
//   getSupportedWalletsForNetwork,
//   sendNativeTransaction,
//   sendTokenTransaction,
//   sendTransaction,
//   sendTRC20Transaction,
//   sendERC20Transaction,
//   sendSolanaTokenTransaction,
//   sendAlgorandAssetTransaction,
//   getTokenConfig
// };











// // coinley-sdk/src/services/walletService.js (UPDATED - Simplified)
// import { CoinleyConnectClient } from './coinleyConnectClient';

// // Wallet Types (matching Coinley Connect)
// export const WALLET_TYPES = {
//   METAMASK: 'metamask',
//   PHANTOM: 'phantom',
//   TRONLINK: 'tronlink',
//   TRUST_WALLET: 'trustwallet',
//   LUTE: 'lute'
// };

// // Network Types (matching Coinley Connect)
// export const NETWORK_TYPES = {
//   ETHEREUM: 'ethereum',
//   BSC: 'bsc',
//   TRON: 'tron',
//   ALGORAND: 'algorand',
//   SOLANA: 'solana'
// };

// // Network to wallet mapping
// export const NETWORK_WALLET_MAP = {
//   [NETWORK_TYPES.ETHEREUM]: [WALLET_TYPES.METAMASK, WALLET_TYPES.TRUST_WALLET],
//   [NETWORK_TYPES.BSC]: [WALLET_TYPES.METAMASK, WALLET_TYPES.TRUST_WALLET],
//   [NETWORK_TYPES.TRON]: [WALLET_TYPES.TRONLINK, WALLET_TYPES.TRUST_WALLET],
//   [NETWORK_TYPES.ALGORAND]: [WALLET_TYPES.LUTE],
//   [NETWORK_TYPES.SOLANA]: [WALLET_TYPES.PHANTOM, WALLET_TYPES.TRUST_WALLET]
// };

// // Initialize Coinley Connect client
// const coinleyConnect = new CoinleyConnectClient({
//     apiUrl: process.env.COINLEY_CONNECT_API_URL || 'http://localhost:3001/api',
//     walletInterfaceUrl: process.env.COINLEY_CONNECT_URL || 'http://localhost:3001',
//     debug: process.env.NODE_ENV === 'development'
// });

// /**
//  * Connect to wallet via Coinley Connect service
//  * This replaces all the complex wallet connection logic
//  */
// export const connectWallet = async (walletType, network) => {
//     try {
//         console.log(`🔗 Connecting to ${walletType} on ${network} via Coinley Connect`);
        
//         // Initiate connection through Coinley Connect
//         const connection = await coinleyConnect.connectWallet(walletType, network, {
//             popup: true, // Open in popup by default
//             popup: { width: 420, height: 650 }
//         });
        
//         console.log('Connection initiated:', connection);
        
//         // Wait for connection to complete
//         const session = await coinleyConnect.waitForConnection(connection.sessionId);
        
//         console.log('✅ Wallet connected successfully:', session);
        
//         return {
//             walletType: session.walletType,
//             address: session.address,
//             network: session.network,
//             sessionId: session.id,
//             isConnected: true,
//             chainId: session.chainId,
//             // Keep these for backward compatibility
//             provider: null, // External service handles provider
//             rawProvider: null
//         };
        
//     } catch (error) {
//         console.error('❌ Wallet connection failed:', error);
//         throw error;
//     }
// };

// /**
//  * Send transaction via Coinley Connect service
//  * This replaces all the complex transaction logic
//  */
// export const sendTransaction = async (walletConnection, transactionDetails) => {
//     try {
//         console.log('🚀 Sending transaction via Coinley Connect:', transactionDetails);
        
//         if (!walletConnection.sessionId) {
//             throw new Error('No active wallet session. Please connect wallet first.');
//         }
        
//         const { to, amount, currency, network, tokenAddress, tokenDecimals } = transactionDetails;
        
//         // Send transaction through Coinley Connect
//         const result = await coinleyConnect.sendTransaction(walletConnection.sessionId, {
//             to,
//             amount: amount.toString(),
//             currency,
//             network,
//             tokenAddress,
//             tokenDecimals
//         });
        
//         console.log('✅ Transaction sent successfully:', result);
        
//         // Return transaction hash for compatibility
//         return result.transaction?.hash || result.transactionId;
        
//     } catch (error) {
//         console.error('❌ Transaction failed:', error);
//         throw error;
//     }
// };

// /**
//  * Detect available wallets via Coinley Connect
//  */
// export const detectWallets = async () => {
//     try {
//         // Get supported wallets from Coinley Connect
//         const wallets = await coinleyConnect.getSupportedWallets();
        
//         // Convert to the format expected by your SDK
//         const detectedWallets = {};
        
//         wallets.forEach(wallet => {
//             // For now, assume all supported wallets are "detected"
//             // In a real implementation, Coinley Connect would handle detection
//             detectedWallets[wallet.type] = true;
//         });
        
//         return detectedWallets;
        
//     } catch (error) {
//         console.error('Error detecting wallets:', error);
//         return {};
//     }
// };

// /**
//  * Get supported wallets for a network
//  */
// export const getSupportedWalletsForNetwork = (network) => {
//     return NETWORK_WALLET_MAP[network] || [];
// };

// /**
//  * Get wallet install URL
//  */
// export const getWalletInstallUrl = (walletType) => {
//     const urls = {
//         [WALLET_TYPES.METAMASK]: 'https://metamask.io/download/',
//         [WALLET_TYPES.PHANTOM]: 'https://phantom.app/download',
//         [WALLET_TYPES.TRONLINK]: 'https://www.tronlink.org/download/',
//         [WALLET_TYPES.TRUST_WALLET]: 'https://trustwallet.com/download/',
//         [WALLET_TYPES.LUTE]: 'https://lute.app/download/'
//     };
//     return urls[walletType] || '';
// };

// /**
//  * Disconnect wallet
//  */
// export const disconnectWallet = async (walletConnection) => {
//     try {
//         if (walletConnection.sessionId) {
//             await coinleyConnect.disconnectWallet(walletConnection.sessionId);
//         }
//         return true;
//     } catch (error) {
//         console.error('Error disconnecting wallet:', error);
//         return false;
//     }
// };

// // Export the client for advanced usage
// export { coinleyConnect };












// new one




// // coinley-sdk/src/services/walletService.js (COMPLETE WITH ALL EXPORTS)
// import CoinleyConnectClient from './coinleyConnectClient';

// // Wallet Types (matching Coinley Connect)
// export const WALLET_TYPES = {
//   METAMASK: 'metamask',
//   PHANTOM: 'phantom',
//   TRONLINK: 'tronlink',
//   TRUST_WALLET: 'trustwallet',
//   LUTE: 'lute'
// };

// // Network Types (matching Coinley Connect)
// export const NETWORK_TYPES = {
//   ETHEREUM: 'ethereum',
//   BSC: 'bsc',
//   TRON: 'tron',
//   ALGORAND: 'algorand',
//   SOLANA: 'solana'
// };

// // Network configuration (for backward compatibility)
// export const NETWORK_CONFIG = {
//   [NETWORK_TYPES.ETHEREUM]: {
//     name: 'Ethereum Mainnet',
//     chainId: 1,
//     symbol: 'ETH',
//     decimals: 18,
//     rpcUrl: 'https://mainnet.infura.io/v3/your-infura-key',
//     blockExplorerUrl: 'https://etherscan.io'
//   },
//   [NETWORK_TYPES.BSC]: {
//     name: 'Binance Smart Chain',
//     chainId: 56,
//     symbol: 'BNB',
//     decimals: 18,
//     rpcUrl: 'https://bsc-dataseed.binance.org/',
//     blockExplorerUrl: 'https://bscscan.com'
//   },
//   [NETWORK_TYPES.TRON]: {
//     name: 'TRON Mainnet',
//     symbol: 'TRX',
//     decimals: 6,
//     rpcUrl: 'https://api.trongrid.io',
//     blockExplorerUrl: 'https://tronscan.org'
//   },
//   [NETWORK_TYPES.ALGORAND]: {
//     name: 'Algorand Mainnet',
//     symbol: 'ALGO',
//     decimals: 6,
//     rpcUrl: 'https://mainnet-api.algonode.cloud',
//     blockExplorerUrl: 'https://algoexplorer.io'
//   },
//   [NETWORK_TYPES.SOLANA]: {
//     name: 'Solana Mainnet',
//     symbol: 'SOL',
//     decimals: 9,
//     rpcUrl: 'https://rpc.ankr.com/solana',
//     blockExplorerUrl: 'https://explorer.solana.com'
//   }
// };

// // Token configurations (for backward compatibility)
// export const TOKEN_CONFIG = {
//   USDT: {
//     ethereum: {
//       contractAddress: '0xdAC17F958D2ee523a2206206994597C13D831ec7',
//       decimals: 6,
//       symbol: 'USDT'
//     },
//     bsc: {
//       contractAddress: '0x55d398326f99059fF775485246999027B3197955',
//       decimals: 18,
//       symbol: 'USDT'
//     },
//     tron: {
//       contractAddress: 'TR7NHqjeKQxGTCi8q8ZY4pL8otSzgjLj6t',
//       decimals: 6,
//       symbol: 'USDT'
//     },
//     algorand: {
//       assetId: 312769,
//       decimals: 6,
//       symbol: 'USDT'
//     },
//     solana: {
//       contractAddress: 'Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB',
//       decimals: 6,
//       symbol: 'USDT'
//     }
//   },
//   USDC: {
//     ethereum: {
//       contractAddress: '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
//       decimals: 6,
//       symbol: 'USDC'
//     },
//     bsc: {
//       contractAddress: '0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d',
//       decimals: 18,
//       symbol: 'USDC'
//     },
//     tron: {
//       contractAddress: 'TEkxiTehnzSmSe2XqrBj4w32RUN966rdz8',
//       decimals: 6,
//       symbol: 'USDC'
//     },
//     algorand: {
//       assetId: 31566704,
//       decimals: 6,
//       symbol: 'USDC'
//     },
//     solana: {
//       contractAddress: 'EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v',
//       decimals: 6,
//       symbol: 'USDC'
//     }
//   }
// };

// // Network to wallet mapping
// export const NETWORK_WALLET_MAP = {
//   [NETWORK_TYPES.ETHEREUM]: [WALLET_TYPES.METAMASK, WALLET_TYPES.TRUST_WALLET],
//   [NETWORK_TYPES.BSC]: [WALLET_TYPES.METAMASK, WALLET_TYPES.TRUST_WALLET],
//   [NETWORK_TYPES.TRON]: [WALLET_TYPES.TRONLINK, WALLET_TYPES.TRUST_WALLET],
//   [NETWORK_TYPES.ALGORAND]: [WALLET_TYPES.LUTE],
//   [NETWORK_TYPES.SOLANA]: [WALLET_TYPES.PHANTOM, WALLET_TYPES.TRUST_WALLET]
// };

// // Get environment variables or use defaults
// const getConnectConfig = () => {
//   // Check if we're in a browser environment
//   if (typeof window !== 'undefined') {
//     return {
//       apiUrl: window.COINLEY_CONNECT_API_URL || 'http://localhost:3001/api',
//       walletInterfaceUrl: window.COINLEY_CONNECT_URL || 'http://localhost:3001',
//       debug: window.NODE_ENV === 'development' || false
//     };
//   }
  
//   // Node.js environment
//   return {
//     apiUrl: process.env.COINLEY_CONNECT_API_URL || 'http://localhost:3001/api',
//     walletInterfaceUrl: process.env.COINLEY_CONNECT_URL || 'http://localhost:3001',
//     debug: process.env.NODE_ENV === 'development' || false
//   };
// };

// // Initialize Coinley Connect client
// const coinleyConnect = new CoinleyConnectClient(getConnectConfig());

// /**
//  * Connect to wallet via Coinley Connect service
//  * This replaces all the complex wallet connection logic
//  */
// export const connectWallet = async (walletType, network) => {
//     try {
//         console.log(`🔗 Connecting to ${walletType} on ${network} via Coinley Connect`);
        
//         // Initiate connection through Coinley Connect
//         const connection = await coinleyConnect.connectWallet(walletType, network, {
//             popup: true, // Open in popup by default
//             popup: { width: 420, height: 650 }
//         });
        
//         console.log('Connection initiated:', connection);
        
//         // Wait for connection to complete
//         const session = await coinleyConnect.waitForConnection(connection.sessionId);
        
//         console.log('✅ Wallet connected successfully:', session);
        
//         return {
//             walletType: session.walletType,
//             address: session.address,
//             network: session.network,
//             sessionId: session.id,
//             isConnected: true,
//             chainId: session.chainId,
//             // Keep these for backward compatibility
//             provider: null, // External service handles provider
//             rawProvider: null
//         };
        
//     } catch (error) {
//         console.error('❌ Wallet connection failed:', error);
//         throw error;
//     }
// };

// /**
//  * Send transaction via Coinley Connect service
//  * This replaces all the complex transaction logic
//  */
// export const sendTransaction = async (walletConnection, transactionDetails) => {
//     try {
//         console.log('🚀 Sending transaction via Coinley Connect:', transactionDetails);
        
//         if (!walletConnection.sessionId) {
//             throw new Error('No active wallet session. Please connect wallet first.');
//         }
        
//         const { to, amount, currency, network, tokenAddress, tokenDecimals } = transactionDetails;
        
//         // Send transaction through Coinley Connect
//         const result = await coinleyConnect.sendTransaction(walletConnection.sessionId, {
//             to,
//             amount: amount.toString(),
//             currency,
//             network,
//             tokenAddress,
//             tokenDecimals
//         });
        
//         console.log('✅ Transaction sent successfully:', result);
        
//         // Return transaction hash for compatibility
//         return result.transaction?.hash || result.transactionId;
        
//     } catch (error) {
//         console.error('❌ Transaction failed:', error);
//         throw error;
//     }
// };

// /**
//  * Detect available wallets via Coinley Connect
//  */
// export const detectWallets = async () => {
//     try {
//         // Get supported wallets from Coinley Connect
//         const wallets = await coinleyConnect.getSupportedWallets();
        
//         // Convert to the format expected by your SDK
//         const detectedWallets = {};
        
//         wallets.forEach(wallet => {
//             // For now, assume all supported wallets are "detected"
//             // In a real implementation, Coinley Connect would handle detection
//             detectedWallets[wallet.type] = true;
//         });
        
//         return detectedWallets;
        
//     } catch (error) {
//         console.error('Error detecting wallets:', error);
//         // Return fallback for common wallets
//         return {
//             [WALLET_TYPES.METAMASK]: true,
//             [WALLET_TYPES.PHANTOM]: true,
//             [WALLET_TYPES.TRONLINK]: false,
//             [WALLET_TYPES.TRUST_WALLET]: false,
//             [WALLET_TYPES.LUTE]: false
//         };
//     }
// };

// /**
//  * ✅ FIXED: Get wallet install URL (was missing)
//  */
// export const getWalletInstallUrl = (walletType) => {
//     const urls = {
//         [WALLET_TYPES.METAMASK]: 'https://metamask.io/download/',
//         [WALLET_TYPES.PHANTOM]: 'https://phantom.app/download',
//         [WALLET_TYPES.TRONLINK]: 'https://www.tronlink.org/download/',
//         [WALLET_TYPES.TRUST_WALLET]: 'https://trustwallet.com/download/',
//         [WALLET_TYPES.LUTE]: 'https://lute.app/download/'
//     };
//     return urls[walletType] || '';
// };

// /**
//  * Get supported wallets for a network
//  */
// export const getSupportedWalletsForNetwork = (network) => {
//     return NETWORK_WALLET_MAP[network] || [];
// };

// /**
//  * ✅ FIXED: Debug wallet environment (was missing)
//  */
// export const debugWalletEnvironment = () => {
//     console.warn('debugWalletEnvironment is deprecated - wallet debugging is now handled by Coinley Connect');
//     return { 
//         message: 'Wallet debugging handled by Coinley Connect service',
//         coinleyConnectUrl: getConnectConfig().walletInterfaceUrl,
//         availableWallets: Object.keys(WALLET_TYPES),
//         supportedNetworks: Object.keys(NETWORK_TYPES)
//     };
// };

// /**
//  * ✅ FIXED: Detect wallets with retry (was missing)
//  */
// export const detectWalletsWithRetry = async (maxRetries = 3, delay = 1000) => {
//     console.warn('detectWalletsWithRetry is deprecated - using detectWallets instead');
//     return detectWallets();
// };

// /**
//  * Disconnect wallet
//  */
// export const disconnectWallet = async (walletConnection) => {
//     try {
//         if (walletConnection.sessionId) {
//             await coinleyConnect.disconnectWallet(walletConnection.sessionId);
//         }
//         return true;
//     } catch (error) {
//         console.error('Error disconnecting wallet:', error);
//         return false;
//     }
// };

// /**
//  * ✅ FIXED: Send native transaction (for backward compatibility)
//  */
// export const sendNativeTransaction = async (walletConnection, toAddress, amount) => {
//     console.warn('sendNativeTransaction is deprecated - use sendTransaction instead');
//     return sendTransaction(walletConnection, {
//         to: toAddress,
//         amount: amount,
//         currency: 'ETH', // Default to ETH
//         network: walletConnection.network || 'ethereum'
//     });
// };

// /**
//  * ✅ FIXED: Send token transaction (for backward compatibility)
//  */
// export const sendTokenTransaction = async (walletConnection, tokenConfig, toAddress, amount) => {
//     console.warn('sendTokenTransaction is deprecated - use sendTransaction instead');
//     return sendTransaction(walletConnection, {
//         to: toAddress,
//         amount: amount,
//         currency: tokenConfig.symbol,
//         network: walletConnection.network,
//         tokenAddress: tokenConfig.contractAddress,
//         tokenDecimals: tokenConfig.decimals
//     });
// };

// /**
//  * ✅ FIXED: Send ERC20 transaction (for backward compatibility)
//  */
// export const sendERC20Transaction = async (walletConnection, tokenConfig, toAddress, amount) => {
//     console.warn('sendERC20Transaction is deprecated - use sendTransaction instead');
//     return sendTokenTransaction(walletConnection, tokenConfig, toAddress, amount);
// };

// /**
//  * ✅ FIXED: Get token config (for backward compatibility)
//  */
// export const getTokenConfig = (currency, network) => {
//     if (!currency || !network) {
//         return null;
//     }
    
//     const tokenConfig = TOKEN_CONFIG[currency.toUpperCase()];
//     if (!tokenConfig) {
//         return null;
//     }
    
//     return tokenConfig[network.toLowerCase()];
// };

// // Export the client for advanced usage
// export { coinleyConnect };

// // ✅ FIXED: Default export for the entire service
// export default {
//     WALLET_TYPES,
//     NETWORK_TYPES,
//     NETWORK_CONFIG,
//     TOKEN_CONFIG,
//     NETWORK_WALLET_MAP,
//     connectWallet,
//     sendTransaction,
//     detectWallets,
//     getWalletInstallUrl,
//     getSupportedWalletsForNetwork,
//     debugWalletEnvironment,
//     detectWalletsWithRetry,
//     disconnectWallet,
//     sendNativeTransaction,
//     sendTokenTransaction,
//     sendERC20Transaction,
//     getTokenConfig,
//     coinleyConnect
// };





// coinley-sdk/src/services/walletService.js - Updated with new networks
import CoinleyConnectClient from './coinleyConnectClient';

// ✅ UPDATED: Extended wallet types and network types
export const WALLET_TYPES = {
  METAMASK: 'metamask',
  PHANTOM: 'phantom',
  TRONLINK: 'tronlink',
  TRUST_WALLET: 'trustwallet',
  LUTE: 'lute'
};

// ✅ UPDATED: Added new network types
export const NETWORK_TYPES = {
  ETHEREUM: 'ethereum',
  BSC: 'bsc',
  TRON: 'tron',
  ALGORAND: 'algorand',
  SOLANA: 'solana',
  // New networks
  OPTIMISM: 'optimism',
  ARBITRUM: 'arbitrum',
  POLYGON: 'polygon',
  AVALANCHE: 'avalanche',
  CELO: 'celo'
};

// ✅ UPDATED: Extended network configuration
export const NETWORK_CONFIG = {
  [NETWORK_TYPES.ETHEREUM]: {
    name: 'Ethereum Mainnet',
    chainId: 1,
    symbol: 'ETH',
    decimals: 18,
    rpcUrl: 'https://mainnet.infura.io/v3/your-infura-key',
    blockExplorerUrl: 'https://etherscan.io'
  },
  [NETWORK_TYPES.BSC]: {
    name: 'Binance Smart Chain',
    chainId: 56,
    symbol: 'BNB',
    decimals: 18,
    rpcUrl: 'https://bsc-dataseed.binance.org/',
    blockExplorerUrl: 'https://bscscan.com'
  },
  [NETWORK_TYPES.TRON]: {
    name: 'TRON Mainnet',
    symbol: 'TRX',
    decimals: 6,
    rpcUrl: 'https://api.trongrid.io',
    blockExplorerUrl: 'https://tronscan.org'
  },
  [NETWORK_TYPES.ALGORAND]: {
    name: 'Algorand Mainnet',
    symbol: 'ALGO',
    decimals: 6,
    rpcUrl: 'https://mainnet-api.algonode.cloud',
    blockExplorerUrl: 'https://algoexplorer.io'
  },
  [NETWORK_TYPES.SOLANA]: {
    name: 'Solana Mainnet',
    symbol: 'SOL',
    decimals: 9,
    rpcUrl: 'https://rpc.ankr.com/solana',
    blockExplorerUrl: 'https://explorer.solana.com'
  },
  // ✅ NEW: Additional network configurations
  [NETWORK_TYPES.OPTIMISM]: {
    name: 'Optimism',
    chainId: 10,
    symbol: 'ETH',
    decimals: 18,
    rpcUrl: 'https://mainnet.optimism.io',
    blockExplorerUrl: 'https://optimistic.etherscan.io'
  },
  [NETWORK_TYPES.ARBITRUM]: {
    name: 'Arbitrum One',
    chainId: 42161,
    symbol: 'ETH',
    decimals: 18,
    rpcUrl: 'https://arb1.arbitrum.io/rpc',
    blockExplorerUrl: 'https://arbiscan.io'
  },
  [NETWORK_TYPES.POLYGON]: {
    name: 'Polygon',
    chainId: 137,
    symbol: 'MATIC',
    decimals: 18,
    rpcUrl: 'https://polygon-rpc.com',
    blockExplorerUrl: 'https://polygonscan.com'
  },
  [NETWORK_TYPES.AVALANCHE]: {
    name: 'Avalanche C-Chain',
    chainId: 43114,
    symbol: 'AVAX',
    decimals: 18,
    rpcUrl: 'https://api.avax.network/ext/bc/C/rpc',
    blockExplorerUrl: 'https://snowtrace.io'
  },
  [NETWORK_TYPES.CELO]: {
    name: 'Celo',
    chainId: 42220,
    symbol: 'CELO',
    decimals: 18,
    rpcUrl: 'https://forno.celo.org',
    blockExplorerUrl: 'https://celoscan.io'
  }
};

// ✅ UPDATED: Extended token configurations
export const TOKEN_CONFIG = {
  USDT: {
    ethereum: {
      contractAddress: '0xdAC17F958D2ee523a2206206994597C13D831ec7',
      decimals: 6,
      symbol: 'USDT'
    },
    bsc: {
      contractAddress: '0x55d398326f99059fF775485246999027B3197955',
      decimals: 18,
      symbol: 'USDT'
    },
    tron: {
      contractAddress: 'TR7NHqjeKQxGTCi8q8ZY4pL8otSzgjLj6t',
      decimals: 6,
      symbol: 'USDT'
    },
    algorand: {
      assetId: 312769,
      decimals: 6,
      symbol: 'USDT'
    },
    solana: {
      contractAddress: 'Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB',
      decimals: 6,
      symbol: 'USDT'
    },
    // ✅ NEW: USDT on new networks
    optimism: {
      contractAddress: '0x94b008aA00579c1307B0EF2c499aD98a8ce58e58',
      decimals: 6,
      symbol: 'USDT'
    },
    arbitrum: {
      contractAddress: '0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9',
      decimals: 6,
      symbol: 'USDT'
    },
    polygon: {
      contractAddress: '0xc2132D05D31c914a87C6611C10748AEb04B58e8F',
      decimals: 6,
      symbol: 'USDT'
    },
    avalanche: {
      contractAddress: '0x9702230A8Ea53601f5cD2dc00fDBc13d4dF4A8c7',
      decimals: 6,
      symbol: 'USDT'
    },
    celo: {
      contractAddress: '0x48065fbBE25f71C9282ddf5e1cD6D6A887483D5e',
      decimals: 6,
      symbol: 'USDT'
    }
  },
  USDC: {
    ethereum: {
      contractAddress: '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
      decimals: 6,
      symbol: 'USDC'
    },
    bsc: {
      contractAddress: '0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d',
      decimals: 18,
      symbol: 'USDC'
    },
    tron: {
      contractAddress: 'TEkxiTehnzSmSe2XqrBj4w32RUN966rdz8',
      decimals: 6,
      symbol: 'USDC'
    },
    algorand: {
      assetId: 31566704,
      decimals: 6,
      symbol: 'USDC'
    },
    solana: {
      contractAddress: 'EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v',
      decimals: 6,
      symbol: 'USDC'
    },
    // ✅ NEW: USDC on new networks
    optimism: {
      contractAddress: '0x0b2C639c533813f4Aa9D7837CAf62653d097Ff85',
      decimals: 6,
      symbol: 'USDC'
    },
    arbitrum: {
      contractAddress: '0xaf88d065e77c8cC2239327C5EDb3A432268e5831',
      decimals: 6,
      symbol: 'USDC'
    },
    polygon: {
      contractAddress: '0x2791Bca1f2de4661ED88A30C99A7a9449Aa84174',
      decimals: 6,
      symbol: 'USDC'
    },
    avalanche: {
      contractAddress: '0xB97EF9Ef8734C71904D8002F8b6Bc66Dd9c48a6E',
      decimals: 6,
      symbol: 'USDC'
    },
    celo: {
      contractAddress: '0xcebA9300f2b948710d2653dD7B07f33A8B32118C',
      decimals: 6,
      symbol: 'USDC'
    }
  },
  DAI: {
    ethereum: {
      contractAddress: '0x6B175474E89094C44Da98b954EedeAC495271d0F',
      decimals: 18,
      symbol: 'DAI'
    },
    // ✅ NEW: DAI on new networks
    optimism: {
      contractAddress: '0xDA10009cBd5D07dd0CeCc66161FC93D7c9000da1',
      decimals: 18,
      symbol: 'DAI'
    },
    arbitrum: {
      contractAddress: '0xDA10009cBd5D07dd0CeCc66161FC93D7c9000da1',
      decimals: 18,
      symbol: 'DAI'
    },
    polygon: {
      contractAddress: '0x8f3Cf7ad23Cd3CaDbD9735AFf958023239c6A063',
      decimals: 18,
      symbol: 'DAI'
    },
    avalanche: {
      contractAddress: '0xd586E7F844cEa2F87f50152665BCbc2C279D8d70',
      decimals: 18,
      symbol: 'DAI'
    }
  }
};

// ✅ UPDATED: Extended network to wallet mapping
export const NETWORK_WALLET_MAP = {
  // Existing networks
  [NETWORK_TYPES.ETHEREUM]: [WALLET_TYPES.METAMASK, WALLET_TYPES.TRUST_WALLET],
  [NETWORK_TYPES.BSC]: [WALLET_TYPES.METAMASK, WALLET_TYPES.TRUST_WALLET],
  [NETWORK_TYPES.TRON]: [WALLET_TYPES.TRONLINK, WALLET_TYPES.TRUST_WALLET],
  [NETWORK_TYPES.ALGORAND]: [WALLET_TYPES.LUTE],
  [NETWORK_TYPES.SOLANA]: [WALLET_TYPES.PHANTOM, WALLET_TYPES.TRUST_WALLET],
  
  // ✅ NEW: New network wallet mappings (all EVM-compatible use MetaMask)
  [NETWORK_TYPES.OPTIMISM]: [WALLET_TYPES.METAMASK, WALLET_TYPES.TRUST_WALLET],
  [NETWORK_TYPES.ARBITRUM]: [WALLET_TYPES.METAMASK, WALLET_TYPES.TRUST_WALLET],
  [NETWORK_TYPES.POLYGON]: [WALLET_TYPES.METAMASK, WALLET_TYPES.TRUST_WALLET],
  [NETWORK_TYPES.AVALANCHE]: [WALLET_TYPES.METAMASK, WALLET_TYPES.TRUST_WALLET],
  [NETWORK_TYPES.CELO]: [WALLET_TYPES.METAMASK, WALLET_TYPES.TRUST_WALLET]
};

// Get Coinley Connect configuration
const getConnectConfig = () => {
  if (typeof window !== 'undefined') {
    return {
      apiUrl: window.COINLEY_CONNECT_API_URL || 'http://localhost:3001/api',
      walletInterfaceUrl: window.COINLEY_CONNECT_URL || 'http://localhost:3001',
      debug: window.NODE_ENV === 'development' || false
    };
  }
  
  return {
    apiUrl: process.env.COINLEY_CONNECT_API_URL || 'http://localhost:3001/api',
    walletInterfaceUrl: process.env.COINLEY_CONNECT_URL || 'http://localhost:3001',
    debug: process.env.NODE_ENV === 'development' || false
  };
};

// Initialize Coinley Connect client
const coinleyConnect = new CoinleyConnectClient(getConnectConfig());

// ✅ UPDATED: Enhanced chain ID mapping for new networks
const getChainIdForNetwork = (network) => {
  const chainIds = {
    'ethereum': 1,
    'bsc': 56,
    'optimism': 10,
    'arbitrum': 42161,
    'polygon': 137,
    'avalanche': 43114,
    'celo': 42220
  };
  return chainIds[network] || 1;
};

// ✅ UPDATED: Enhanced address validation for new networks
const validateAddressFormat = (address, network) => {
  if (!address || typeof address !== 'string') return false;
  
  const trimmedAddress = address.trim();
  
  switch (network.toLowerCase()) {
    case 'ethereum':
    case 'bsc':
    case 'optimism':
    case 'arbitrum':
    case 'polygon':
    case 'avalanche':
    case 'celo':
      // All EVM-compatible networks use same address format
      return /^0x[a-fA-F0-9]{40}$/.test(trimmedAddress);
    case 'tron':
      return /^T[a-zA-Z0-9]{33}$/.test(trimmedAddress);
    case 'solana':
      return /^[1-9A-HJ-NP-Za-km-z]{32,44}$/.test(trimmedAddress);
    case 'algorand':
      return /^[A-Z2-7]{58}$/.test(trimmedAddress);
    default:
      return true; // Unknown network, skip validation
  }
};

// ✅ MAIN WALLET CONNECTION FUNCTION - Uses Coinley Connect
export const connectWallet = async (walletType, network) => {
    console.log(`🔗 Connecting to ${walletType} via Coinley Connect for ${network}`);
    
    try {
        // Use Coinley Connect service to handle wallet connection
        const connection = await coinleyConnect.connectWallet(walletType, network, {
            debug: getConnectConfig().debug
        });
        
        console.log('✅ Wallet connected via Coinley Connect:', connection);
        
        return {
            walletType: connection.walletType,
            address: connection.address,
            network: connection.network,
            sessionId: connection.sessionId,
            isConnected: connection.isConnected,
            provider: connection.provider || null
        };
        
    } catch (error) {
        console.error('❌ Coinley Connect wallet connection failed:', error);
        
        // ✅ FALLBACK: Try direct browser connection if Coinley Connect fails
        console.log('🔄 Attempting fallback direct connection...');
        return await connectWalletDirectly(walletType, network);
    }
};

// ✅ FALLBACK: Direct browser wallet connection
const connectWalletDirectly = async (walletType, network) => {
    try {
        switch (walletType) {
            case WALLET_TYPES.METAMASK:
                return await connectMetaMaskDirectly(network);
            case WALLET_TYPES.PHANTOM:
                return await connectPhantomDirectly(network);
            case WALLET_TYPES.TRONLINK:
                return await connectTronLinkDirectly(network);
            default:
                throw new Error(`Direct connection not implemented for ${walletType}`);
        }
    } catch (error) {
        console.error(`❌ Direct connection failed for ${walletType}:`, error);
        throw error;
    }
};

// ✅ UPDATED: Enhanced MetaMask connection with network switching for new chains
const connectMetaMaskDirectly = async (network) => {
    if (typeof window.ethereum === 'undefined') {
        throw new Error('MetaMask is not installed');
    }

    try {
        const accounts = await window.ethereum.request({
            method: 'eth_requestAccounts'
        });

        if (!accounts || accounts.length === 0) {
            throw new Error('No accounts available');
        }

        const chainId = await window.ethereum.request({
            method: 'eth_chainId'
        });

        const requiredChainId = getChainIdForNetwork(network);
        if (parseInt(chainId, 16) !== requiredChainId) {
            await switchMetaMaskNetwork(requiredChainId, network);
        }

        console.log('✅ MetaMask connected directly:', {
            address: accounts[0],
            chainId: parseInt(chainId, 16),
            network
        });

        return {
            walletType: WALLET_TYPES.METAMASK,
            address: accounts[0],
            network: network,
            chainId: parseInt(chainId, 16),
            isConnected: true,
            provider: window.ethereum,
            sessionId: null
        };

    } catch (error) {
        console.error('MetaMask direct connection error:', error);
        throw error;
    }
};

// ✅ UPDATED: Enhanced network switching with support for new networks
const switchMetaMaskNetwork = async (chainId, network) => {
    try {
        await window.ethereum.request({
            method: 'wallet_switchEthereumChain',
            params: [{ chainId: `0x${chainId.toString(16)}` }]
        });
    } catch (switchError) {
        // If the network doesn't exist, add it
        if (switchError.code === 4902) {
            try {
                await addNetworkToMetaMask(network, chainId);
            } catch (addError) {
                console.error('Failed to add network:', addError);
                throw addError;
            }
        } else {
            console.error('Failed to switch network:', switchError);
            throw switchError;
        }
    }
};

// ✅ NEW: Add network to MetaMask for new networks
const addNetworkToMetaMask = async (network, chainId) => {
    const networkConfig = NETWORK_CONFIG[network];
    if (!networkConfig) {
        throw new Error(`Network configuration not found for ${network}`);
    }

    const params = {
        chainId: `0x${chainId.toString(16)}`,
        chainName: networkConfig.name,
        rpcUrls: [networkConfig.rpcUrl],
        nativeCurrency: {
            name: networkConfig.symbol,
            symbol: networkConfig.symbol,
            decimals: networkConfig.decimals
        },
        blockExplorerUrls: [networkConfig.blockExplorerUrl]
    };

    await window.ethereum.request({
        method: 'wallet_addEthereumChain',
        params: [params]
    });
};

// Keep existing functions (connectPhantomDirectly, connectTronLinkDirectly, etc.)
const connectPhantomDirectly = async (network) => {
    if (typeof window.solana === 'undefined' || !window.solana.isPhantom) {
        throw new Error('Phantom wallet is not installed');
    }

    try {
        const response = await window.solana.connect();
        
        console.log('✅ Phantom connected directly:', {
            address: response.publicKey.toString(),
            network
        });

        return {
            walletType: WALLET_TYPES.PHANTOM,
            address: response.publicKey.toString(),
            network: network,
            chainId: null,
            isConnected: true,
            provider: window.solana,
            sessionId: null
        };

    } catch (error) {
        console.error('Phantom direct connection error:', error);
        throw error;
    }
};

const connectTronLinkDirectly = async (network) => {
    if (typeof window.tronWeb === 'undefined') {
        throw new Error('TronLink is not installed');
    }

    try {
        const accounts = await window.tronWeb.request({
            method: 'tron_requestAccounts'
        });

        if (!accounts || accounts.length === 0) {
            throw new Error('No accounts available');
        }

        console.log('✅ TronLink connected directly:', {
            address: accounts[0],
            network
        });

        return {
            walletType: WALLET_TYPES.TRONLINK,
            address: accounts[0],
            network: network,
            chainId: null,
            isConnected: true,
            provider: window.tronWeb,
            sessionId: null
        };

    } catch (error) {
        console.error('TronLink direct connection error:', error);
        throw error;
    }
};

// ✅ Send transaction via Coinley Connect or direct
export const sendTransaction = async (walletConnection, transactionDetails) => {
    try {
        console.log('🚀 Sending transaction:', transactionDetails);
        
        const { to, amount, currency, network, tokenAddress, tokenDecimals } = transactionDetails;
        
        // If we have a Coinley Connect session ID, use the service
        if (walletConnection.sessionId) {
            console.log('📡 Using Coinley Connect service for transaction...');
            
            const txHash = await coinleyConnect.sendTransaction(walletConnection.sessionId, {
                to,
                amount: amount.toString(),
                currency,
                network,
                tokenAddress,
                tokenDecimals
            });
            
            console.log('✅ Transaction sent via Coinley Connect:', txHash);
            return txHash;
        }
        
        // Fallback to direct transaction if we have a provider
        if (walletConnection.provider) {
            console.log('🔄 Using direct wallet provider for transaction...');
            return await sendTransactionDirectly(walletConnection, transactionDetails);
        }
        
        throw new Error('No transaction method available');
        
    } catch (error) {
        console.error('❌ Transaction failed:', error);
        throw error;
    }
};

// Send transaction directly through wallet provider
const sendTransactionDirectly = async (walletConnection, transactionDetails) => {
    const { walletType, provider } = walletConnection;
    
    try {
        switch (walletType) {
            case WALLET_TYPES.METAMASK:
                return await sendMetaMaskTransaction(provider, walletConnection, transactionDetails);
            case WALLET_TYPES.PHANTOM:
                return await sendPhantomTransaction(provider, transactionDetails);
            case WALLET_TYPES.TRONLINK:
                return await sendTronLinkTransaction(provider, transactionDetails);
            default:
                throw new Error(`Direct transaction not implemented for ${walletType}`);
        }
    } catch (error) {
        console.error(`Direct transaction failed for ${walletType}:`, error);
        throw error;
    }
};

const sendMetaMaskTransaction = async (provider, walletConnection, transactionDetails) => {
    const { to, amount, tokenAddress } = transactionDetails;
    
    try {
        if (tokenAddress && tokenAddress !== '0x0000000000000000000000000000000000000000') {
            throw new Error('ERC20 transactions require additional setup - use Coinley Connect service');
        } else {
            // Native token transaction
            const amountWei = (parseFloat(amount) * 1e18).toString(16);
            
            const tx = await provider.request({
                method: 'eth_sendTransaction',
                params: [{
                    from: walletConnection.address,
                    to: to,
                    value: `0x${amountWei}`
                }]
            });
            
            console.log('✅ MetaMask transaction sent:', tx);
            return tx;
        }
    } catch (error) {
        console.error('MetaMask transaction error:', error);
        throw error;
    }
};

const sendPhantomTransaction = async (provider, transactionDetails) => {
    console.warn('Phantom direct transactions require @solana/web3.js - use Coinley Connect service');
    throw new Error('Use Coinley Connect service for Phantom transactions');
};

const sendTronLinkTransaction = async (provider, transactionDetails) => {
    console.warn('TronLink direct transactions require TronWeb setup - use Coinley Connect service');
    throw new Error('Use Coinley Connect service for TronLink transactions');
};

// ✅ Detect available wallets
export const detectWallets = async () => {
    const detected = {
        [WALLET_TYPES.METAMASK]: false,
        [WALLET_TYPES.PHANTOM]: false,
        [WALLET_TYPES.TRONLINK]: false,
        [WALLET_TYPES.TRUST_WALLET]: false,
        [WALLET_TYPES.LUTE]: false
    };
    
    // Detect MetaMask
    if (typeof window.ethereum !== 'undefined') {
        if (window.ethereum.isMetaMask) {
            detected[WALLET_TYPES.METAMASK] = true;
        }
        if (window.ethereum.isTrust) {
            detected[WALLET_TYPES.TRUST_WALLET] = true;
        }
    }
    
    // Detect Phantom
    if (typeof window.solana !== 'undefined' && window.solana.isPhantom) {
        detected[WALLET_TYPES.PHANTOM] = true;
    }
    
    // Detect TronLink
    if (typeof window.tronWeb !== 'undefined') {
        detected[WALLET_TYPES.TRONLINK] = true;
    }
    
    // Detect Lute/AlgoSigner
    if (typeof window.AlgoSigner !== 'undefined') {
        detected[WALLET_TYPES.LUTE] = true;
    }
    
    console.log('🔍 Detected wallets:', detected);
    return detected;
};

// Export all utility functions
export const getAvailableWallets = async (network = null) => {
    try {
        const wallets = await coinleyConnect.getSupportedWallets(network);
        const detectedWallets = await detectWallets();
        
        const walletsWithStatus = wallets.map(wallet => ({
            ...wallet,
            isInstalled: detectedWallets[wallet.type] || false,
            status: detectedWallets[wallet.type] ? 'installed' : 'not_installed'
        }));
        
        walletsWithStatus.sort((a, b) => {
            if (a.isInstalled && !b.isInstalled) return -1;
            if (!a.isInstalled && b.isInstalled) return 1;
            return 0;
        });
        
        return walletsWithStatus;
        
    } catch (error) {
        console.error('Error getting available wallets:', error);
        
        const detected = await detectWallets();
        return [
            {
                type: WALLET_TYPES.METAMASK,
                name: 'MetaMask',
                icon: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT3ymr3UNKopfI0NmUY95Dr-0589vG-91KuAA&s',
                description: 'Connect using browser extension',
                isInstalled: detected[WALLET_TYPES.METAMASK],
                status: detected[WALLET_TYPES.METAMASK] ? 'installed' : 'not_installed'
            },
            {
                type: WALLET_TYPES.PHANTOM,
                name: 'Phantom',
                icon: 'https://coinlaunch.space/media/images/4/8/5/0/4850.sp3ow1.192x192.png',
                description: 'Connect using Phantom wallet',
                isInstalled: detected[WALLET_TYPES.PHANTOM],
                status: detected[WALLET_TYPES.PHANTOM] ? 'installed' : 'not_installed'
            }
        ];
    }
};

export const getWalletInstallUrl = (walletType) => {
    const urls = {
        [WALLET_TYPES.METAMASK]: 'https://metamask.io/download/',
        [WALLET_TYPES.PHANTOM]: 'https://phantom.app/download',
        [WALLET_TYPES.TRONLINK]: 'https://www.tronlink.org/download/',
        [WALLET_TYPES.TRUST_WALLET]: 'https://trustwallet.com/download/',
        [WALLET_TYPES.LUTE]: 'https://lute.app/download/'
    };
    return urls[walletType] || '';
};

export const getSupportedWalletsForNetwork = (network) => {
    return NETWORK_WALLET_MAP[network] || [];
};

export const disconnectWallet = async (walletConnection) => {
    try {
        if (walletConnection.sessionId) {
            await coinleyConnect.disconnectWallet(walletConnection.sessionId);
        }
        return true;
    } catch (error) {
        console.error('Error disconnecting wallet:', error);
        return false;
    }
};

export const getTokenConfig = (currency, network) => {
    if (!currency || !network) return null;
    
    const tokenConfig = TOKEN_CONFIG[currency.toUpperCase()];
    if (!tokenConfig) return null;
    
    return tokenConfig[network.toLowerCase()];
};

export const validateWalletAddress = (address, network) => {
    return { valid: validateAddressFormat(address, network) };
};

export const debugWalletEnvironment = () => {
    const environment = {
        hasMetaMask: typeof window.ethereum !== 'undefined',
        hasPhantom: typeof window.solana !== 'undefined',
        hasTronLink: typeof window.tronWeb !== 'undefined',
        coinleyConnectUrl: getConnectConfig().walletInterfaceUrl,
        availableWallets: Object.keys(WALLET_TYPES),
        supportedNetworks: Object.keys(NETWORK_TYPES)
    };
    
    console.log('🔍 Wallet Environment Debug:', environment);
    return environment;
};

export const generateMockTransactionHash = (network = 'ethereum') => {
    const prefixes = {
        ethereum: '0x', bsc: '0x', optimism: '0x', arbitrum: '0x', 
        polygon: '0x', avalanche: '0x', celo: '0x',
        tron: '', algorand: '', solana: ''
    };
    
    const prefix = prefixes[network] || '0x';
    const hash = Array.from({length: 64}, () => 
        Math.floor(Math.random() * 16).toString(16)).join('');
        
    return `${prefix}${hash}`;
};

// Legacy function exports for backward compatibility
export const sendTokenTransaction = async (walletConnection, tokenConfig, toAddress, amount) => {
    return sendTransaction(walletConnection, {
        to: toAddress,
        amount: amount,
        currency: tokenConfig.symbol,
        network: walletConnection.network,
        tokenAddress: tokenConfig.contractAddress || tokenConfig.address,
        tokenDecimals: tokenConfig.decimals
    });
};

export const sendERC20Transaction = sendTokenTransaction;
export const sendNativeTransaction = async (walletConnection, toAddress, amount) => {
    return sendTransaction(walletConnection, {
        to: toAddress,
        amount: amount,
        currency: 'ETH',
        network: walletConnection.network || 'ethereum'
    });
};

export const detectWalletsWithRetry = detectWallets;

// Export the client for advanced usage
export { coinleyConnect };

// Default export
export default {
    WALLET_TYPES,
    NETWORK_TYPES,
    NETWORK_CONFIG,
    TOKEN_CONFIG,
    NETWORK_WALLET_MAP,
    connectWallet,
    sendTransaction,
    detectWallets,
    getAvailableWallets,
    getWalletInstallUrl,
    getSupportedWalletsForNetwork,
    debugWalletEnvironment,
    disconnectWallet,
    getTokenConfig,
    validateWalletAddress,
    generateMockTransactionHash,
    coinleyConnect
};